(function() {
  'use strict';

  angular
    .module('acstoparent', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'toastr',
      'ui.router', 'ui.router.stateHelper', 'ngFileUpload', 'satellizer', 'angular-locker'
    ]);

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('FileDeleteConfirmController', FileDeleteConfirmController);

  FileDeleteConfirmController.$inject = ['$uibModalInstance', '$sce', 'filename'];

  /* @ngInject */
  function FileDeleteConfirmController($uibModalInstance, $sce, filename) {
    var vm = this;

    vm.title = 'File Delete';
    vm.popClass = 'lead alert-danger';
    vm.msg = $sce.trustAsHtml('<p class="lead">Do you want to delete ' + filename + ' file?</p>');

    vm.ok = function() {
      $uibModalInstance.close({
        status: true
      });
    };

    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };


  }


})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('editScholarshipController', editScholarshipController);

  editScholarshipController.$inject = ['$scope', '$log', '$state', 'DataFactory', 'ChildFactory', 'Upload', '$timeout', 'toastr', '$uibModal', 'IncomeFactory', 'FileFactory', 'ScholarshipFactory', '$sanitize', '$window', '$location', '$stateParams', 'locker', 'states', 'school', '$http', '$sce', 'displayStudentAlert', 'moment', '$filter'];

  /* @ngInject */
  function editScholarshipController($scope, $log, $state, DataFactory, ChildFactory, Upload, $timeout,
    toastr, $uibModal, IncomeFactory, FileFactory, ScholarshipFactory, $sanitize, $window, $location,
    $stateParams, locker, states, school, $http, $sce, displayStudentAlert, moment, $filter) {

    var vm = this,
      d = moment(),
      lastYear = moment().subtract(1, 'year'),
      nextYear = moment().add(1, 'year'),
      getFebSecond = moment([d.year(), 1, 2]), //get feb 2nd
      getAprilFirst = moment().month(3).date(1),
      scholarshipId = $stateParams.scholarshipId,
      fosterChildId = 0,
      options = 0,
      validateFosterIncome;

    vm.id = $stateParams.scholarshipId;

    if ($state.current.name === 'scholarship.narrative' ||
      $state.current.name === 'scholarship.taxcredit' ||
      $state.current.name === 'scholarship.review') {
      loadFileFunc();
    }

    vm.user = angular.fromJson(locker.get('user'));
    vm.schoolList = school.data.schools;
    vm.states = states.data.states;

    vm.studentList = [];
    vm.gradeList = $state.current.data.gradeList;

    vm.appAlert = false;
    vm.appAlertYear = moment().add(1, 'y').format('YYYY');

    vm.validateParent = false;
    vm.validateNarrative = false;
    vm.validateStudent = false;
    vm.validateIncome = false;
    vm.validateTax = false;
    vm.currentPath = $location.hash();
    vm.isFosterChild = false;
    vm.household = 0;
    vm.incomeLoading = true;
    vm.submit = 'Submit Application';
    vm.organization = '';
    vm.fincomes = [];
    vm.validateEsa = false;
    vm.using_esa = '';
    vm.using_esa_selection = '';
    vm.esaDropdown = [{
      label: 'Yes',
      value: 256
    },
    { label: 'No', value: 0 }];
    vm.schoolYearLabel =  $sce.trustAsHtml('I am applying for scholarships for the following school year:');
    vm.readyForSubmit = 0;

    var janFirst = moment().month(0).date(1);
    var febThird =  moment().month(1).date(3);
    var marchThirtyFirst = moment().month(2).date(31);
    var octFirst = moment().month(9).date(1);
    var lastDayOfCurrentYear =  moment().month(11).date(31);

    if (displayStudentAlert !== false) {
      vm.appAlert = displayStudentAlert;

      if (moment().isBetween(janFirst, febThird, null, '[)')) {
        vm.appAlertYear = moment().format('YYYY');
      }

      if (moment().isBetween(octFirst, lastDayOfCurrentYear, null, '[)')) {
        vm.appAlertYear = moment().add(1, 'y').format('YYYY');
      }
    }

    // select state from profile
    angular.forEach(vm.states, function(value, key) {

      if (value.value == vm.user.state) {
        vm.user.state = vm.states[key];
      }

    });

    var listChildren = ChildFactory.getChildren(),
      getScholarship = ScholarshipFactory.getScholarship(scholarshipId);

    listChildren
      .then(function(children) {

        if (children) {

          locker.put('children' + scholarshipId, angular.toJson(children.child));
          vm.studentList = children.data.child;

          // loop through collection and parse double quotes
          angular.forEach(vm.studentList, function(value, key) {
            vm.studentList[key].fname = $filter('paseQuotes')(vm.studentList[key].fname);
          });

          // load scholarship after childern are loaded
          loadScholarship();

        }

      });


    vm.addStudent = function() {

      var modalInstance = $uibModal.open({
        templateUrl: 'app/students/student.add.html',
        controller: 'AddStudentController as vm',
        resolve: { /* @ngInject */
          'school': ['DataFactory',
            function(DataFactory) {
              return DataFactory.getSchool();
            }
          ],
          'student': ['ChildFactory',
            function(ChildFactory) {
              return ChildFactory.getChildren();
            }
          ]
        }
      });

      modalInstance.result.then(function(data) {
        if (data) {

          ChildFactory.getChildrenNoCache()
            .then(function(children) {

              // $log.log('children', children);

              vm.studentList = children.data.child;

            });

          toastr.success('Child added successfully', 'Child added');

        }

      }, function() {

        // cancel
        // $target.removeClass('warning');
        // console.log('next function after the modalinstance');
        toastr.error('Can not add child', 'Failed');

      });

    };



    // school year logic
    // change every feb 3rd
    // change again after 4/15

    // http://momentjs.com/docs/
    // current year / next year, e.g., 2015/2016

    // play with the data
    // d = moment([d.year(), 1, 2]);
    //d = moment([d.year(), 1, 3]); // 2/3/2016
    // d = moment([d.year(), 3, 15]);
    // d = moment([d.year(), 3, 16]);

    // $log.log('date is: ', d);
    // $log.log('getFebSecond diff', d.diff(getFebSecond, 'days'));
    // $log.log('getAprilSeventh diff', d.diff(getAprilSeventh, 'days'));

    // if year between 1/1 and 2/2 show last year
    if (displayStudentAlert !== false) {

      if (moment().isBetween(octFirst, lastDayOfCurrentYear, null, '[)')) {
        vm.schoolYearList = [{
          label: d.format('YY') + '-' + nextYear.format('YY'),
          value: d.year() + '/' + nextYear.year()
        }];

        vm.schoolYearDrop = vm.schoolYearList[0];
        vm.schoolYear = vm.schoolYearDrop.value;
      } else {
        vm.schoolYearDrop = lastYear.format('YY') + '-' + d.format('YY');
        vm.schoolYear = lastYear.year() + '/' + d.year();

        vm.schoolYearList = [{
          label: lastYear.format('YY') + '-' + d.format('YY'),
          value: lastYear.year() + '/' + d.year()
        }];

        vm.schoolYearDrop = vm.schoolYearList[0];
        vm.schoolYear = vm.schoolYearDrop.value;
      }

    } else if (moment().isBetween(getFebSecond, getAprilFirst,  null, '()')) {
      // moment(d.format('YYYY') + '-2-3').isBetween(d.format('YYYY') + '-1-1', d.format('YYYY') + '-2-3', null, '[)')
      
      // https://ambitios.zendesk.com/agent/tickets/1551
      vm.schoolYearLabel = $sce.trustAsHtml('<strong>School year for which you are applying for scholarships.</strong> If you already submitted an application for this student for the current school year, select the upcoming school year.');

      // if year 2/3/2015 to 4/1
      // show drop down of 2 years
      vm.schoolYearList = [{
        label: d.format('YY') + '-' + nextYear.format('YY'),
        value: d.year() + '/' + nextYear.year()
      }, {
        label: lastYear.format('YY') + '-' + d.format('YY'),
        value: lastYear.year() + '/' + d.year()
      }];


      vm.schoolYearDrop = '';
      vm.schoolYear = '';

    } else {

      vm.schoolYearList = [{
        label: d.format('YY') + '-' + nextYear.format('YY'),
        value: d.year() + '/' + nextYear.year()
      }];


      vm.schoolYearDrop = vm.schoolYearList[0];
      vm.schoolYear = vm.schoolYearDrop.value;
    }

    vm.updateSchoolYear = function() {
      vm.schoolYear = vm.schoolYearDrop.value; //.label
    }

    // end school year logic

    // get scholarship based on their ID
    // get income
    // get files
    // load data

    function loadScholarship() {

      getScholarship
        .then(function(data) {

          // $log.info('getScholarship', data);

          if (data.scholarship) {
            var x = data.scholarship;


            vm.isFosterChild = x.foster_child;
            fosterChildId = x.children_id;

            // load narrative only once so it does not get overwritten
            if ($state.current.name === 'scholarship.narrative') {

              /*if (x.narrative) {
                // vm.narrative = $sce.trustAsHtml(x.narrative);
                vm.narrative = x.narrative;
              }*/

              if (locker.get('narrative' + scholarshipId)) {
                // vm.narrative = $sce.trustAsHtml(locker.get('narrative' + scholarshipId));
                vm.narrative = locker.get('narrative' + scholarshipId);
              } else {
                vm.narrative = x.narrative;
              }

            }


            if ($state.current.name === 'scholarship.income') {

              if (x.household_size) {
                vm.number_of_household = x.household_size;
              }

              if (locker.has('household' + scholarshipId)) {
                vm.number_of_household = locker.get('household' + scholarshipId);
              }


            }


            if ($state.current.name === 'scholarship.taxcredit') {

              // locker.put('public_school_transfer' + scholarshipId, false);
              // locker.put('kindergarten_student' + scholarshipId, false);
              // locker.put('kindergarten_disabled' + scholarshipId, false);
              // locker.put('us_armed_forces_dependent' + scholarshipId, false);
              // locker.put('prev_scholarship_recipient' + scholarshipId, false);

              // $log.log('I am here taxcredit');
              if (x.comment) {
                vm.comment = x.comment;
              }

              if (locker.get('comment' + scholarshipId)) {
                vm.comment = locker.get('comment' + scholarshipId);
              }

              vm.stos = [];

              DataFactory.getStos().then(function(sto) {

                vm.stos = sto.data.stos;

                // hand options after stos are loaded
                // options
                if (x.options) {

                  var mask = x.options;

                  if (mask & 1) {
                    vm.public_school_transfer = 1;
                    locker.put('public_school_transfer' + scholarshipId, true);
                  }

                  if (mask & 2) {
                    vm.kindergarten_student = 2;
                    locker.put('kindergarten_student' + scholarshipId, true);
                  }

                  if (mask & 16) {
                    vm.kindergarten_disabled = 16;
                    locker.put('kindergarten_disabled' + scholarshipId, true);
                  }

                  if (mask & 4) {
                    vm.us_armed_forces_dependent = 4;
                    locker.put('us_armed_forces_dependent' + scholarshipId, true);
                  }

                  if (mask & 8) {
                    vm.prev_scholarship_recipient = 8;
                    locker.put('prev_scholarship_recipient' + scholarshipId, true);

                    // show/load/preselect organization
                    // if (locker.get('organization' + scholarshipId)) {
                    //   vm.organization = locker.get('organization' + scholarshipId);
                    //   locker.put('organization' + scholarshipId, );
                    // }

                    if (x.organization) {

                      angular.forEach(vm.stos, function(value, key) {
                        // preselect value if matching
                        if (value.name == x.organization) {
                          vm.organization = vm.stos[key];
                        }

                      });

                    }

                  }

                  if (mask & 32) {
                    vm.home_school_transfer = 32;
                    locker.put('home_school_transfer' + scholarshipId, true);
                  }

                  if (mask & 64) {
                    vm.out_of_state_transfer = 64;
                    locker.put('out_of_state_transfer' + scholarshipId, true);
                  }

                  if (mask & 128) {
                    vm.esa_transfer = 128;
                    locker.put('esa_transfer' + scholarshipId, true);
                  }

                  if (mask & 256) {
                    vm.using_esa = 256;
                    locker.put('using_esa' + scholarshipId, true);
                  }
                }

                // load local storage
                if (locker.get('public_school_transfer' + scholarshipId)) {
                  vm.public_school_transfer = 1;
                }

                if (locker.get('kindergarten_student' + scholarshipId)) {
                  vm.kindergarten_student = 2;
                }

                if (locker.get('kindergarten_disabled' + scholarshipId)) {
                  vm.kindergarten_disabled = 16;
                }

                if (locker.get('us_armed_forces_dependent' + scholarshipId)) {
                  vm.us_armed_forces_dependent = 4;
                }

                if (locker.get('prev_scholarship_recipient' + scholarshipId)) {
                  vm.prev_scholarship_recipient = 8;

                  angular.forEach(vm.stos, function(value, key) {

                    // load local selection (not saved yet)
                    if (value.name == locker.get('organization' + scholarshipId)) {
                      vm.organization = vm.stos[key];
                    }

                  });

                }

                if (locker.get('home_school_transfer' + scholarshipId)) {
                  vm.home_school_transfer = 32;
                }

                if (locker.get('out_of_state_transfer' + scholarshipId)) {
                  vm.out_of_state_transfer = 64;
                }

                if (locker.get('esa_transfer' + scholarshipId)) {
                  vm.esa_transfer = 128;
                }

                if (locker.get('using_esa' + scholarshipId)) {
                  vm.using_esa = 256;
                }

              });

            }



            // load comment only once so it does not get overwritten
            if ($state.current.name === 'scholarship.review') {

              /*if (x.narrative) {
                vm.narrative = $sce.trustAsHtml(x.narrative);
                // vm.narrative = x.narrative;
              }*/

              if (locker.get('narrative' + scholarshipId)) {
                vm.narrative = $sce.trustAsHtml(locker.get('narrative' + scholarshipId));
              } else {
                vm.narrative = $sce.trustAsHtml(x.narrative);
              }
              if (x.household_size === 0) {
                vm.number_of_household = x.household_size;
              }

              if (locker.get('household' + scholarshipId)) {
                vm.number_of_household = locker.get('household' + scholarshipId);
              }
              if (x.comment) {
                vm.comment = x.comment;
              }

              if (locker.get('comment' + scholarshipId)) {
                vm.comment = locker.get('comment' + scholarshipId);
              }

              if (x.organization) {
                vm.organization = x.organization;
              }

              if (locker.get('organization' + scholarshipId)) {
                vm.organization = locker.get('organization' + scholarshipId);
              }


              vm.public_school_transfer = locker.get('public_school_transfer' + scholarshipId);
              vm.kindergarten_student = locker.get('kindergarten_student' + scholarshipId);
              vm.kindergarten_disabled = locker.get('kindergarten_disabled' + scholarshipId);
              vm.us_armed_forces_dependent = locker.get('us_armed_forces_dependent' + scholarshipId);
              vm.prev_scholarship_recipient = locker.get('prev_scholarship_recipient' + scholarshipId);
              vm.home_school_transfer = locker.get('home_school_transfer' + scholarshipId);
              vm.out_of_state_transfer = locker.get('out_of_state_transfer' + scholarshipId);
              vm.esa_transfer = locker.get('esa_transfer' + scholarshipId);
              vm.using_esa = locker.get('using_esa' + scholarshipId);
              resetSubmit();

            }

            angular.forEach(vm.studentList, function(value, key) {

              // $log.log('value', value);

              if (value.web_id == x.children_id) {
                vm.students = vm.studentList[key];
              }

            });

            // select school
            angular.forEach(vm.schoolList, function(value, key) {

              if (value.alt_id == x.altId) {
                vm.school = vm.schoolList[key];
              }

            });

            // select child grade
            angular.forEach(vm.gradeList, function(value, key) {

              if (value.value == x.grade) {
                vm.grade = vm.gradeList[key];
              }

            });

            vm.tuition_amt = x.tuition_amt;
            vm.schoolYear = x.appYearText; // 2016/2017
            vm.schoolYearValue = x.app_year; // 16/17

          }

          loadIncome();

        });

    }

    vm.studentInfo = function(e) {

      vm.validateParent = true;

      if (!$scope.scholarship.$valid) {

        e.preventDefault();
        toastr.error('Please check your values and try again', 'Error!');
        vm.begin = 'Begin';

      } else {

        locker.put('family' + scholarshipId, vm.user);
        locker.put('student' + scholarshipId, vm.students);
        locker.put('school' + scholarshipId, vm.school);
        locker.put('grade' + scholarshipId, vm.grade);

        $state.go('scholarship.narrative', {
          scholarshipId: scholarshipId
        });

      }

    };

    vm.saveNarrative = function(event) {

      event.preventDefault();

      vm.validateNarrative = true;

      if (!$scope.scholarship.$valid) {

        toastr.error('Please check your values and try again', 'Error!');

      } else {

        // put narrative to local session storage
        // show this in the review and use this data for submission
        if (vm.narrative) {
          // locker.put('narrative' + scholarshipId, $sanitize(vm.narrative));
          locker.put('narrative' + scholarshipId, vm.narrative);
        }

        $state.go('scholarship.income', {
          scholarshipId: scholarshipId
        });

      }


    };





    vm.income = function(event) {
      event.preventDefault();

      var $table = angular.element('table');

      vm.validateIncome = true;


      if (vm.household != vm.number_of_household || vm.household < 2 && !vm.isFosterChild) {

        // $log.log('vm.household', vm.household);
        // $log.log();
        // alert('Entries do not match the total number in household. Please include everyone in your household, including children and those away at college, even if they do not have income.');

        $uibModal.open({
          templateUrl: 'app/scholarship/edit/alert.html',
          controller: 'AlertController',
          controllerAs: 'vm',
          resolve: { /* @ngInject */
            s: function() {
              return vm.household < 2 ? (vm.isFosterChild ? 3 : 2) : 1;
            }
          }
        });

        return false;
      }

      if ($table.find('tbody td:visible').eq(1).text() === '$ ---') {
        // alert('Please enter a foster child income.');
        $uibModal.open({
          templateUrl: 'app/scholarship/edit/alert.html',
          controller: 'AlertController',
          controllerAs: 'vm',
          resolve: { /* @ngInject */
            s: function() {
              return 0;
            }
          }
        });
        return false;
      }

      if (vm.number_of_household) {
        locker.put('household' + scholarshipId, vm.number_of_household);
      }

      // e.preventDefault();
      // $log.log('click');

      // $log.log('$location', $location.hash());
      // create scholorship

      $state.go('scholarship.taxcredit', {
        scholarshipId: scholarshipId
      });

    };

    // checkboxes
    vm.pst = function() {

      if (vm.public_school_transfer) {
        locker.put('public_school_transfer' + scholarshipId, true);
      } else {
        locker.put('public_school_transfer' + scholarshipId, false);
      }

    };

    vm.ks = function() {
      if (vm.kindergarten_student) {
        locker.put('kindergarten_student' + scholarshipId, true);
      } else {
        locker.put('kindergarten_student' + scholarshipId, false);
      }
    };

    vm.kd = function() {
      if (vm.kindergarten_disabled) {
        locker.put('kindergarten_disabled' + scholarshipId, true);
      } else {
        locker.put('kindergarten_disabled' + scholarshipId, false);
      }
    };

    vm.uafd = function() {
      if (vm.us_armed_forces_dependent) {
        locker.put('us_armed_forces_dependent' + scholarshipId, true);
      } else {
        locker.put('us_armed_forces_dependent' + scholarshipId, false);
      }
    };

    vm.psr = function() {
      if (vm.prev_scholarship_recipient) {
        locker.put('prev_scholarship_recipient' + scholarshipId, true);
      } else {
        locker.put('prev_scholarship_recipient' + scholarshipId, false);
        vm.organization = '';
      }
    };

    vm.hst = function() {
      if (vm.home_school_transfer) {
        locker.put('home_school_transfer' + scholarshipId, true);
      } else {
        locker.put('home_school_transfer' + scholarshipId, false);
      }
    };

    vm.oost = function() {
      if (vm.out_of_state_transfer) {
        locker.put('out_of_state_transfer' + scholarshipId, true);
      } else {
        locker.put('out_of_state_transfer' + scholarshipId, false);
      }
    };

    vm.et = function() {
      if (vm.esa_transfer) {
        locker.put('esa_transfer' + scholarshipId, true);
      } else {
        locker.put('esa_transfer' + scholarshipId, false);
      }
    };

    vm.updateUsingESA = function() {
      if (vm.using_esa_selection.value > 0) {
        locker.put('using_esa' + scholarshipId, true);
      } else {
        locker.put('using_esa' + scholarshipId, false);
      }
    }

    vm.taxOverFlow = function(event) {
      event.preventDefault();
      vm.validateTax = true;
      vm.validateEsa = true;

      // if (vm.grade.value === 'Pre K' && vm.kindergarten_disabled) {
      //   toastr.error('This option is not available because the grade level you selected for this child was not Pre-K', 'Error!');
      //   return false;
      // }

      // if (vm.grade.value === 'Kindergarten' && vm.kindergarten_student) {
      //   toastr.error('This option is not available because the grade level you selected for this child was not Kindergarten', 'Error!');
      //   return false;
      // }

      if (!$scope.scholarship.$valid) {

        toastr.error('Please make sure all the required fields are filled', 'Error!');


      } else {

        if (vm.comment) {
          locker.put('comment' + scholarshipId, vm.comment);
        }

        if (vm.organization) {
          locker.put('organization' + scholarshipId, vm.organization.name);
        }

        $state.go('scholarship.review', {
          scholarshipId: scholarshipId
        });

      }

    };

    // vm.review = function(event) {
    //   event.preventDefault();

    //   $log.log('submit');
    //   // vm.validateTax = true;

    //   // if (vm.comment) {
    //   //   locker.put('comment', vm.comment);
    //   // }

    //   // $state.go('scholarship.review', {
    //   //   scholarshipId: scholarshipId
    //   // });
    //   resetSubmit();

    // };









    // income
    // load all income

    vm.periods = {
      1: 'Annually',
      12: 'Monthly',
      24: '2xMonth',
      26: 'EOW',
      52: 'Weekly'
    };



    function loadIncome() {

      // $log.log('loading income');

      vm.incomeLoading = true;

      if (vm.isFosterChild) {

        // getFosterIncome
        // IncomeFactory.getFosterIncome(fosterChildId)
        $http.get('/api/income/foster/' + fosterChildId, {
          cache: false
        })
          .then(function(response) {

            if (response.data.fosterIncome) {

              vm.fincomes = response.data.fosterIncome;
              vm.household = response.data.fosterIncome.length;
              validateFosterIncome = response.data.fosterIncome.other;
              // $log.log('response.data.fosterIncome.other', response.data.fosterIncome.other);

            }

            // hide loading
            vm.incomeLoading = false;

          });

      } else {

        IncomeFactory.getIncomes()
          .then(function(data) {

            if (data.incomes) {

              vm.fincomes = data.incomes;
              vm.household = data.incomes.length;

            }

            // hide loading
            vm.incomeLoading = false;

          });

      }



    }




    vm.addIncome = function() {

      var modalInstance = $uibModal.open({
        templateUrl: 'app/scholarship/income/income.add.html',
        controller: 'AddIncomeController',
        controllerAs: 'vm',
        resolve: {
          ID: function() {
            return '';
          }
        }
      });

      modalInstance.result.then(function(response) {

        // if (vm.household) {

        //   vm.fincomes.push(response.data.income);

        // } else {

        //   // cannot push
        //   loadIncome();

        // }

        // loadIncome();

        vm.fincomes.push(response.income);

        vm.household = (vm.household + 1);

        // info

      }, function() {

        // cancel
        // $target.removeClass('warning');
        // $log.log('next function after the modalinstance');

      });
    };

    vm.editTableRow = function(income, event) {

      var $target = angular.element(event.target).parent().parent();
      var editIncomeIndex = vm.fincomes.indexOf(income);

      // fix to ensure table row is selected
      if (event.target.nodeName === 'I') {
        $target = $target.parent();
      }

      $target.addClass('info');

      var modalInstance = $uibModal.open({
        templateUrl: 'app/scholarship/income/income.add.html',
        controller: 'AddIncomeController',
        controllerAs: 'vm',
        resolve: {
          ID: function() {
            return income.id;
          }
        }
      });

      modalInstance.result.then(function(response) {

        // $log.log('response.income', response.income);
        vm.fincomes[editIncomeIndex] = response.income;

      }, function() {

        $target.removeClass('info');

      });

    };

    vm.editFosterChild = function(income, event) {

      var $target = angular.element(event.target).parent().parent();
      // var editIncomeIndex = vm.fincomes.indexOf(income);

      // fix to ensure table row is selected
      if (event.target.nodeName === 'I') {
        $target = $target.parent();
      }

      $target.addClass('info');

      var modalInstance = $uibModal.open({
        templateUrl: 'app/scholarship/income/foster.child.income.html',
        controller: 'FosterChildIncomeController',
        controllerAs: 'vm',
        resolve: {
          ID: function() {
            return income.id;
          }
        }
      });

      modalInstance.result.then(function(response) {

        // $log.log('response', response);
        // $log.log('[response.income]', [response.income]);
        vm.fincomes = [response.income];

      }, function() {

        $target.removeClass('info');

      });

    };


    vm.deleteTableRow = function(income, event) {

      var $target = angular.element(event.target).parent().parent();

      // fix to ensure table row is selected
      if (event.target.nodeName === 'I') {
        $target = $target.parent();
      }

      $target.addClass('danger');

      var modalInstance = $uibModal.open({
        templateUrl: 'app/confirm.html',
        controller: 'IncomeConfirmController',
        controllerAs: 'vm',
        resolve: { /* @ngInject */
          incomename: function() {
            return income.name;
          }
        }
      });


      modalInstance.result.then(function(response) {

        if (response.status) {

          IncomeFactory.deleteIncome(income.id)
            .then(function(data) {

              if (data) {
                vm.household = (vm.household - 1);
                vm.fincomes.splice(vm.fincomes.indexOf(income), 1);
                toastr.success('Income deleted successfully', 'Success');
              }

            }, function() {

              toastr.error('There were issues adding the Parent information', 'Failed to Update');

            });

        }

        $target.removeClass('danger');

      }, function() {

        // if cancelled
        $target.removeClass('danger');

      });


    };


    /*end income*/









    /**
     *
     * file upload
     *
     **/

    function loadFileFunc() {



      // vm.log = '';
      vm.dynamic = 0;
      vm.type = 'warning';
      vm.showComplete = 0;


      function getFilesList() {
        FileFactory.getFiles(scholarshipId).then(function(data) {
          // $log.log('file data', data);
          vm.uploadedFiles = data.files;
        });
      }

      getFilesList();

      $scope.$watch('files', function() {
        vm.upload($scope.files);
      });

      // $scope.$watch('files', function() {
      //   $scope.upload($scope.files);
      // });

      vm.upload = function(files) {

        var studentData = {
          'student': '',
          'studentID': '',
          'fname': '',
          'lname': '',
          'scholarshipId': ''
        };

        if (files && files.length) {

          vm.showComplete = 0;

          if (vm.students) {
            studentData = {
              // 'student': vm.students,
              'studentID': vm.students.web_id,
              'fname': vm.students.fname,
              'lname': vm.students.lname,
              'scholarshipId': scholarshipId
            };
          } else {

            toastr.error('A student must be selected before a file can be uploaded', 'Error');
            return false;

          }

          for (var i = 0; i < files.length; i++) {
            var file = files[i];

            var fileInfo = {

              url: 'api/upload',
              fields: studentData,
              file: file

            };

            // FileFactory.postFile(fileInfo).then();

            Upload.upload(fileInfo).progress(function(evt) {

              var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);

              vm.dynamic = progressPercentage;
              vm.type = 'info';
              // vm.log = 'progress: ' + progressPercentage + '% ' +
              //             evt.config.file.name + '\n' + vm.log;
            }).success(function(data) {

              vm.dynamic = '100';
              vm.type = 'success';
              vm.showComplete = 1;

              vm.uploadedFiles = data.files;

              // $timeout(function() {
              //     vm.log = 'file: ' + config.file.name + ', Response: ' + JSON.stringify(data) + '\n' + vm.log;
              // });

              toastr.success('File uploaded successfully!', 'Success');

            }).error(function() {
              vm.dynamic = '0';
              file.state = 'Error';
              // $log.log('file: ' + data.file.name + ' failed. Response: ' + angular.toJson(data));
              toastr.error('Error uploading!!!', 'Error');
            });
          }
        }
      };

      vm.deletFile = function(event, file) {

        var $target = angular.element(event.target).parent();

        if (event.target.nodeName === 'SPAN') {
          $target = $target.parent();
        }

        var modalInstance = $uibModal.open({
          templateUrl: 'app/confirm.html',
          controller: 'FileDeleteConfirmController',
          controllerAs: 'vm',
          resolve: { /* @ngInject */
            filename: function() {
              return file.original_filename;
            }
          }
        });


        modalInstance.result.then(function(response) {

          if (response.status) {

            FileFactory.deleteFile(file.id).then(function(data) {

              if (data) {

                toastr.success('File deleted', 'Success');
                $target.remove();
                getFilesList();

              }

            }, function() {

              toastr.error('There was an issue deleting the file please try again later', 'Failed to Delete File');

            });

          }

        });


      };
    }
    // end file upload





    function clearSession() {
      locker.forget('narrative' + scholarshipId);
      locker.forget('household' + scholarshipId);
      locker.forget('comment' + scholarshipId);
      locker.put('public_school_transfer' + scholarshipId, false);
      locker.put('kindergarten_student' + scholarshipId, false);
      locker.put('kindergarten_disabled' + scholarshipId, false);
      locker.put('us_armed_forces_dependent' + scholarshipId, false);
      locker.put('prev_scholarship_recipient' + scholarshipId, false);
      locker.put('home_school_transfer' + scholarshipId, false);
      locker.put('out_of_state_transfer' + scholarshipId, false);
      locker.put('esa_transfer' + scholarshipId, false);
      locker.put('using_esa' + scholarshipId, false);
    }



    function resetButtons() {

      vm.save = 'Save Now &amp; Finish Later';
      // vm.begin = 'Next: Narrative <i class="fa fa-chevron-right"></i>';

    }

    function getOptions(options) {

      options = 0;

      if (locker.get('public_school_transfer' + scholarshipId)) {
        options += 1;
      }
      if (locker.get('kindergarten_student' + scholarshipId)) {
        options += 2;
      }
      if (locker.get('us_armed_forces_dependent' + scholarshipId)) {
        options += 4;
      }
      if (locker.get('prev_scholarship_recipient' + scholarshipId)) {
        options += 8;
      }
      if (locker.get('kindergarten_disabled' + scholarshipId)) {
        options += 16;
      }
      if (locker.get('home_school_transfer' + scholarshipId)) {
        options += 32;
      }
      if (locker.get('out_of_state_transfer' + scholarshipId)) {
        options += 64;
      }
      if (locker.get('esa_transfer' + scholarshipId)) {
        options += 128;
      }
      if (locker.get('using_esa' + scholarshipId)) {
        options += 256;
      }
      return options;

    }

    resetButtons();

    vm.saveScholarship = function(event) {


      vm.validateParent = true;

      if (!$scope.scholarship.$valid) {

        event.preventDefault();
        toastr.error('Please check your values and try again', 'Error');

      } else {

        vm.save = 'Saving scholarship application...';

        var family = locker.get('family' + scholarshipId);
        var student = locker.get('student' + scholarshipId);


        if (!family) {
          family = vm.user;
        }

        if (!student) {
          student = vm.students;
        }

        var schoolSession = (locker.get('school' + scholarshipId)) ? locker.get('school' + scholarshipId) : vm.school,
          gradeSession = (locker.get('grade' + scholarshipId)) ? locker.get('grade' + scholarshipId) : vm.grade,
          organizationSession = (locker.get('organization' + scholarshipId)) ? locker.get('organization' + scholarshipId) : vm.organization.name,
          houseSession = (locker.get('household' + scholarshipId)) ? locker.get('household' + scholarshipId) : vm.household,
          narrativeSession = (locker.get('narrative' + scholarshipId)) ? locker.get('narrative' + scholarshipId) : vm.narrative,
          commentSession = (locker.get('comment' + scholarshipId)) ? locker.get('comment' + scholarshipId) : vm.comment;

        options = getOptions();

        var scholarshipData = {
          scholarshipId: scholarshipId,
          parent_first_name: family.parent_first_name,
          parent_middle_initial: family.parent_middle_initial,
          parent_last_name: family.parent_last_name,
          parent_phone: family.parent_phone,
          spouse_first_name: family.spouse_first_name,
          spouse_middle_initial: family.spouse_middle_initial,
          spouse_last_name: family.spouse_last_name,
          address: family.address,
          address2: family.address2,
          city: family.city,
          state: family.state.value,
          zip: family.zip,
          student_web_id: student.web_id,
          student_name: student.fname + ' ' + student.mname + ' ' + student.lname,
          school_id: schoolSession.school_id,
          alt_id: schoolSession.alt_id,
          school_name: schoolSession.school_name,
          grade: gradeSession.value,
          organization: $sanitize(organizationSession),
          options: options,
          household_size: houseSession,
          narrative: $sanitize(narrativeSession),
          comment: $sanitize(commentSession)
        };

        // $log.log('data to submit', scholarshipData);
        ScholarshipFactory.updateScholarship(scholarshipId, scholarshipData)
          .then(function() {
            // $log.log(response);
            toastr.success('Application saved!', 'Success');

            clearSession();
            resetButtons();

            $state.go('scholarship.dashboard');

          }, function() {

            toastr.error('Apologies, there was an issue saving your application.', 'Error');

          });


      }



    };

    function resetSubmit() {
      vm.submit = 'Submit Application';
    }

    vm.submitScholarship = function() {
      // $log.log('submiting...');
      vm.submit = 'Submitting scholarship application...';

      var family = locker.get('family' + scholarshipId);
      var student = locker.get('student' + scholarshipId);

      if (!family) {
        family = vm.user;
      }

      if (!student) {
        student = vm.students;
      }

      var schoolSession = (locker.get('school' + scholarshipId)) ? locker.get('school' + scholarshipId) : vm.school,
        gradeSession = (locker.get('grade' + scholarshipId)) ? locker.get('grade' + scholarshipId) : vm.grade,
        organizationSession = (locker.get('organization' + scholarshipId)) ? locker.get('organization' + scholarshipId) : vm.organization.name,
        houseSession = (locker.get('household' + scholarshipId)) ? locker.get('household' + scholarshipId) : vm.household,
        narrativeSession = (locker.get('narrative' + scholarshipId)) ? locker.get('narrative' + scholarshipId) : vm.narrative,
        commentSession = (locker.get('comment' + scholarshipId)) ? locker.get('comment' + scholarshipId) : vm.comment;

      options = getOptions();

      var scholarshipData = {
        scholarshipId: scholarshipId,
        parent_first_name: family.parent_first_name,
        parent_middle_initial: family.parent_middle_initial,
        parent_last_name: family.parent_last_name,
        parent_phone: family.parent_phone,
        spouse_first_name: family.spouse_first_name,
        spouse_middle_initial: family.spouse_middle_initial,
        spouse_last_name: family.spouse_last_name,
        address: family.address,
        address2: family.address2,
        city: family.city,
        state: family.state.value,
        zip: family.zip,
        student_web_id: student.web_id,
        student_name: student.fname + ' ' + student.mname + ' ' + student.lname,
        school_id: schoolSession.school_id,
        alt_id: schoolSession.alt_id,
        school_name: schoolSession.school_name,
        grade: gradeSession.label,
        organization: $sanitize(organizationSession),
        options: options,
        household_size: houseSession,
        tuition_amt: vm.tuition_amt,
        app_year: vm.schoolYearValue,
        narrative: $sanitize(narrativeSession),
        comment: $sanitize(commentSession)
      };

      ScholarshipFactory.completeScholarship(scholarshipData)
        .then(function() {
          // $log.log(data);
          toastr.success('Application submitted!', 'Success');

          clearSession();
          resetSubmit();

          $state.go('scholarship.dashboard');

        }, function() {

          resetSubmit();

          $state.go('scholarship.apply', {
            scholarshipId: scholarshipId
          });

          toastr.error('Could not submit application please double check your entires and try again', 'Error');

        });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('AlertController', AlertController);

  AlertController.$inject = ['$uibModalInstance', '$sce', 's'];

  /* @ngInject */
  function AlertController($uibModalInstance, $sce, s) {
    var vm = this;

    vm.title = 'Number of People Living in Household';
    vm.popClass = 'alert-warning';

    if (s === 1) {
      vm.msg = $sce.trustAsHtml('<p class="lead">Entries do not match the total number in household. Please include everyone in your household, including children and those away at college, even if they do not have income.</p>');
    } else if (s === 2) {
      vm.msg = $sce.trustAsHtml('<p class="lead">The total number in household must be at least 2 or greater.</p>');
    } else if (s === 3) {
      vm.msg = $sce.trustAsHtml('<p class="lead">The total number in household must be at least 1 or greater.</p>');
    } else {
      vm.msg = $sce.trustAsHtml('<p class="lead">Please enter a foster child income.</p>');
    }

    vm.ok = function() {
      $uibModalInstance.dismiss('cancel');
    };

  }


})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('AddIncomeController', AddIncomeController);

  AddIncomeController.$inject = ['$scope', '$state', '$uibModal', '$filter', 'toastr', 'DataFactory', '$sanitize', '$uibModalInstance', 'IncomeFactory', 'ID', 'locker'];

  /* @ngInject */
  function AddIncomeController($scope, $state, $uibModal, $filter, toastr, DataFactory, $sanitize, $uibModalInstance, IncomeFactory, ID, locker) {
    var vm = this;
    vm.user = angular.fromJson(locker.get('user'));
    vm.validateIncome = false;
    vm.noIncome = false;
    vm.incomeBtn = '<i class="fa fa-plus"></i>Add Income';

    // edit income
    // load income
    if (ID) {

      vm.incomeBtn = '<i class="fa fa-plus"></i>Update Income';
      // var periodIndex = {
      //   1: 0,
      //   12: 1,
      //   24: 2,
      //   26: 3,
      //   52: 4
      // };

      IncomeFactory.getIncome(ID).then(function(data) {

        // load data into model

        vm.income_name = data.income.name;

        vm.work = data.income.work;
        if (data.income.work_frequency) {
          // vm.work_period = vm.periods[periodIndex[data.income.work_frequency]];
          vm.work = data.income.work * data.income.work_frequency;
        }


        vm.support = data.income.support;
        if (data.income.support_frequency) {
          // vm.support_period = vm.periods[periodIndex[data.income.support_frequency]];
          vm.support = data.income.support * data.income.support_frequency;
        }


        vm.retirement = data.income.retirement;
        if (data.income.retirement_frequency) {
          // vm.retirement_period = vm.periods[periodIndex[data.income.retirement_frequency]];
          vm.retirement = data.income.retirement * data.income.retirement_frequency;
        }

        vm.other = data.income.other;
        if (data.income.other_frequency) {
          // vm.other_period = vm.periods[periodIndex[data.income.other_frequency]];
          vm.other = data.income.other * data.income.other_frequency;
        }

      });

    }


    vm.saveIncomeInfo = function ($event) {

      $event.preventDefault();
      vm.validateIncome = true;

      if ($scope.income.$invalid) {

        toastr.error('Please include a name and income type. If there is no income, click the No Income checkbox.', 'Failed to Add Income');
        return false;

      }

      function resetButtons() {

        var btn = (ID) ? 'Update Income' : 'Add Income';
        vm.incomeBtn = '<i class="fa fa-plus"></i>' + btn;

      }

      resetButtons();

      vm.incomeBtn = '<i class="fa fa-refresh fa-spin"></i>Saving...';


      toastr.info('Please wait this may take a few moments', 'Saving data...', 0);

      var info = {
        name: $sanitize(vm.income_name),
        work: $sanitize(vm.work),
        work_frequency: (vm.work) ? '1' : '',
        support: $sanitize(vm.support),
        support_frequency: (vm.support) ? '1' : '',
        retirement: $sanitize(vm.retirement),
        retirement_frequency: (vm.retirement) ? '1' : '',
        other: $sanitize(vm.other),
        other_frequency: (vm.other) ? '1' : ''
      };

      if (ID) {

        // update
        IncomeFactory.updateIncome(ID, info)
          .then(function(response) {

            toastr.clear();

            if (response) {
              toastr.success('Income successfully updated!', 'Success');
              resetButtons();

              // add newly created object ID
              // info.id = info.id;

              $uibModalInstance.close(response);
            }

          }, function(error) {

            if (error) {
              toastr.error('There were issues', 'Failed to Edit Income');
              resetButtons();
              $uibModalInstance.close();
            }

          });

        return false;

      }

      IncomeFactory.addIncome(info).then(function(response) {

        toastr.clear();

        // api returns 200 when error
        // 

        if (response) {

          toastr.success('Income successfully added!', 'Success');
          resetButtons();

          // add newly created object ID
          // info.id = data.id;

          $uibModalInstance.close(response);
        }

      }, function(error) {

        if (error) {

          toastr.error('There were issues adding a income', 'Failed to Add Income');
          resetButtons();
          $uibModalInstance.close();
        }

      });

    };

    vm.cancel = cancel;
    vm.resetEarnings = resetEarnings;


    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }


    function resetEarnings() {
      if (vm.noIncome) {
        vm.work = 0;
        vm.support = 0;
        vm.retirement = 0;
        vm.other = 0;
      }
    }

  }
})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('FosterChildIncomeController', FosterChildIncomeController);

  FosterChildIncomeController.$inject = ['$scope', '$state', '$uibModal', '$filter', 'toastr', 'DataFactory', '$sanitize', '$uibModalInstance', 'IncomeFactory', 'ID', 'locker'];

  /* @ngInject */
  function FosterChildIncomeController($scope, $state, $uibModal, $filter, toastr, DataFactory, $sanitize, $uibModalInstance, IncomeFactory, ID, locker) {
    var vm = this;
    vm.user = angular.fromJson(locker.get('user'));
    vm.validateIncome = false;
    vm.noIncome = false;
    vm.incomeBtn = '<i class="fa fa-plus"></i>Add Income';

    vm.periods = [{
      label: '12',
      value: 'Monthly'
    }];

    vm.other_period = '';


    // edit income
    // load income
    if (ID) {

      vm.incomeBtn = '<i class="fa fa-plus"></i>Update Income';

      IncomeFactory.getIncome(ID).then(function(data) {

        // load data into model

        vm.income_name = data.income.name;
        vm.other = data.income.other;
        vm.other_period = vm.periods[0];

      });

    }


    vm.saveIncomeInfo = function($event) {

      $event.preventDefault();
      vm.validateIncome = true;

      if ($scope.income.$invalid) {

        toastr.error('Please include a name and income type. If there is no income, click the No Income checkbox.', 'Failed to Add Income');
        return false;

      }

      function resetButtons() {

        var btn = (ID) ? 'Update Income' : 'Add Income';
        vm.incomeBtn = '<i class="fa fa-plus"></i>' + btn;

      }

      resetButtons();

      vm.incomeBtn = '<i class="fa fa-refresh fa-spin"></i>Saving...';


      toastr.info('Please wait this may take a few moments', 'Saving data...', 0);

      // vm.noIncome
      var fosterChildIncome;

      fosterChildIncome = $sanitize(vm.other);

      if (vm.noIncome) {
        fosterChildIncome = 0;
      }

      var info = {
        name: $sanitize(vm.income_name),
        other: fosterChildIncome,
        other_frequency: (vm.other_period.label) ? vm.other_period.label : ''
      };

      if (ID) {

        // update
        IncomeFactory.updateIncome(ID, info)
          .then(function(response) {

            toastr.clear([toastr]);

            if (response) {

              toastr.success('Income successfully updated!', 'Success');
              resetButtons();

              // add newly created object ID
              // info.id = info.id;

              $uibModalInstance.close(response);
            }

          }, function(error) {

            toastr.clear([toastr]);

            if (error) {

              toastr.error('There were issues', 'Failed to Edit Income');
              resetButtons();
              $uibModalInstance.close();
            }

          });

        return false;

      }

    };

    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };


  }
})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('IncomeConfirmController', IncomeConfirmController);

  IncomeConfirmController.$inject = ['$uibModalInstance', '$sce', 'incomename'];

  /* @ngInject */
  function IncomeConfirmController($uibModalInstance, $sce, incomename) {
    var vm = this;

    vm.title = 'Delete Income';
    vm.popClass = 'lead alert-danger';
    vm.msg = $sce.trustAsHtml('<p class="lead">Are you sure you want to delete income for ' + incomename + '?</p>');

    vm.ok = function() {
      $uibModalInstance.close({
        status: true
      });
    };

    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };


  }


})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('AddScholarshipController', AddScholarshipController);

  AddScholarshipController.$inject = [
    '$scope',
    '$location',
    '$state',
    'ChildFactory',
    'toastr',
    '$uibModal',
    'ScholarshipFactory',
    '$sanitize',
    'moment',
    '$window',
    'locker',
    'school',
    'states',
    'displayStudentAlert',
    '$filter',
    '$sce'
  ];

  /* @ngInject */
  function AddScholarshipController(
    $scope, $location, $state, ChildFactory, toastr, $uibModal, ScholarshipFactory, $sanitize, moment, $window,
    locker, school, states, displayStudentAlert, $filter, $sce) {

    var vm = this,
      d = moment(),
      lastYear = moment().subtract(1, 'year'),
      nextYear = moment().add(1, 'year'),
      getFebSecond = moment().month(1).date(2), //get feb 2nd
      getAprilSeventh = moment().month(3).date(7), // get april 7th
      getAprilFirst = moment().month(3).date(1);



    // $log.log('student', student);
    // $log.log('school', school);
    // $log.log('states', states);
    // $log.log('profile', locker.get('user'));

    vm.user = angular.fromJson(locker.get('user'));
    vm.schoolList = school.data.schools;
    vm.states = states.data.states;

    vm.studentList = [];
    vm.gradeList = $state.current.data.gradeList;

    vm.appAlert = false;
    vm.appAlertYear = moment().add(1, 'y').format('YYYY');

    vm.validateParent = false;
    vm.validateStudent = false;
    vm.validateIncome = false;
    vm.validateTax = false;
    vm.schoolYearList = '';
    vm.currentPath = $location.hash();
    vm.schoolYearLabel =  $sce.trustAsHtml('I am applying for scholarships for the following school year:');


    var janFirst = moment().month(0).date(1);
    var febThird =  moment().month(1).date(3);
    var marchThirtyFirst = moment().month(2).date(31);
    var octFirst = moment().month(9).date(1);
    var lastDayOfCurrentYear =  moment().month(11).date(31);

    if (displayStudentAlert !== false) {
      vm.appAlert = displayStudentAlert;
      if (moment().isBetween(janFirst, febThird, null, '[)')) {
        vm.appAlertYear = moment().format('YYYY');
      }

      if (moment().isBetween(octFirst, lastDayOfCurrentYear, null, '[)')) {
        vm.appAlertYear = moment().add(1, 'y').format('YYYY');
      }
    }

    // select state from profile
    angular.forEach(vm.states, function(value, key) {

      if (value.value == vm.user.state) {
        vm.user.state = vm.states[key];
      }

    });




    // school year logic
    // change every feb 3rd
    // change again after 4/15 --ignore now
    // change again after 4/3

    // http://momentjs.com/docs/
    // current year / next year, e.g., 2015/2016

    // play with the data
    // d = moment([d.year(), 1, 2]);
    //d = moment([d.year(), 1, 3]); // 2/3/2016
    // d = moment([d.year(), 3, 15]);
    // d = moment([d.year(), 3, 16]);

    // $log.log('date is: ', d);
    // $log.log('getFebSecond diff', d.diff(getFebSecond, 'days'));
    // $log.log('getAprilSeventh diff', d.diff(getAprilSeventh, 'days'));

    // Jan 1st - Feb 3rd --- 1st and 3rd
    // Feb 3rd - April 7th - on 3rd and 4/6
    // 4/7 remove 2 year

    // if year between 1/1 and 2/2 show last year
    if (displayStudentAlert !== false) {

      if (moment().isBetween(octFirst, lastDayOfCurrentYear, null, '[)')) {
        vm.schoolYearList = [{
          label: d.format('YY') + '-' + nextYear.format('YY'),
          value: d.year() + '/' + nextYear.year()
        }];

        vm.schoolYearDrop = vm.schoolYearList[0];
        vm.schoolYear = vm.schoolYearDrop.value;
      } else {

        vm.schoolYearDrop = lastYear.format('YY') + '-' + d.format('YY');
        vm.schoolYear = lastYear.year() + '/' + d.year();

        vm.schoolYearList = [{
          label: lastYear.format('YY') + '-' + d.format('YY'),
          value: lastYear.year() + '/' + d.year()
        }];

        vm.schoolYearDrop = vm.schoolYearList[0];
        vm.schoolYear = vm.schoolYearDrop.value;
      }

    } else if (moment().isBetween(getFebSecond, getAprilFirst,  null, '()')) {
      // https://ambitios.zendesk.com/agent/tickets/1551

      vm.schoolYearLabel = $sce.trustAsHtml('<strong>School year for which you are applying for scholarships.</strong> If you already submitted an application for this student for the current school year, select the upcoming school year.');

      // if year 2/3/2015 to 4/15/2015
      // show drop down of 2 years
      vm.schoolYearList = [{
        label: d.format('YY') + '-' + nextYear.format('YY'),
        value: d.year() + '/' + nextYear.year()
      }, {
        label: lastYear.format('YY') + '-' + d.format('YY'),
        value: lastYear.year() + '/' + d.year()
      }];

      vm.schoolYearDrop = '';
      vm.schoolYear = '';

    } else {

      vm.schoolYearList = [{
        label: d.format('YY') + '-' + nextYear.format('YY'),
        value: d.year() + '/' + nextYear.year()
      }];

      vm.schoolYearDrop = vm.schoolYearList[0];
      vm.schoolYear = vm.schoolYearDrop.value;
    }
    
    // remove
    // vm.schoolYearList = [{
    //   label: d.format('YY') + '-' + nextYear.format('YY'),
    //   value: d.year() + '/' + nextYear.year()
    // }, {
    //   label: lastYear.format('YY') + '-' + d.format('YY'),
    //   value: lastYear.year() + '/' + d.year()
    // }];
    // vm.schoolYearDrop = vm.schoolYearList[0];
    // vm.schoolYear = vm.schoolYearDrop.value;
    // end remove

    vm.updateSchoolYear = function() {
      vm.schoolYear = vm.schoolYearDrop.value; //.label
    }

    vm.handleGradeChange = function() {
      if (vm.grade && vm.grade.value === 'Kindergarten') {
        alert('ADOR regulations state that a Kindergartener must turn 5 years old on or before December 31 of their Kindergarten year to be considered for tax credit scholarships.');
      }
    }

    // end school year logic



    ChildFactory.getChildren()
      .then(function(children) {

        if (children) {

          locker.put('children', angular.toJson(children.child));
          vm.studentList = children.data.child;

          // loop through collection and parse double quotes
          angular.forEach(vm.studentList, function(value, key) {
            vm.studentList[key].fname = $filter('paseQuotes')(vm.studentList[key].fname);
          });

        }

      });


    vm.addStudent = function() {

      var modalInstance = $uibModal.open({
        templateUrl: 'app/students/student.add.html',
        controller: 'AddStudentController as vm',
        resolve: { /* @ngInject */
          'school': ['DataFactory',
            function(DataFactory) {
              return DataFactory.getSchool();
            }
          ],
          'student': ['ChildFactory',
            function(ChildFactory) {
              return ChildFactory.getChildren();
            }
          ]
        }
      });

      modalInstance.result.then(function(data) {
        if (data) {

          ChildFactory.getChildrenNoCache()
            .then(function(children) {

              // $log.log('children', children);

              vm.studentList = children.data.child;

            });

          toastr.success('Child added successfully', 'Child added');

        }

      }, function(response) {

        // cancel

        if (response !== 'cancel') {

          toastr.error('Can not add child', 'Failed');

        }

      });

    };


    function resetButtons() {

      vm.save = 'Save Now &amp; Finish Later';
      vm.begin = 'Next: Narrative <i class="fa fa-chevron-right"></i>';

    }

    resetButtons();

    // preselect school when a child is selected
    vm.loadChildSchool = function(child) {

      angular.forEach(vm.schoolList, function(value, key) {
        if (value.alt_id == child.school_alt_id) {
          vm.school = vm.schoolList[key];
        }
      });

    }

    function saveScholarship() {
      // $log.log('vm', vm);

      var req = {
        address: vm.user.address,
        address2: vm.user.address2,
        city: vm.user.city,
        email: vm.user.email,
        parent_first_name: vm.user.parent_first_name,
        parent_last_name: vm.user.parent_last_name,
        parent_middle_initial: vm.user.parent_middle_initial,
        parent_phone: vm.user.parent_phone,
        spouse_first_name: vm.user.spouse_first_name,
        spouse_last_name: vm.user.spouse_last_name,
        spouse_middle_initial: vm.user.spouse_middle_initial,
        state: vm.user.state.value,
        zip: vm.user.zip,
        student_web_id: vm.students.web_id,
        student_name: vm.students.fname,
        school_id: vm.school.school_id,
        alt_id: vm.school.alt_id,
        school_name: vm.school.school_name,
        tuition_amt: vm.tuition_amt,
        app_year: vm.schoolYearDrop.label, // 2016/2017
        appYearText: vm.schoolYearDrop.value, // 16/17
        grade: vm.grade.value
      };

      return ScholarshipFactory.saveScholarship(req);
    }

    vm.startScholarship = function(e) {

      vm.validateParent = true;

      // A child is considered too young for scholarship if they are not 5 years old by January 1st
      // of their Kindergarten year (eg. For the 19-20 school year, this would be 1/1/2020), _and_ do not have an IEP written from the public school district.

      if (vm.schoolYearDrop && vm.students) {
        var getChildStartingYear = vm.schoolYearDrop.value.split('/')[1];
        var studentDOB = new Date(vm.students.dob_month + '/' + vm.students.dob_day + '/' + vm.students.dob_year);
        var startSchoolYearDate = new Date('1/1/' + getChildStartingYear);
        var isStudentFiveYearsOldByJanFirst = moment(startSchoolYearDate).diff(studentDOB, 'years', false);

        if (isStudentFiveYearsOldByJanFirst < 5) {
          $uibModal.open({
            templateUrl: 'app/scholarship/modal.html',
            controller: 'ScholarshipModalController as vm'
          });
        }
      }

      if (!$scope.scholarship.$valid) {

        e.preventDefault();
        toastr.error('Please check your values and try again', 'Error');

      } else {

        vm.begin = 'Creating scholarship application...';

        saveScholarship()
          .then(function(response) {

            // $log.log(response);

            toastr.success('Scholarship Application Started', 'Success!');

            // go next step Narrative
            $state.go('scholarship.narrative', {
              scholarshipId: response.scholarship.id
            });

            resetButtons();

          }, function() {

            // $log.log('no good', response);
            toastr.error('Scholarship error', 'Error!');
            resetButtons();

          });

      }

    };

    vm.saveScholarship = function(e) {

      vm.validateParent = true;

      if (vm.schoolYearDrop && vm.students) {
        var getChildStartingYear = vm.schoolYearDrop.value.split('/')[1];
        var studentDOB = new Date(vm.students.dob_month + '/' + vm.students.dob_day + '/' + vm.students.dob_year);
        var startSchoolYearDate = new Date('1/1/' + getChildStartingYear);
        var isStudentFiveYearsOldByJanFirst = moment(startSchoolYearDate).diff(studentDOB, 'years', false);

        if (isStudentFiveYearsOldByJanFirst < 5) {
          $uibModal.open({
            templateUrl: 'app/scholarship/modal.html',
            controller: 'ScholarshipModalController as vm'
          });
        }
      }

      if (!$scope.scholarship.$valid) {

        e.preventDefault();
        toastr.error('Please check your values and try again', 'Error');

      } else {

        vm.save = 'Saving scholarship application...';

        saveScholarship()
          .then(function() {

            // $log.log(response);

            toastr.success('You can return to the application from Scholarships & Applications Dashboard in the "Saved Applications (in progress) tab', 'A scholarship has been saved for you');

            // go next step home
            $state.go('scholarship.dashboard');
            resetButtons();

          }, function() {

            // $log.log('no good', response);
            toastr.error('Scholarship error', 'Error!');
            resetButtons();

          });


      }


    }



  }
})();

(function () {
  'use strict';

  angular
      .module('acstoparent')
      .controller('SpanishModal', SpanishModal);

  SpanishModal.$inject = ['$uibModalInstance'];

  /* @ngInject */
  function SpanishModal($uibModalInstance) {
      var vm = this;

      vm.ok = function () {
          $uibModalInstance.dismiss('cancel');
      };

  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .directive('acstoFooter', acstoFooter);

  /** @ngInject */
  function acstoFooter() {

    var directive = {
      bindToController: true,
      restrict: 'E',
      templateUrl: 'app/components/footer/footer.html'
    };

    return directive;

  }



})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .directive('acstoNavbar', acstoNavbar);

  /** @ngInject */
  function acstoNavbar() {

    var directive = {
      bindToController: true,
      controller: NavbarController,
      controllerAs: 'vm',
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html'
    };

    return directive;

  }

  NavbarController.$inject = ['$auth', '$state', '$scope', '$rootScope', 'locker'];

  /** @ngInject */
  function NavbarController($auth, $state, $scope, $rootScope, locker) {
    var vm = this;
    // var timer;

    vm.loggedin = false;
    vm.avatar = false;
    vm.user = '';

    // $rootScope.currentUser
    $scope.$watch($rootScope.currentUser, function(newVal) {

      if (newVal) {

        // $log.log('yes', newVal);
        vm.user = angular.fromJson(newVal);
        vm.loggedin = true;

      }

    });



    vm.logout = function() {

      $auth.logout().then(function() {

        // Remove the authenticated user from local storage
        // localStorage.removeItem('user');
        locker.empty();

        // Flip authenticated to false so that we no longer
        // show UI elements dependant on the user being logged in
        $rootScope.authenticated = false;
        vm.loggedin = false;

        // Remove the current user info from rootscope
        $rootScope.currentUser = null;

        $state.go('login');
      });

    };



  }
})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .directive('customLinkInputs', customLinkInputs);

  /** @ngInject */
  function customLinkInputs() {
    var directive = {
      restrict: 'A',
      scope: {
        url: '=generatedUrl',
        showResetFormBtn: '='
      },
      controllerAs: 'vm',
      controller: CustomLinkController,
      templateUrl: 'app/components/customlinkInputs/customlinkInputs.html',
      bindToController: true
    };

    return directive;
  }

  CustomLinkController.$inject = ['DataFactory'];

  function CustomLinkController(DataFactory) {
    var vm = this;
    vm.student = '';
    vm.overflowStudent = '';
    vm.overflowSchool = '';
    vm.school = '';

    DataFactory.getSchool()
    .then(function(result) {
      vm.schoolList = result.data.schools;
    });

    vm.resetForm = function() {
      // vm.student = '';
      // vm.overflowStudent = '';
      // vm.overflowSchool = '';
      // vm.school = '';
      // vm.promocode = '';
      // vm.url = '';
      // just reload the page
      location.reload();
    }

    vm.updateUrl = function() {
      var urlParam = [];
      var hostname = '';
      if (vm.school && vm.student) {
        hostname = 'https://donor.acsto.org/';
        urlParam.push('school_alt=' + encodeURIComponent(vm.school.alt_id));
        urlParam.push('student=' + encodeURIComponent(vm.student));
        vm.url = hostname + '?' + urlParam.join('&');
      }
      if (vm.overflowSchool && vm.overflowStudent) {
        urlParam.push('schoolOverflow_alt=' + encodeURIComponent(vm.overflowSchool.alt_id));
        urlParam.push('studentOverflow=' + encodeURIComponent(vm.overflowStudent));
        vm.url = hostname + '?' + urlParam.join('&');
      }

      // if (vm.promocode) {
      //     urlParam.push('promocode=' + encodeURIComponent(vm.promocode));
      // }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('StudentsController', StudentsController);

  StudentsController.$inject = ['$scope', '$state', '$uibModal', '$filter', 'toastr', 'ResourceFactory', 'ChildFactory', 'DataFactory', '$cacheFactory', '$sanitize', 'locker'];

  /* @ngInject */
  function StudentsController($scope, $state, $uibModal, $filter, toastr, ResourceFactory, ChildFactory, DataFactory, $cacheFactory, $sanitize, locker) {
    var vm = this;

    vm.children = '';
    vm.childloading = true;

    function loadChildren() {

      vm.childloading = true;
      ChildFactory.getChildren()
        .then(function(children) {

          locker.put('children', angular.toJson(children.child));
          vm.children = children.data.child;
          vm.childloading = false;

        });

    }

    loadChildren();

    vm.childEdit = function(student, event) {
      event.preventDefault();

      var $target = angular.element(event.target).parent().parent().parent();
      $target.addClass('warning');

      // $log.log('student', student);

      //get the index of stack
      var editIndex = vm.children.indexOf(student);

      var modalInstance = $uibModal.open({
        templateUrl: 'app/students/student.update.html',
        controller: 'updateStudentController',
        controllerAs: 'vm',
        resolve: { /* @ngInject */
          child_id: function() {
            return student.web_id;
          },
          'school': ['DataFactory',
            function(DataFactory) {
              return DataFactory.getSchool();
            }
          ]
        }
      });

      modalInstance.result.then(function(response) {

        // $log.log('response', response);
        // $log.log('response.data.child', response.data.child);
        // $log.log('editIndex', editIndex);
        // $log.log('vm.children[editIndex]', vm.children[editIndex]);

        $target.removeClass('warning');

        vm.children[editIndex] = response.data.child;
      }, function() {

        // cancel
        $target.removeClass('warning');
        // console.log('next function after the modalinstance');

      });

    };

    vm.childAdd = function() {

      var modalInstance = $uibModal.open({
        templateUrl: 'app/students/student.add.html',
        controller: 'AddStudentController as vm',
        size: 'lg',
        resolve: { /* @ngInject */
          school: ['DataFactory',
            function(DataFactory) {
              return DataFactory.getSchool();
            }
          ]
          // ,student: function(ChildFactory) {
          //   return ChildFactory.getChildren();
          // }
        }

      });

      modalInstance.result.then(function(data) {

        // $scope.refreshChild();
        // console.log('data', data);

        if (angular.element('tbody tr').length === 0) {
          loadChildren();
          return;
        }

        if (data) {

          // $log.log('child data return', data);
          vm.children.push(data);
          toastr.success('Child added successfully', 'Child added');
        }

        // loadChildren();


      }, function() {

        // cancel
        // $target.removeClass('warning');
        // console.log('next function after the modalinstance');
        // toastr.pop('failed', 'Can not add child.');

      });

    };

    vm.childDelete = function(child, event) {
      var $target = angular.element(event.target).parent().parent();

      // fix to ensure table row is selected
      if (event.target.nodeName === 'I') {
        $target = $target.parent();
      }

      $target.addClass('danger');

      // var confirmChildDelete = confirm('Are you sure you want to delete this child?');

      var modalInstance = $uibModal.open({
        templateUrl: 'app/students/student.confirm.html',
        controller: 'StudentConfirmController',
        controllerAs: 'vm',
        resolve: { /* @ngInject */
          studentname: function() {
            return child.fname + ' ' + child.lname;
          }
        }
      });


      modalInstance.result.then(function(response) {

        /*if (response.status) {

          ChildFactory.deleteChild(child.web_id, function() {

            // remove child from array
            vm.children.splice(vm.children.indexOf(child), 1);
            toastr.success('Child deleted successfully', 'Child deleted');

          }, function() {

            toastr.error('There were issues adding the Parent information', 'Failed to Update Parent Information');

          });

        }*/

        $target.removeClass('danger');

      }, function() {

        // if cancelled
        $target.removeClass('danger');

      });

    };


  }
})();

(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('updateStudentController', updateStudentController);

  updateStudentController.$inject = ['$scope', '$state', '$uibModal', '$filter', 'toastr', 'child_id', 'DataFactory', 'ChildFactory', '$sanitize', '$uibModalInstance', 'school'];

  /* @ngInject */
  function updateStudentController($scope, $state, $uibModal, $filter, toastr, child_id, DataFactory, ChildFactory, $sanitize, $uibModalInstance, school) {
    var vm = this;
    vm.validateChild = false;
    vm.schoolList = school.data.schools;
    vm.foster_child = 0;

    activate();

    ////////////////

    function activate() {

      // find index of an object
      function arrayObjectIndexOf(myArray, searchTerm, property) {
        for (var i = 0, len = myArray.length; i < len; i++) {
          if (myArray[i][property] === searchTerm) {
            return i;
          }
        }
        return -1;
      }
      // arrayObjectIndexOf(grades , "4", "label");

      function formateDate(dataDate) {
        var date = new Date(dataDate);
        return ("0" + (date.getMonth() + 1).toString()).substr(-2) + "/" + ("0" + date.getDate().toString()).substr(-2) + "/" + date.getFullYear();
      }

      ChildFactory.getChild(child_id)
        .then(function(child) {

          // load student stored values
          var selectedSchoolID = '';

          selectedSchoolID = arrayObjectIndexOf(vm.schoolList, child.alt_id, 'alt_id');

          vm.children = child;

          vm.children.fname = $filter('paseQuotes')(vm.children.fname);

          vm.dob = formateDate(child.dob_month + '/' + child.dob_day + '/' + child.dob_year);

          vm.school = vm.schoolList[selectedSchoolID];

          vm.fosterCheck = child.is_foster_child;
          // vm.foster_child = child.is_foster_child;

          vm.childloading = false;
        });

      vm.update = function() {

        vm.validateChild = true;

        if ($scope.childform.$invalid) {

          toastr.clear();

          // $log.log(vm.childform.$error);

          toastr.error('Double check your values and try again', 'Failed to Update Child Information');
          return false;

        }

        toastr.info('Please wait this may take a few moments', 'Saving Changes...', {
          timeOut: 6000
        });

        ChildFactory.updateChild(child_id, {
          fname: $sanitize(vm.children.fname),
          mname: $sanitize(vm.children.mname),
          lname: $sanitize(vm.children.lname),
          dob: $sanitize($filter('date')(vm.dob, 'M/d/yyyy')),
          school_id: vm.school.school_id,
          alt_id: vm.school.alt_id,
          is_foster_child: vm.foster_child
        })
          .then(function(response) {
              // Success handler
              toastr.clear();
              toastr.success('Child updated successfully', 'Child updated');
              $uibModalInstance.close(response);

            },
            function() {
              // Error handler
              toastr.clear();
              // $log.error('Gists error', response.status, response.data);
              toastr.error('Double check your values and try again', 'Failed to Update Child Information');
            });

      };

      vm.cancel = function() {
        $uibModalInstance.dismiss('cancel');
      };



    }



  }


})();

(function() {
  'use strict';

  angular
    .module('acstoparent')
    .run(appRun);

  /* @ngInject */
  function appRun(routerHelper) {
    routerHelper.configureStates(getStates());
  }

  function getStates() {
    return [{
      state: 'students',
      config: {
        url: '/students',
        templateUrl: 'app/students/student.html',
        controller: 'StudentsController',
        controllerAs: 'vm',
        resolve: { /* @ngInject */
          'school': ['DataFactory',
            function(DataFactory) {
              return DataFactory.getSchool();
            }
          ],
          'student': ['ChildFactory',
            function(ChildFactory) {
              return ChildFactory.getChildren();
            }
          ]
        }
      }
    }];
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('StudentConfirmController', StudentConfirmController);

  StudentConfirmController.$inject = ['$uibModalInstance', '$sce', 'studentname'];

  /* @ngInject */
  function StudentConfirmController($uibModalInstance, $sce, studentname) {
    var vm = this;

    vm.title = studentname;
    vm.popClass = 'lead alert-info';
    vm.ok = function() {
      $uibModalInstance.close({
        status: true
      });
    };

    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };


  }


})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('AddStudentController', AddStudentController);

  AddStudentController.$inject = ['$scope', '$state', '$uibModal', '$filter', 'toastr', 'DataFactory', 'ChildFactory', '$sanitize', '$uibModalInstance', 'locker', 'school'];

  /* @ngInject */
  function AddStudentController($scope, $state, $uibModal, $filter, toastr, DataFactory, ChildFactory, $sanitize, $uibModalInstance, locker, school) {
    var vm = this;

    vm.foster_child = 0;
    vm.validateChild = false;

    vm.user = angular.fromJson(locker.get('user'));
    vm.schoolList = school.data.schools;
    // $log.log('vm.schoolList', vm.schoolList);
    // vm.children_school = vm.schoolList;


    // remove N/A in the Scholarship Applications
    // if ($state.current.name === 'scholarship.apply') {
    //   vm.grades.splice(0, 1);
    // }


    function resetStudentBtn() {
      vm.addStudentBtn = '<i class="fa fa-user-plus"></i>Add Student';
    }

    resetStudentBtn();

    vm.saveChildInfo = function($event) {

      // var token = angular.element('meta[name="csrf-token"]').attr('content');

      $event.preventDefault();
      vm.validateChild = true;

      if ($scope.childform.$invalid) {

        toastr.error('Double check your values and try again', 'Failed to Add Child Information');
        return false;

      } else {

        // var $btn = angular.element($event.currentTarget).button('saving');
        vm.maxBtn = 'Saving...';

        toastr.info('Please wait this may take a few moments', 'Saving data...', {
          timeOut: 6000
        });

        ChildFactory.addChild({

          web_id: $sanitize(vm.user.id),
          family_web_id: $sanitize(vm.user.id),
          school_id: vm.children_school.school_id,
          alt_id: vm.children_school.alt_id,
          child_first_name: $sanitize(vm.child_first_name),
          child_middle_initial: $sanitize(vm.child_middle_initial),
          child_last_name: $sanitize(vm.child_last_name),
          is_foster_child: vm.foster_child,
          dob: $sanitize($filter('date')(vm.child_dob, 'M/d/yyyy'))

        }, function(data) {

          toastr.clear();
          resetStudentBtn();

          // api returns 200 when error
          //
          if (data.status_code === 1) {
            var date = new Date($filter('date')(vm.child_dob));


            $uibModalInstance.close({
              dob_day: date.getDate().toString(),
              dob_month: (1 + date.getMonth()).toString(),
              dob_year: date.getFullYear(),

              family_web_id: vm.user.id,
              fname: $sanitize(vm.child_first_name),

              is_foster_child: vm.foster_child,
              lname: $sanitize(vm.child_last_name),
              mname: $sanitize(vm.child_middle_initial),

              school_name: vm.children_school.school_name,
              web_id: data.content.student_web_id
            });

          } else {

            toastr.pop('error', 'Failed to Add Child', 'There were issues adding a child.');
            resetStudentBtn();
            $uibModalInstance.close();

          }


        }, function(data) {

          toastr.clear();

          if (data.status_code != 1) {

            toastr.error('There were issues adding a child', 'Failed to Add Child');
            resetStudentBtn();
            $uibModalInstance.close();

          }


        });

      }




      // $uibModalInstance.close();

    };

    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };




  }


})();

(function() {
  'use strict';

  angular
    .module('acstoparent')
    .factory('ChildFactory', ChildFactory);

  // ChildFactory.$inject = ['dependencies'];

  /* @ngInject */
  function ChildFactory($http, $q) {
    var service = {
      getChildren: getChildren,
      getChildrenNoCache: getChildrenNoCache,
      getChild: getChild,
      addChild: addChild,
      updateChild: updateChild,
      deleteChild: deleteChild
    };



    return service;

    ////////////////

    function getChildren() {

      return $http.get('/api/family/child');
      // var deferred = $q.defer();
      // $http.get('/api/family/child')
      //   .success(deferred.resolve)
      //   .error(deferred.resolve);
      // return deferred.promise;
    }

    function getChildrenNoCache() {

      // 
      return $http.get('/api/family/child?q=' + new Date().getTime());

    }

    function getChild(id) {
      var deferred = $q.defer();
      $http.get('/api/family/child/' + id, {
        cache: false
      })
        .success(deferred.resolve)
        .error(deferred.resolve);
      return deferred.promise;
    }

    function addChild(data, onSuccess, onFail) {
      // family/{family}/child
      $http.post('/api/family/child', data)
        .success(onSuccess)
        .error(onFail);

    }

    function updateChild(id, data) {
      // var deferred = $q.defer();

      //   .success(deferred.resolve)
      //   .error(deferred.reject);
      // return deferred.promise;


      return $http.put('/api/family/child/' + id, data);

    }

    function deleteChild(id, onSuccess, onFail) {

      $http.delete('/api/family/child/' + id)
        .success(onSuccess)
        .error(onFail);

    }
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .filter('tel', tel);

  function tel() {
    return filterFilter;

    ////////////////

    function filterFilter(tel) {
      if (!tel) {
        return '';
      }
      var areaCode, number;
      var value = tel.toString().trim().replace(/^\+/, '');

      if (value.match(/[^0-9]/)) {
        return tel;
      }

      if (value.length === 10) {
        areaCode = value.slice(0, 3);
        number = value.slice(3);
      }

      number = number.slice(0, 3) + '-' + number.slice(3);

      return ('(' + areaCode + ') ' + number).trim();

    }
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .provider('routerHelper', routerHelperProvider);

  routerHelperProvider.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider'];

  /* @ngInject */
  function routerHelperProvider($locationProvider, $stateProvider, $urlRouterProvider) {
    /* jshint validthis:true */
    this.$get = RouterHelper;

    $locationProvider.html5Mode(true);

    RouterHelper.$inject = ['$state'];

    /* @ngInject */
    function RouterHelper($state) {
      var hasOtherwise = false;

      var service = {
        configureStates: configureStates,
        getStates: getStates
      };

      return service;

      ///////////////

      function configureStates(states, otherwisePath) {
        states.forEach(function(state) {
          $stateProvider.state(state.state, state.config);
        });
        if (otherwisePath && !hasOtherwise) {
          hasOtherwise = true;
          $urlRouterProvider.otherwise(otherwisePath);
        }
      }

      function getStates() {
        return $state.get();
      }
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .filter('routeActive', routeActive);

  // routeActive.$inject = ['$state'];

  /* @ngInject */
  function routeActive() {
    return filterFilter;

    ////////////////

    function filterFilter(route, steps) {
      for (var i = 0, j = steps.length; i < j; i++) {
        if (steps[i].name === route.name) {
          return steps[i];
        }
      }

      return false;
    }
  }

})();
(function() {
  'use strict';

  angular.module('acstoparent')
    .directive('passwordStrength', function() {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, element, attrs, ngModel) {
          var indicator = element.children();
          var dots = Array.prototype.slice.call(indicator.children());
          var weakest = dots.slice(-1)[0];
          var weak = dots.slice(-2);
          var strong = dots.slice(-3);
          var strongest = dots.slice(-4);

          element.after(indicator);

          element.bind('keyup', function() {
            var matches = {
                positive: {},
                negative: {}
              },
              counts = {
                positive: {},
                negative: {}
              },
              tmp,
              strength = 0,
              letters = 'abcdefghijklmnopqrstuvwxyz',
              numbers = '01234567890',
              symbols = '\\!@#$%&/()=?¿',
              strValue;

            angular.forEach(dots, function(el) {
              el.style.backgroundColor = '#ebeef1';
            });

            if (ngModel.$viewValue) {
              // Increase strength level
              matches.positive.lower = ngModel.$viewValue.match(/[a-z]/g);
              matches.positive.upper = ngModel.$viewValue.match(/[A-Z]/g);
              matches.positive.numbers = ngModel.$viewValue.match(/\d/g);
              matches.positive.symbols = ngModel.$viewValue.match(/[$-/:-?{-~!^_`\[\]]/g);
              matches.positive.middleNumber = ngModel.$viewValue.slice(1, -1).match(/\d/g);
              matches.positive.middleSymbol = ngModel.$viewValue.slice(1, -1).match(/[$-/:-?{-~!^_`\[\]]/g);

              counts.positive.lower = matches.positive.lower ? matches.positive.lower.length : 0;
              counts.positive.upper = matches.positive.upper ? matches.positive.upper.length : 0;
              counts.positive.numbers = matches.positive.numbers ? matches.positive.numbers.length : 0;
              counts.positive.symbols = matches.positive.symbols ? matches.positive.symbols.length : 0;

              counts.positive.numChars = ngModel.$viewValue.length;
              tmp += (counts.positive.numChars >= 8) ? 1 : 0;

              counts.positive.requirements = (tmp >= 3) ? tmp : 0;
              counts.positive.middleNumber = matches.positive.middleNumber ? matches.positive.middleNumber.length : 0;
              counts.positive.middleSymbol = matches.positive.middleSymbol ? matches.positive.middleSymbol.length : 0;

              // Decrease strength level
              matches.negative.consecLower = ngModel.$viewValue.match(/(?=([a-z]{2}))/g);
              matches.negative.consecUpper = ngModel.$viewValue.match(/(?=([A-Z]{2}))/g);
              matches.negative.consecNumbers = ngModel.$viewValue.match(/(?=(\d{2}))/g);
              matches.negative.onlyNumbers = ngModel.$viewValue.match(/^[0-9]*$/g);
              matches.negative.onlyLetters = ngModel.$viewValue.match(/^([a-z]|[A-Z])*$/g);

              counts.negative.consecLower = matches.negative.consecLower ? matches.negative.consecLower.length : 0;
              counts.negative.consecUpper = matches.negative.consecUpper ? matches.negative.consecUpper.length : 0;
              counts.negative.consecNumbers = matches.negative.consecNumbers ? matches.negative.consecNumbers.length : 0;

              // Calculations
              strength += counts.positive.numChars * 4;
              if (counts.positive.upper) {
                strength += (counts.positive.numChars - counts.positive.upper) * 2;
              }
              if (counts.positive.lower) {
                strength += (counts.positive.numChars - counts.positive.lower) * 2;
              }
              if (counts.positive.upper || counts.positive.lower) {
                strength += counts.positive.numbers * 4;
              }
              strength += counts.positive.symbols * 6;
              strength += (counts.positive.middleSymbol + counts.positive.middleNumber) * 2;
              strength += counts.positive.requirements * 2;

              strength -= counts.negative.consecLower * 2;
              strength -= counts.negative.consecUpper * 2;
              strength -= counts.negative.consecNumbers * 2;

              if (matches.negative.onlyNumbers) {
                strength -= counts.positive.numChars;
              }
              if (matches.negative.onlyLetters) {
                strength -= counts.positive.numChars;
              }

              strength = Math.max(0, Math.min(100, Math.round(strength)));

              if (strength > 85) {
                angular.forEach(strongest, function(el) {
                  el.style.backgroundColor = '#008cdd';
                });
              } else if (strength > 65) {
                angular.forEach(strong, function(el) {
                  el.style.backgroundColor = '#6ead09';
                });
              } else if (strength > 30) {
                angular.forEach(weak, function(el) {
                  el.style.backgroundColor = '#e09115';
                });
              } else {
                weakest.style.backgroundColor = '#e01414';
              }
            }
          });
        },
        template: '<span class="password-strength-indicator"><span></span><span></span><span></span><span></span></span>'
      };
    });
})();
(function() {
  'use strict';

  angular.module('acstoparent')
    .directive('passwordMatch', function() {
      return {
        require: 'ngModel',
        scope: {
          otherModelValue: '=passwordMatch'
        },
        link: function(scope, element, attributes, ngModel) {
          ngModel.$validators.compareTo = function(modelValue) {
            return modelValue === scope.otherModelValue;
          };
          scope.$watch('otherModelValue', function() {
            ngModel.$validate();
          });
        }
      };
    });

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .filter('paseQuotes', paseQuotes);

  // paseQuotes.$inject = ['$state'];

  /* @ngInject */
  function paseQuotes() {
    return filterFilter;

    ////////////////

    function filterFilter(input) {
      if (input) {
        return input.replace(/&#34;/g, '"');
      }
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .directive('minWord', minWord);

  // minWord.$inject = ['dependencies'];

  /* @ngInject */
  function minWord() {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      require: 'ngModel',
      link: link,
      restrict: 'A'
    };
    return directive;

    function link(scope, element, attrs, ngModel) {

      var min = attrs.minWord;

      ngModel.$validators.minWord = function(modelValue, viewValue) {

        if (ngModel.$isEmpty(modelValue)) {
          return false;
        }

        if (viewValue.trim().split(' ').length >= min) {
          return true;
        }

        if (modelValue.trim().split(' ').length >= min) {
          return true;
        }

        // it is invalid
        return false;
      };

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('acstoparent')
    .directive('maxWord', maxWord);

  // maxWord.$inject = ['dependencies'];

  /* @ngInject */
  function maxWord() {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      require: 'ngModel',
      link: link,
      restrict: 'A'
    };
    return directive;

    function link(scope, element, attrs, ngModel) {

      var max = attrs.maxWord;

      ngModel.$validators.maxWord = function(modelValue, viewValue) {

        if (ngModel.$isEmpty(modelValue)) {
          return true;
        }

        if (viewValue.trim().split(' ').length <= max) {
          return true;
        }

        if (modelValue.trim().split(' ').length <= max) {
          return true;
        }

        // it is invalid
        return false;
      };

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('acstoparent')
    .factory('logger', logger);

  logger.$inject = ['$log', 'toastr'];

  /* @ngInject */
  function logger($log, toastr) {
    var service = {
      showToasts: true,

      error: error,
      info: info,
      success: success,
      warning: warning,

      // straight to console; bypass toastr
      log: $log.log
    };

    return service;
    /////////////////////

    function error(message, data, title) {
      toastr.error(message, title);
      $log.error('Error: ' + message, data);
    }

    function info(message, data, title) {
      toastr.info(message, title);
      $log.info('Info: ' + message, data);
    }

    function success(message, data, title) {
      toastr.success(message, title);
      $log.info('Success: ' + message, data);
    }

    function warning(message, data, title) {
      toastr.warning(message, title);
      $log.warn('Warning: ' + message, data);
    }
  }
}());
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .factory('MsVersionFactory', MsVersionFactory);

  // MsVersionFactory.$inject = ['dependencies'];

  /* @ngInject */
  function MsVersionFactory() {
    var service = {
      isIE: isIE
    };
    return service;

    ////////////////

    function isIE() {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf('MSIE ');

      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {

        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));

      } else {

        return false;

      }

    }
  }
})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .filter('fromNow', fromNow);
  
  function fromNow() {
    return filterFilter;

    ////////////////

    function filterFilter(date) {
      return moment(date).fromNow();
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .directive('formatPhone', formatPhone);

  /* @ngInject */
  function formatPhone() {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      link: link,
      restrict: 'A'
    };
    return directive;

    function link(scope, element) {
      element.on('blur', function() {
        var $targetVal = element.val();
        if ($targetVal.length === 10) {
          element.val($targetVal.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3'));
        }
      });
    }
  }


})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .directive('formatMoney', formatMoney);

  /* @ngInject */
  function formatMoney($filter) {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      link: link,
      restrict: 'A'
    };
    return directive;

    function link(scope, element) {
      element.on('blur', function() {
        var $targetVal = element.val();

        if ($targetVal) {
          var value = $targetVal.replace(/\$|,|[a-zA-Z]/g, '');
          element.val($filter('currency')(value, ''));
        }
      });
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .factory('FileFactory', factory);

  /* @ngInject */
  function factory($http, Upload, logger) {
    var service = {
      getFiles: getFiles,
      postFile: postFile,
      deleteFile: deleteFile
    };
    return service;

    ////////////////

    function getComplete(response) {
      return response.data;
    }

    function getFailed(error) {
      if (error.status === 401) {
        logger.error('Sorry, your session has timed out. Please log in again to continue.');
      } else {
        logger.error('File Failed.', error);
      }
    }

    function getFiles(id) {
      return $http.get('/api/upload/' + id)
        .then(getComplete)
        .catch(getFailed);
    }

    function postFile() {
      return $http.get('/api/upload')
        .then(getComplete)
        .catch(getFailed);
    }

    function deleteFile(id) {
      return $http.delete('/api/upload/' + id)
        .then(getComplete)
        .catch(getFailed);
    }


  }
})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .factory('exception', exception);

  exception.$inject = ['logger'];

  function exception(logger) {
    var service = {
      catcher: catcher
    };
    return service;

    function catcher(message) {
      return function(reason) {
        logger.error(message, reason);
      };
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .directive('equals', equals);

  /* @ngInject */
  function equals() {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      link: link,
      restrict: 'A',
      require: '?ngModel'
    };
    return directive;

    function link(scope, elem, attrs, ngModel) {
      if (!ngModel) {
        return;
      } // do nothing if no ng-model

      // watch own value and re-validate on change
      scope.$watch(attrs.ngModel, function() {
        validate();
      });

      // observe the other value and re-validate on change
      attrs.$observe('equals', function() {
        validate();
      });

      var validate = function() {
        // values
        var val1 = ngModel.$viewValue;
        var val2 = attrs.equals;

        // set validity
        // remove case senstivity
        ngModel.$setValidity('equals', !val1 || !val2 || val1.toLowerCase() === val2.toLowerCase());
      };
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('SendSchoarshipEmailController', SendSchoarshipEmailController);

  SendSchoarshipEmailController.$inject = ['$uibModalInstance', 'studentinfo', 'ScholarshipFactory', '$filter'];

  /* @ngInject */
  function SendSchoarshipEmailController($uibModalInstance, studentinfo, ScholarshipFactory, $filter) {
    var vm = this;
    vm.validateContact = false;

    vm.title = 'Contact Us ' + '(' + $filter('paseQuotes')(studentinfo.student_name) + ')';

    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };

    vm.ok = function() {
      vm.validateContact = true;

      ScholarshipFactory.emailAppChanges({
        msg: vm.msg,
        student_name: studentinfo.student_name,
        student_web_id: studentinfo.student_web_id,
        school_name: studentinfo.school_name

      }).then(function(data) {

        $uibModalInstance.close({
          status: true
        });

      }, function(error) {

        $uibModalInstance.dismiss('cancel');

      });

    };

  }


})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .factory('HistoryFactory', HistoryFactory);

  /* @ngInject */
  function HistoryFactory($http, logger) {
    var service = {
      getAward: getAward
    };
    return service;

    ////////////////

    function getComplete(response) {
      return response.data;
    }

    function getFailed(error) {

      // console.log(error);

      if (error.status === 401) {
        logger.error('Sorry, your session has timed out. Please log in again to continue.');
      } else {
        logger.error('Failed getting Award History.', error);
      }

    }

    function getAward() {
      return $http.get('/api/award')
        .then(getComplete)
        .catch(getFailed);
    }

  }
})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .factory('StatusFactory', StatusFactory);

  /* @ngInject */
  function StatusFactory($http, logger) {
    var service = {
      getStatus: getStatus
    };
    return service;

    ////////////////

    function getComplete(response) {
      return response.data;
    }

    function getFailed(error) {
      if (error.status === 401) {
        logger.error('Sorry, your session has timed out. Please log in again to continue.');
      } else {
        logger.error('Failed getting Applications Status.', error);
      }
    }

    function getStatus() {

      return $http.get('/api/scholarship')
        .then(getComplete)
        .catch(getFailed);

    }

  }
})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .factory('ScholarshipFactory', ScholarshipFactory);

  ScholarshipFactory.$inject = ['$http', '$q', 'logger'];

  /* @ngInject */
  function ScholarshipFactory($http, $q, logger) {
    var service = {
      getSavedScholarships: getSavedScholarships,
      getScholarship: getScholarship,
      completeScholarship: completeScholarship,
      saveScholarship: saveScholarship,
      createScholarship: createScholarship,
      updateScholarship: updateScholarship,
      deleteScholarship: deleteScholarship,
      emailAppChanges: emailAppChanges
    };
    return service;

    ////////////////

    // function getComplete(response) {
    //   return response.data;
    // }

    function getFailed(error) {
      if (error.status === 401) {
        logger.error('Sorry, your session has timed out. Please log in again to continue.');
      } else {
        logger.error('Failed Scholarship.', error);
      }

      // message, data, title
    }

    // save scholarship before sending

    function getSavedScholarships() {
      var deferred = $q.defer();

      $http.get('/api/saved_scholarship')
        .then(function(response) {
          deferred.resolve(response.data);
        }, function(error) {
          deferred.reject(error);
          getFailed(error);
        });

      return deferred.promise;
    }

    function saveScholarship(data) {
      var deferred = $q.defer();

      $http.post('/api/saved_scholarship', data)
        .then(function(response) {
          deferred.resolve(response.data);
        }, function(error) {
          deferred.reject(error);
          getFailed(error);
        });

      return deferred.promise;
    }

    function createScholarship(data) {
      var deferred = $q.defer();
      $http.post('/api/scholarship', data)
        .then(function(response) {
          deferred.resolve(response.data);
        }, function(error) {
          deferred.reject(error);
          getFailed(error);
        });

      return deferred.promise;
    }

    function updateScholarship(id, data) {
      var deferred = $q.defer();
      $http.put('/api/saved_scholarship/' + id, data)
        .then(function(response) {
          deferred.resolve(response.data);
        }, function(error) {
          deferred.reject(error);
          getFailed(error);
        });

      return deferred.promise;
    }

    function deleteScholarship(id) {
      var deferred = $q.defer();
      $http.delete('/api/saved_scholarship/' + id)
        .then(function(response) {
          deferred.resolve(response.data);
        }, function(error) {
          deferred.reject(error);
          getFailed(error);
        });

      return deferred.promise;
    }


    // get scholarship from API
    function getScholarship(id) {
      var deferred = $q.defer();

      $http.get('/api/scholarship/' + id, {
        cache: false
      }).then(function(response) {
        deferred.resolve(response.data);
      }, function(error) {
        deferred.reject(error);
        getFailed(error);
      });

      return deferred.promise;
    }


    function completeScholarship(data) {
      var deferred = $q.defer();

      $http.post('/api/scholarship', data)
        .then(function(response) {
          deferred.resolve(response.data);
        }, function(error) {
          deferred.reject(error);
          getFailed(error);
        });

      return deferred.promise;
    }



    function emailAppChanges(data) {
      var deferred = $q.defer();

      $http.post('/api/email', data)
        .then(function(response) {
          deferred.resolve(response.data);
        }, function(error) {
          deferred.reject(error);
          getFailed(error);
        });

      return deferred.promise;
    }

    // function updateScholarship(id, data) {
    //   return $http.put('/scholarship/' + id, data)
    //     .then(getComplete)
    //     .catch(getFailed);
    // }

  }
})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .run(appRun);

  /* @ngInject */
  function appRun(routerHelper) {
    routerHelper.configureStates(getStates());
  }

  // https://github.com/angular-ui/ui-router/wiki
  // You can use resolve to provide your controller with content or data that is custom to the state. resolve is an optional map of dependencies which should be injected into the controller.

  function getStates() {
    return [{
      state: 'scholarship',
      config: {
        abstract: true,
        template: '<ui-view />',
        data: { /* @ngInject */
          gradeList: [{
            label: '-1',
            value: 'Preschool with Disabilities'
          }, {
            label: '0',
            value: 'Kindergarten'
          }, {
            label: '1',
            value: '1st Grade'
          }, {
            label: '2',
            value: '2nd Grade'
          }, {
            label: '3',
            value: '3rd Grade'
          }, {
            label: '4',
            value: '4th Grade'
          }, {
            label: '5',
            value: '5th Grade'
          }, {
            label: '6',
            value: '6th Grade'
          }, {
            label: '7',
            value: '7th Grade'
          }, {
            label: '8',
            value: '8th Grade'
          }, {
            label: '9',
            value: '9th Grade'
          }, {
            label: '10',
            value: '10th Grade'
          }, {
            label: '11',
            value: '11th Grade'
          }, {
            label: '12',
            value: '12th Grade'
          }]
        },
        resolve: { /* @ngInject */
          scholarshipId: ['$stateParams',
            function($stateParams) {
              return $stateParams.scholarshipId;
            }
          ],
          // profile: function(DataFactory) {
          //   return angular.fromJson(locker.get('user'));
          // },
          'states': ['DataFactory',
            function(DataFactory) {
              return DataFactory.getState();
            }
          ],
          'school': ['DataFactory',
            function(DataFactory) {
              return DataFactory.getSchool();
            }
          ],
          displayStudentAlert: ['moment',
            function(moment) {
              var janFirst = moment().month(0).date(1);
              var febThird =  moment().month(1).date(3);
              var octFirst = moment().month(9).date(1);
              var lastDayOfCurrentYear =  moment().month(11).date(31);

              return moment().isBetween(janFirst, febThird, null, '[)')
                ? '\'' + moment().format('YY') + '-\'' + moment().add(1, 'years').format('YY')
                : moment().isBetween(octFirst, lastDayOfCurrentYear, null, '[)') ? '\'' + moment().add(1, 'years').format('YY') + '-\'' + moment().add(2, 'years').format('YY') : false;
            }
          ]
        }
      }
    }, {
      state: 'scholarship.dashboard',
      config: {
        url: '/dashboard',
        templateUrl: 'app/scholarship/dashboard.html',
        controller: 'ScholarshipController',
        controllerAs: 'vm'
      }
    }, {
      state: 'scholarship.apply',
      config: {
        url: '/apply/family-information',
        templateUrl: 'app/scholarship/add/addScholarship.html',
        controller: 'AddScholarshipController',
        controllerAs: 'vm'
      }
    }, {
      state: 'scholarship.edit',
      config: {
        url: '/edit/{scholarshipId:int}/family-information',
        templateUrl: 'app/scholarship/edit/editScholarship.html',
        controller: 'editScholarshipController',
        controllerAs: 'vm'
      }
    }, {
      state: 'scholarship.narrative',
      config: {
        url: '/edit/{scholarshipId:int}/narrative',
        templateUrl: 'app/scholarship/edit/narrative.html',
        controller: 'editScholarshipController',
        controllerAs: 'vm'
      }
    }, {
      state: 'scholarship.income',
      config: {
        url: '/edit/{scholarshipId:int}/verify-income',
        templateUrl: 'app/scholarship/edit/verify-income.html',
        controller: 'editScholarshipController',
        controllerAs: 'vm'
      }
    }, {
      state: 'scholarship.taxcredit',
      config: {
        url: '/edit/{scholarshipId:int}/overflow-tax-credit',
        templateUrl: 'app/scholarship/edit/overflow-tax-credit.html',
        controller: 'editScholarshipController',
        controllerAs: 'vm'
      }
    }, {
      state: 'scholarship.review',
      config: {
        url: '/edit/{scholarshipId:int}/review',
        templateUrl: 'app/scholarship/edit/review.html',
        controller: 'editScholarshipController',
        controllerAs: 'vm'
      }
    }];
  }

})();

(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('ScholarshipController', ScholarshipController);

  ScholarshipController.$inject = ['$scope', '$state', 'DataFactory', 'ChildFactory', 'Upload', '$timeout', 'toastr', '$uibModal', 'StatusFactory', 'ScholarshipFactory', 'HistoryFactory', '$auth', '$window', '$sce'];

  /* @ngInject */
  function ScholarshipController($scope, $state, DataFactory, ChildFactory, Upload, $timeout, toastr, $uibModal, StatusFactory, ScholarshipFactory, HistoryFactory, $auth, $window, $sce) {
    var vm = this;
    vm.students = [];
    vm.scholarshipList = [];
    vm.awards = [];
    vm.loading = true;

    vm.appStatus = getStatus;
    vm.getUnfinishedScholarship = getSavedScholarship;
    vm.getHistory = getHistory;
    vm.downloadChildHistory = downloadChildHistory;
    vm.downloadConfirmation = downloadChildConfirmation;
    vm.contact = contact;
    vm.deleteScholarship = deleteScholarship;

    vm.statusLookup = {
      COMPLETE: 'We have everything needed to consider your student for scholarship. Please view our <a href="https://acsto.org/parents/award-year-timeline" title="Award Timeline">Award Timeline</a> for information on our next scholarship awards.',
      SUBMITTED: 'We have received your application and are still processing it. Please allow 7-10 business days for us to complete processing. We will contact you if there is anything else necessary to consider it complete.',
      INCOMPLETE: 'We require more information to consider your student for scholarship awards. Please contact our office at 480.820.0403.',
      EXPIRED: 'This application is out-of-date. Please submit a new application.'
    };

    vm.getStatusLookup = getStatusLookup;

    // getStatus();

    ////////////////

    function getStatus() {
      vm.loading = true;

      var appStatus = StatusFactory.getStatus();

      appStatus.then(function(data) {

        // console.log(data);
        if (data) {

          vm.students = data.app;
          // $log.log('data', data);

        }

        vm.loading = false;

      });
    }

    function getSavedScholarship() {
      vm.loading = true;

      ScholarshipFactory.getSavedScholarships()
        .then(function(data) {
          // Make sure we have data in the array.
          if (data && data.scholarships) {
            // here we default the year to expired to adjust app w/o no app year.
            var savedScholarship = data.scholarships;

            savedScholarship.forEach(function(obj, index) {
              var appFullYear = 1980;
              // for 16-17 App Year
              // Due date: April 3, 2017
              if (obj.appYearText !== null) {
                appFullYear = obj.appYearText.substring(5,9);
              }
              savedScholarship[index].expired = moment().isAfter(appFullYear + '-04-03');
            });

            vm.scholarshipList = savedScholarship;
          }

          vm.loading = false;
        });
    }

    function getHistory() {

      vm.loading = true;

      HistoryFactory.getAward()
        .then(function(data) {

          if (data) {

            vm.awards = data.awards;

          }

          vm.loading = false;

        });

    }

    function downloadChildHistory(event, $id) {

      event.preventDefault();
      $window.open('/api/award/history/' + $id + '?token=' + $auth.getToken(), '_blank', '');

    }

    function downloadChildConfirmation(event, $id) {

      event.preventDefault();
      $window.open('/api/award/confirmation/' + $id + '?token=' + $auth.getToken(), '_blank', '');

    }

    // vm.editScholarship = function($data) {
    // $log.log('editScholarship', $data);

    // HistoryFactory.getAward().then(function(data) {
    //   console.log('history data: ', data);
    //   vm.awards = data;
    // });

    // };

    function contact(event, student) {
      event.preventDefault();

      var modalInstance = $uibModal.open({
        templateUrl: 'app/scholarship/scholarship.contact.html',
        controller: 'SendSchoarshipEmailController as vm',
        resolve: { /* @ngInject */
          'studentinfo': function() {
            return {
              'student_web_id': student.student_web_id,
              'student_name': student.student_name,
              'school_name': student.detail[0].school_name
            };
          }
        }
      });

      modalInstance.result.then(function(response) {
        if (response.status) {
          toastr.success('Email sent successfully!', 'Email Sent!');
        }
      });

    }

    function deleteScholarship(event, scholarship) {
      var $target = angular.element(event.target).parent().parent();

      // fix to ensure table row is selected
      if (event.target.nodeName === 'I') {
        $target = $target.parent();
      }

      $target.addClass('danger');

      var modalInstance = $uibModal.open({
        templateUrl: 'app/confirm.html',
        controller: 'ScholarshipConfirmController',
        controllerAs: 'vm',
        resolve: { /* @ngInject */
          scholarshipname: function() {
            return scholarship.student_name + ' ' + scholarship.school_name + ' ' + scholarship.grade;
          }
        }
      });

      modalInstance.result.then(function(response) {
        if (response.status) {
          vm.scholarshipList.splice(vm.scholarshipList.indexOf(scholarship), 1);

          ScholarshipFactory.deleteScholarship(scholarship.id).then(function(data) {
            if (data) {
              toastr.success('Scholarship deleted', 'Success');
            }
          }, function() {

            toastr.error('There were issues adding the Parent information', 'Failed to Update Parent Information');

          });
        }

        $target.removeClass('danger');
      }, function() {

        // if cancelled
        $target.removeClass('danger');
      });


      // HistoryFactory.getAward().then(function(data) {
      //   console.log('history data: ', data);
      //   vm.awards = data;
      // });

    }

    var trusted = {};
    function getStatusLookup(status) {
      var dataLookkup = this.statusLookup[status];
      return trusted[dataLookkup] || (trusted[dataLookkup] = $sce.trustAsHtml(dataLookkup));
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('ScholarshipConfirmController', ScholarshipConfirmController);

  ScholarshipConfirmController.$inject = ['$uibModalInstance', '$sce', 'scholarshipname', 'toastr'];

  /* @ngInject */
  function ScholarshipConfirmController($uibModalInstance, $sce, scholarshipname, toastr) {
    var vm = this;

    vm.title = 'Delete Application';
    vm.popClass = 'lead alert-danger';
    vm.msg = $sce.trustAsHtml('<p class="lead">Are you sure you want to delete this application?<br><small>' + scholarshipname + '</small></p>');

    vm.ok = function() {
      $uibModalInstance.close({
        status: true
      });
    };

    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel');
      toastr.fail('Email failed please try again later', 'Email Error!');
    };


  }


})();

(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('ScholarshipModalController', ScholarshipModalController);

  ScholarshipModalController.$inject = ['$uibModalInstance', '$sce'];

  /* @ngInject */
  function ScholarshipModalController($uibModalInstance, $sce) {
    var vm = this;

    vm.title = 'Child Must Be at Least 5 Years Old';
    // vm.msg = $sce.trustAsHtml('<p class="lead">The Arizona Department of Revenue requires a child to be at least 5 years old by January 1st of their Kindergarten year in order to be considered for tax credit scholarships. Please verify the date of birth for your child by going to Students and using the <i class="fa fa-pencil"></i> Edit button. If your student is a preschooler with disabilities, you will need to provide an MET or IEP from an Arizona public school for us to consider the application complete.</p>');

    vm.ok = function() {
      $uibModalInstance.close();
    };
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .factory('IncomeFactory', IncomeFactory);

  /* @ngInject */
  function IncomeFactory($http, $q, $log, logger) {
    var service = {
      getIncomes: getIncomes,
      getIncome: getIncome,
      addIncome: addIncome,
      updateIncome: updateIncome,
      deleteIncome: deleteIncome,
      getFinacialTimestamp: getFinacialTimestamp,
      updateAcsto: updateAcsto
    };
    return service;

    ////////////////

    function getComplete(response) {
      return response.data;
    }

    function getFailed(error) {
      if (error.status === 401) {
        logger.error('Sorry, your session has timed out. Please log in again to continue.');
      } else {
        var errorMsg = error.data['msg'] || 'Something went wrong.';
        logger.error(errorMsg, error, 'Failed Income');
      }
    }

    function getIncomes() {
      return $http.get('/api/income')
        .then(getComplete)
        .catch(getFailed);
    }

    function getIncome(id) {
      return $http.get('/api/income/' + id, {
          cache: false,
          time: new Date().getTime()
        }).then(getComplete)
        .catch(getFailed);
    }

    function addIncome(data) {
      return $http.post('/api/income', data)
        .then(getComplete)
        .catch(getFailed);
    }

    function updateIncome(id, data) {
      return $http.put('/api/income/' + id, data)
        .then(getComplete)
        .catch(getFailed);
    }

    function deleteIncome(id) {
      return $http.delete('/api/income/' + id)
        .then(getComplete)
        .catch(getFailed);
    }

    function getFinacialTimestamp() {
      return $http.get('/api/income_last_update')
        .then(getComplete)
        .catch(getFailed);
    }

    function updateAcsto() {
      return $http.get('/api/update/acsto/income')
        .then(getComplete)
        .catch(getFailed);
    }

  }
})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .run(appRun);

  /* @ngInject */
  function appRun(routerHelper) {
    routerHelper.configureStates(getStates());
  }

  function getStates() {
    return [{
      state: 'sendResetPW',
      config: {
        url: '/send-password',
        templateUrl: 'app/sendPasswordToken/pwToken.html',
        controller: 'PasswordEmailController',
        controllerAs: 'pwemail'
      }
    }];
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('PasswordEmailController', PasswordEmailController);


  /* @ngInject */
  function PasswordEmailController($state, $http, $sanitize, toastr) {
    var vm = this;

    vm.send = function(event) {
      event.preventDefault();
      // reset password
      // console.log('sending');

      $http.post('/api/password/email', {
        email: $sanitize(vm.email)
      })
        .then(function(response) {
          // console.log(response);
          toastr.success(response.data.msg, 'Email Sent', {
            timeOut: 60000
          });

          $state.go('login', {
            msg: 13
          });

        }, function(response) {
          // console.log(response);
          vm.errorMsg = response.data;
          vm.errorMsg.email = response.data.error;
          toastr.error('Failed Sending Email', 'Error');
        });
    };

  }
})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .run(appRun);

  /* @ngInject */
  function appRun(routerHelper) {
    routerHelper.configureStates(getStates());
  }

  function getStates() {
    return [{
      state: 'sendConfirmation',
      config: {
        url: '/resend-confirmation',
        templateUrl: 'app/resendEmail/sendEmail.html',
        controller: 'sendEmailController',
        controllerAs: 'resend'
      }
    }];
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('sendEmailController', sendEmailController);

  /* @ngInject */
  function sendEmailController($scope, $rootScope, $auth, $state, toastr, $http) {
    var vm = this;

    vm.errorMsg = false;


    vm.send = function(event) {
      event.preventDefault();

      $http.post('api/email/confirmation', {
        email: vm.email
      })
        .then(function(response) {
          toastr.success(response.data.msg, 'Email Sent', {
            timeOut: 60000
          });

          $state.go('login', {
            msg: 3
          });

        }, function(response) {
          vm.errorMsg = response.data.error;
          toastr.error('Failed Sending Email', 'Failed');
        });

    };

  }
})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .run(appRun);

  /* @ngInject */
  function appRun(routerHelper) {
    routerHelper.configureStates(getStates());
  }

  function getStates() {
    return [{
      state: 'profile',
      config: {
        url: '/profile',
        templateUrl: 'app/profile/profile.html',
        controller: 'ProfileController',
        controllerAs: 'vm',
        resolve: { /* @ngInject */
          'stateList': ['DataFactory',
            function(DataFactory) {
              return DataFactory.getState();
            }
          ]
        }
      }
    }];
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('ProfileController', ProfileController);

  ProfileController.$inject = ['$scope', '$state', '$uibModal', '$filter', 'toastr', 'ResourceFactory', 'ParentInfoFactory', 'updatePassword', 'DataFactory', '$sanitize', 'locker', 'stateList', '$http'];

  /* @ngInject */
  function ProfileController($scope, $state, $uibModal, $filter, toastr, ResourceFactory, ParentInfoFactory, updatePassword, DataFactory, $sanitize, locker, stateList, $http) {
    var vm = this;

    vm.validateParent = false;
    vm.validatePw = false;
    vm.parents = {};
    vm.user = angular.fromJson(locker.get('user'));
    vm.parents = angular.fromJson(locker.get('user'));
    vm.states = stateList.data.states;

    // $log.log('vm.user', vm.user);


    activate();

    ////////////////

    function activate() {

      var parentPhone = vm.parents.parent_phone || '';
      if (vm.parents.parent_phone && vm.parents.parent_phone.length >= 10) {
        parentPhone = $filter('tel')(vm.parents.parent_phone);
      }
      vm.parents.parent_phone = parentPhone;

      angular.forEach(vm.states, function(value, key) {

        if (value.value === vm.user.state) {
          vm.parents.state = vm.states[key];
        }

      });

      // $scope.$watch('parents', function(newValue, oldValue) {
      //   if (newValue !== oldValue) {
      //     DataFactory.setProfile(newValue);
      //   }
      // });

      // $scope.$watch('states', function(newValue, oldValue) {
      //   if (newValue !== oldValue) {
      //     DataFactory.setState(newValue);
      //   }
      // });

      // $scope.$watch('stateKey', function(newValue, oldValue) {
      //   if (newValue !== oldValue) {
      //     vm.parents.state = vm.states[newValue];
      //   }
      // });

      function resetUpdateBtn() {
        vm.updateBtn = '<i class="fa fa-floppy-o"></i>Update';
      }

      resetUpdateBtn();

      vm.saveParentInfo = function($event) {

        $event.preventDefault();
        vm.validateParent = true;

        vm.updateBtn = 'Updating...';

        vm.parents._method = 'PUT';

        if ($scope.parentInfo.$invalid) {
          toastr.clear();
          toastr.error('Double check your values and try again', 'Failed to Update Parent Information');
          resetUpdateBtn();
          return false;
        }

        toastr.info('Please wait this may take a few moments', 'Saving data...', {
          timeOut: 5000
        });


        ParentInfoFactory.updateFamily(vm.user.id, {

          parent_first_name: $sanitize(vm.parents.parent_first_name),
          parent_middle_initial: $sanitize(vm.parents.parent_middle_initial),
          parent_last_name: $sanitize(vm.parents.parent_last_name),
          parent_phone: $sanitize(vm.parents.parent_phone),
          spouse_first_name: $sanitize(vm.parents.spouse_first_name),
          spouse_middle_initial: $sanitize(vm.parents.spouse_middle_initial),
          spouse_last_name: $sanitize(vm.parents.spouse_last_name),
          // spouse_phone:          $sanitize(vm.parents.spouse_phone),
          address: $sanitize(vm.parents.address),
          address2: $sanitize(vm.parents.address2),
          city: $sanitize(vm.parents.city),
          state: $sanitize(vm.parents.state.value),
          zip: $sanitize(vm.parents.zip)

        }, function() {

          toastr.clear();
          toastr.success('We have updated the parent information', 'Parent information updated');
          resetUpdateBtn();

          // update localstorge when there is an update
          $http.get('api/authenticate/user', {
            cache: false
          }).then(function(response) {

            var user = angular.toJson(response.data.user);
            locker.put('user', user);

          });


        }, function() {

          toastr.clear();
          toastr.error('There were issues adding the Parent information', 'Failed to Update Parent Information');
          resetUpdateBtn();

        });

      };


    }

    vm.updatePassword = function(e) {
      e.preventDefault();
      vm.validatePw = true;

      updatePassword.updatePassword({
        old_password: vm.old_password,
        password: vm.new_password,
        password_confirmation: vm.confirm_new_password
      })
        .then(function(response) {

          if (response.data) {
            toastr.clear();
            toastr.success('Password updated', 'Success');
          }

        }, function(response) {

          // $log.error('response', response);

          if (response.data) {
            toastr.clear();
            toastr.error(response.data.msg, 'Error');
          }

        });

    };



  }
})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .factory('updatePassword', updatePassword);

  // updatePassword.$inject = ['dependencies'];

  /* @ngInject */
  function updatePassword($http) {
    var service = {
      updatePassword: updatePassword
    };
    return service;

    ////////////////

    function updatePassword(payload) {

      return $http.post('/api/authenticate/update/password', payload);

    }


  }
})();
(function() {
  'use strict';

  angular.module('acstoparent')
    .factory('ResourceFactory', function($http) {

      // var getState = function (onSuccess, onFail) {
      var getState = function(onSuccess, onFail) {
        return $http.get('/api/states')
          .success(onSuccess)
          .error(onFail);

        // return $http.get('/states').then(function(data) {
        //     return data;
        // });
      };

      // var getSchool = function (onSuccess, onFail) {
      var getSchool = function(onSuccess, onFail) {
        return $http.get('/api/schools')
          .success(onSuccess)
          .error(onFail);
        // return $http.get('/schools').then(function(data) {
        //     return data;
        // });
      };

      // var getSchool = function (onSuccess, onFail) {
      //     return $http.get('/school')
      //         .success(onSuccess)
      //         .error(onFail);
      // };

      return {
        getState: getState,
        getSchool: getSchool
      };

    })
    .factory('ParentInfoFactory', function($http) {

      // var deferred = $q.defer();
      //     $http.get('/auth/auth-check')
      //         .success(deferred.resolve)
      //         .error(deferred.resolve);

      //     return deferred.promise;



      /*function update(id, data, onSuccess, onFail) {
            $http.put('/family/' + id, data)
            .success(onSuccess)
            .error(onFail);
        }*/

      return {
        updateFamily: function(id, data, onSuccess, onFail) {

          return $http({
              method: 'PUT',
              url: '/api/family/' + id,
              data: data
            })
            .success(onSuccess)
            .error(onFail);

        }

      };

      /*function add(id, data, onSuccess, onFail) {

            $http.post('/family/' + id, data)
            .success(onSuccess)
            .error(onFail);

        }*/

    });


  /*
.factory('ParentInfoFactory', function ($http) {
        function all(onSuccess) {
            $http.get('rms/tag')
                .success(onSuccess)
                .error(function () {
                    console.log("Unable to load snapshot.");
                });
        }

        function add(data, onSuccess,onFail) {
            $http.post('/rms/tag', data)
                .success(onSuccess)
                .error(onFail);
        }

        function update(id, data, onSuccess) {
            $http.put('/rms/tag/' + id, data)
                .success(onSuccess)
                .error(function () {
                    alert("Unable to update snapshot.");
                });
        }

        function remove(id, onSuccess) {
            $http.delete('/rms/tag/' + id, {})
                .success(onSuccess);
        }

        function get(id, onSuccess, onFail) {
            $http.get('/rms/tag/' + id)
                .success(onSuccess)
                .error(onFail);
        }

        return {
            all: all,
            add: add,
            update: update,
            remove: remove,
            get: get
        }
    })
*/
})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('PasswordResetController', PasswordResetController);

  PasswordResetController.$inject = ['$state', '$http', '$stateParams', 'toastr'];

  /* @ngInject */
  function PasswordResetController($state, $http, $stateParams, toastr) {
    var vm = this;


    if (!$stateParams.token) {
      $state.go('login', {
        err: 4
      });
    }

    vm.send = function(event) {
      event.preventDefault();
      // reset password

      toastr.info('Please wait while we reset your password', 'Resetting Password');

      $http.post('/api/password/reset', {
        token: $stateParams.token,
        email: vm.email,
        password: vm.password,
        password_confirmation: vm.confirm_password
      })
        .then(function() {

          toastr.clear();
          toastr.success('Your password has been reset please sign in!', 'Password Reset', {
            timeOut: 60000
          });

          $state.go('login', {
            msg: 11
          });


        }, function(response) {

          toastr.clear();
          toastr.error('Password reset failed', 'Reset Error');
          
          var result = [];

          _.forEach(response.data, function(val) {
            result.push(val);
          });

          vm.errorMsg = result;

        });
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('acstoparent')
    .run(appRun);

  /* @ngInject */
  function appRun(routerHelper) {
    routerHelper.configureStates(getStates());
  }

  function getStates() {
    return [{
      state: 'passwordreset',
      config: {
        url: '/password/reset/:token',
        templateUrl: 'app/resetPassword/pw.html',
        controller: 'PasswordResetController',
        controllerAs: 'pw',
        params: {
          token: ''
        }
      }
    }];
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .run(appRun);

  /* @ngInject */
  function appRun(routerHelper) {
    routerHelper.configureStates(getStates());
  }

  function getStates() {
    return [{
      state: 'register',
      config: {
        url: '/register',
        templateUrl: 'app/register/register.html',
        controller: 'RegisterController',
        controllerAs: 'user',
        resolve: { /* @ngInject */
          'stateList': ['DataFactory',
            function(DataFactory) {
              return DataFactory.getState();
            }
          ]
        }
      }
    }];
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .factory('RegisterFactory', RegisterFactory);

  RegisterFactory.$inject = ['$http'];

  /* @ngInject */
  function RegisterFactory($http) {
    var service = {
      postRegistration: postRegistration
    };
    return service;

    ////////////////

    function postRegistration(req) {
      return $http.post('/api/register', req);
    }


  }
})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('RegisterController', RegisterController);

  RegisterController.$inject = ['$scope', '$auth', '$state', '$http', 'stateList', '$sanitize', 'RegisterFactory', 'toastr'];

  /* @ngInject */
  function RegisterController($scope, $auth, $state, $http, stateList, $sanitize, RegisterFactory, toastr) {
    var vm = this;
    vm.registerValidate = false;

    activate();

    ////////////////

    function activate() {
      vm.email = '';
      vm.password = '';
      vm.spouse_fname = '';
      vm.spouse_middle = '';
      vm.spouse_lname = '';
      vm.address2 = '';

      vm.registerError = false;
      vm.registerErrorText = '';

      vm.stateList = stateList.data.states;

      vm.register = function() {

        vm.registerError = false;

        vm.registerValidate = true;

        if ($scope.registerForm.$valid) {

          var data = {
            parent_first_name: $sanitize(vm.parent_first_name),
            parent_middle_initial: $sanitize(vm.parent_middle_initial),
            parent_last_name: $sanitize(vm.parent_last_name),
            address: $sanitize(vm.address),
            // address2: $sanitize(vm.address2),
            city: $sanitize(vm.city),
            state: $sanitize(vm.state.value),
            zip: $sanitize(vm.zip),
            phone: $sanitize(vm.phone),
            email: vm.email,
            // email_confirmation: $sanitize(vm.confirm_email),
            password: vm.password,
            password_confirmation: vm.confirm_password
          };

          RegisterFactory.postRegistration(data)
            .then(function(response) {

              if (response) {
                toastr.success('Please verify your email before logging in', 'Account Created', {
                  timeOut: 60000
                });

                $state.go('login', {
                  email: $sanitize(vm.email),
                  msg: 0
                });
              }

            }, function(response) {

              vm.registerError = true;
              vm.registerErrorText = response.data;
              toastr.error('Please check your entires and try again', 'Failed Registration');

            });

        } else {

          toastr.error('All values are required', 'Error!');

        }



      };
    }

  }
})();
(function () {
  'use strict';

  angular
      .module('acstoparent')
      .run(appRun);

  /* @ngInject */
  function appRun(routerHelper) {
      routerHelper.configureStates(getStates());
  }

  function getStates() {
      return [{
          state: 'manageLandingPage',
          config: {
              url: '/manage-family-page',
              templateUrl: 'app/manageLandingPage/manageLandingPage.html',
              controller: 'ManageLandingPageController',
              controllerAs: 'vm'
          }
      }];
  }

})();

(function() {
  'use strict';

  angular
    .module('acstoparent')
    .factory('LandingPageFactory', LandingPageFactory);

  // LandingPageFactory.$inject = ['dependencies'];

  /* @ngInject */
  function LandingPageFactory($http) {
    var service = {
      getLandingPage: getLandingPage,
      addLandingPage: addLandingPage,
      updateLandingPage: updateLandingPage
    };


    return service;

    ////////////////

    function getLandingPage() {

      return $http.get('/api/landingpage');
    }

    function addLandingPage(data) {
      return $http.post('/api/landingpage/', data);
    }

    function updateLandingPage(data) {
      return $http.put('/api/landingpage/', data);
    }
  }

})();

(function () {
  'use strict';

  angular
      .module('acstoparent')
      .controller('ManageLandingPageController', ManageLandingPageController);

  ManageLandingPageController.$inject = ['$scope', 'Upload', 'LandingPageFileFactory', 'toastr', '$document', 'LandingPageFactory', '$uibModal', '$q', 'DataFactory', 'locker'];

  /* @ngInject */
  function ManageLandingPageController($scope, Upload, LandingPageFileFactory, toastr, $document, LandingPageFactory, $uibModal, $q, DataFactory, locker) {
    var vm = this;
    vm.appeal = '';
    vm.landingPageLink = '';
    vm.landingPageStatus = '';
    vm.copyStatus = 'Copy URL';
    vm.validateAppeal = false;
    vm.shownListOfUploadedFiles = []; // list of uploaded files that's shown to the user
    vm.uploadedFileNamesFromAPI = []; // list of uploaded files that was previously submitted to API
    vm.webId = '';
    vm.dynamic = 0;
    vm.type = 'warning';
    vm.showComplete = 0;
    vm.submitting = false;
    vm.customLinkStudent = '';
    vm.customLinkSchool = null;
    vm.customLinkOverflowStudent = '';
    vm.customLinkOverflowSchool = {};
    vm.schoolList = [];
    vm.customUrl = '';

    vm.lastSavedChange = '';

    DataFactory.getSchool()
    .then(function(result) {
      vm.schoolList = result.data.schools;
      vm.loadLandingPageInfo();
    });

    vm.loadLandingPageInfo = function() {
      LandingPageFactory.getLandingPage()
      .then(function(landingPage) {
        if (landingPage.status_code === 0 || !landingPage.data.status) {
          vm.landingPageStatus = ''; // default
          vm.landingPageLink = ''; //default
        } else if (landingPage.data.status) {
          vm.landingPageLink = landingPage.data.url;
          vm.landingPageStatus = landingPage.data.status;
          vm.customUrl = landingPage.data.contribution_url;
          vm.appeal = landingPage.data.content1 || '';
          vm.uploadedFileNamesFromAPI = vm.parsePreviouslyUploadedFiles(landingPage.data);
          vm.webId = landingPage.data.web_id;
          vm.decodeCustomUrl();
          vm.setLoadedLandingPageDataAsPreviouslySavedData();
        }
        loadFileFunc();
      });
    }

    vm.decodeCustomUrl = function() {
      if (vm.customUrl.length > 0) {
        var match;
        var pl = /\+/g;  // Regex for replacing addition symbol with a space
        var search = /([^&=]+)=?([^&]*)/g;
        var decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); };
        var sliceUrlIndex = vm.customUrl.indexOf('?');
        var query  = vm.customUrl.substring(sliceUrlIndex + 1);

        var urlParams = {};
        while (match = search.exec(query)) {
          urlParams[decode(match[1])] = decode(match[2]);
        }

        if (urlParams.school_alt) {
          angular.forEach(vm.schoolList, function(school) {
            if (urlParams.school_alt) {
              if (school.alt_id == urlParams.school_alt) {
                vm.customLinkSchool = school;
              }
            }
            if (urlParams.school) {
              if (school.school_id == urlParams.school) {
                vm.customLinkSchool = school;
              }
            }
            if (urlParams.schoolOverflow_alt) {
              if (school.alt_id == urlParams.schoolOverflow_alt) {
                vm.customLinkOverflowSchool = school;
              }
            }
            if (urlParams.schoolOverflow) {
              if (school.school_id == urlParams.schoolOverflow) {
                vm.customLinkOverflowSchool = school;
              }
            }
          })
        }

        vm.customLinkStudent = urlParams.student;
        vm.customLinkOverflowStudent = urlParams.studentOverflow;
      }
    }

    vm.parsePreviouslyUploadedFiles = function(landingPage) {
      var result = [];
      if (landingPage.image1) {
        result.push(landingPage.image1);
      }
      if (landingPage.image2) {
        result.push(landingPage.image2);
      }
      if (landingPage.image3) {
        result.push(landingPage.image3);
      }
      return result;
    };

    vm.copyToClipboard = function() {
      if (vm.landingPageLink) {
        var copyElement = $document[0].createElement("textarea");
        copyElement.style.position = 'fixed';
        copyElement.style.opacity = '0';
        copyElement.textContent = vm.landingPageLink;
        var body = $document[0].getElementsByTagName('body')[0];
        body.appendChild(copyElement);
        copyElement.select();
        $document[0].execCommand('copy');
        body.removeChild(copyElement);
        vm.copyStatus = 'Copied!';
      }
    }

    vm.setLoadedLandingPageDataAsPreviouslySavedData = function () {
      var image1Name = '';
      var image2Name = '';
      var image3Name = '';

      if (vm.shownListOfUploadedFiles[0]) {
        image1Name = vm.shownListOfUploadedFiles[0].filename;
      }

      if (vm.shownListOfUploadedFiles[1]) {
        image2Name = vm.shownListOfUploadedFiles[1].filename;
      }

      if (vm.shownListOfUploadedFiles[2]) {
        image3Name = vm.shownListOfUploadedFiles[2].filename;
      }

      var urlParam = [];
      var hostname = 'https://donor.acsto.org';
      var familyWebId = angular.fromJson(locker.get('user')).id;
      if (vm.customLinkSchool && vm.customLinkStudent) {
        urlParam.push('school_alt=' + encodeURIComponent(vm.customLinkSchool.alt_id));
        urlParam.push('student=' + encodeURIComponent(vm.customLinkStudent));
        urlParam.push('fwi=' + encodeURIComponent(familyWebId));
        vm.customUrl = hostname + '?' + urlParam.join('&');
      }
      if (vm.customLinkOverflowSchool && vm.customLinkOverflowStudent) {
        urlParam.push('schoolOverflow_alt=' + encodeURIComponent(vm.customLinkOverflowSchool.alt_id));
        urlParam.push('studentOverflow=' + encodeURIComponent(vm.customLinkOverflowStudent));
        vm.customUrl = hostname + '?' + urlParam.join('&');
      }

      var landingPageData = {
        content1: vm.appeal,
        content2: '',
        content3: '',
        image1: image1Name,
        image2: image2Name,
        image3: image3Name,
        url: vm.landingPageLink,
        contribution_url: vm.customUrl
      };

      vm.lastSavedChange = JSON.stringify(landingPageData);
    };

    vm.submitPayload = function() {
      vm.submitting = true;
      var image1Name = '';
      var image2Name = '';
      var image3Name = '';

      if (vm.shownListOfUploadedFiles[0]) {
        image1Name = vm.shownListOfUploadedFiles[0].filename;
      }

      if (vm.shownListOfUploadedFiles[1]) {
        image2Name = vm.shownListOfUploadedFiles[1].filename;
      }

      if (vm.shownListOfUploadedFiles[2]) {
        image3Name = vm.shownListOfUploadedFiles[2].filename;
      }

      var urlParam = [];
      var hostname = 'https://donor.acsto.org';
      var familyWebId = angular.fromJson(locker.get('user')).id;
      if (vm.customLinkSchool && vm.customLinkStudent) {
        urlParam.push('school_alt=' + encodeURIComponent(vm.customLinkSchool.alt_id));
        urlParam.push('student=' + encodeURIComponent(vm.customLinkStudent));
        urlParam.push('fwi=' + encodeURIComponent(familyWebId));
        vm.customUrl = hostname + '?' + urlParam.join('&');
      }
      if (vm.customLinkOverflowSchool && vm.customLinkOverflowStudent) {
        urlParam.push('schoolOverflow_alt=' + encodeURIComponent(vm.customLinkOverflowSchool.alt_id));
        urlParam.push('studentOverflow=' + encodeURIComponent(vm.customLinkOverflowStudent));
        vm.customUrl = hostname + '?' + urlParam.join('&');
      }

      var landingPageData = {
        content1: vm.appeal,
        content2: '',
        content3: '',
        image1: image1Name,
        image2: image2Name,
        image3: image3Name,
        url: vm.landingPageLink,
        contribution_url: vm.customUrl
      };

      var landingPageDataStringify = JSON.stringify(landingPageData);

      if (vm.lastSavedChange && (landingPageDataStringify === vm.lastSavedChange)) {
        toastr.warning('You have not made any changes since your last submission. Please make any changes as needed and submit again.', 'Warning: Submission Not Saved');
        vm.submitting = false;
        return;
      } else {
        vm.lastSavedChange = landingPageDataStringify;
      }

      if (vm.webId) {
        landingPageData.webID = vm.webId;
        LandingPageFactory.updateLandingPage(landingPageData)
        .then(function(result) {
          if (result.status === 200) {
            vm.submitting = false;
            vm.loadLandingPageInfo();
            $scope.landingPage.$setUntouched();
            $scope.landingPage.$setPristine();
            vm.showComplete = 0;
            vm.dynamic = 0;
            toastr.success('You have successfully submitted your ACSTO Family Page edits!', 'Success');
          } else {
            console.log('RESULT: ', result)
            toastr.error('Parts of your edit may have failed to save, please try again.', 'Error');
          }
        })
        .catch(function(error) {
          vm.submitting = false;
          vm.loadLandingPageInfo();
          console.log('ERROR: ', error)

          var errorMessage = 'Parts of your edit may have failed to save, please try again.';
          if (error.msg) {
            errorMessage = error.msg;
          }
          toastr.error(errorMessage, 'Error');
        });
      } else {
        LandingPageFactory.addLandingPage(landingPageData)
        .then(function(result) {
          if (result.status === 200) {
            vm.submitting = false;
            vm.loadLandingPageInfo();
            $scope.landingPage.$setUntouched();
            $scope.landingPage.$setPristine();
            vm.showComplete = 0;
            vm.dynamic = 0;
            toastr.success('You have successfully submitted your ACSTO Family Page for review!', 'Success');
          } else {
            toastr.error('Your ACSTO Family Page failed to save, please try again.', 'Error');
          }
        })
        .catch(function(error) {
          vm.submitting = false;
          vm.loadLandingPageInfo();
          var errorMessage = 'Your ACSTO Family Page failed to save, please try again.';
          if (error.msg) {
            errorMessage = error.msg;
          }
          toastr.error(errorMessage, 'Error');
        });
      }
    }

    vm.submitLandingPageInfo = function(event) {
      event.preventDefault();
      vm.validateAppeal = true;

      if (!$scope.landingPage.$valid) {
        toastr.error('Please check your values and try again', 'Error!');
      } else {
        vm.submitPayload();
      }
    }

    vm.mailToSocial = function(event) {
      event.preventDefault();
      window.href = "mailto:social@acsto.org";
    }
        /**
     *
     * file upload
     *
     **/

    function loadFileFunc() {

      // if there are previously uploaded files from API
      if (vm.uploadedFileNamesFromAPI.length > 0) {
        var promises = [];
        vm.uploadedFileNamesFromAPI.forEach(function(filename, index) {
          promises.push(LandingPageFileFactory.getOneLandingPageFile(filename)
          .then(function(result) {
            vm.shownListOfUploadedFiles[index] = result.landing_pages[0];
          }));
        });
        $q.all(promises)
          .catch(function() {
            toastr.error('There was an error retrieving some of your files!', 'Error')
          });
      }

      $scope.$watch(function() {
        return vm.files;
      }, function() {
        if (vm.files && vm.files.length > 0) {
          vm.upload(vm.files);
        }
      });

      vm.upload = function(files) {
        if (files && (vm.shownListOfUploadedFiles.length + files.length <= 3)) {
          vm.showComplete = 0;
          for (var i = 0; i < files.length; i++) {
            var file = files[i];

            var fileInfo = {
              url: 'api/landingpage_upload',
              fields: {},
              file: file
            };

            Upload.upload(fileInfo).progress(function(evt) {
              var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
              vm.dynamic = progressPercentage;
              vm.type = 'info';
            }).success(function(data) {
              vm.dynamic = '100';
              vm.type = 'success';
              vm.showComplete = 1;
              vm.shownListOfUploadedFiles = vm.shownListOfUploadedFiles.concat(data.landing_pages);
              vm.files = [];
              toastr.success('File uploaded successfully!', 'Success');
            }).error(function() {
              vm.dynamic = '0';
              file.state = 'Error';
              toastr.error('There was an error uploading!', 'Error');
            });
          }
        } else if (files && (files.length > 3 || vm.shownListOfUploadedFiles.length + files.length > 3)) {
          toastr.error('You can only upload a total of three files.', 'Upload File Limit!');
        } else if (vm.shownListOfUploadedFiles.length === 3) {
          toastr.error('You can only upload a total of three files. Please delete one before uploading another.', 'Upload File Limit!');
        }
      };

      vm.deleteFile = function(event, file) {
        var $target = angular.element(event.target).parent();

        if (event.target.nodeName === 'SPAN') {
          $target = $target.parent();
        }

        var modalInstance = $uibModal.open({
          templateUrl: 'app/confirm.html',
          controller: 'FileDeleteConfirmController',
          controllerAs: 'vm',
          resolve: { /* @ngInject */
            filename: function() {
              return file.original_filename;
            }
          }
        });


        modalInstance.result.then(function(response) {
          if (response.status) {
            if (vm.uploadedFileNamesFromAPI.indexOf(file.filename) < 0) {
              // delete from localDB if images haven't been submitted/published yet
              LandingPageFileFactory.deleteLandingPageFiles(file.id).then(function(data) {
                if (data) {
                  toastr.success('The file has been deleted.', 'Success');
                  $target.remove();
                  vm.shownListOfUploadedFiles = vm.shownListOfUploadedFiles.filter(function(shownFile) {
                    if (shownFile.id !== file.id) {
                      return shownFile;
                    }
                  });
                }
              }, function() {
                toastr.error('There was an issue deleting the file please try again later', 'Failed to Delete File');
              });
            } else {
              // just remove from shownListOfUploadedFiles
              $target.remove();
              vm.shownListOfUploadedFiles = vm.shownListOfUploadedFiles.filter(function(shownFile) {
                if (shownFile.id !== file.id) {
                  return shownFile;
                }
              });
              toastr.success('The file has been deleted.', 'Success');
            }
          }
        });
      };
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('acstoparent')
    .factory('LandingPageFileFactory', factory);

  /* @ngInject */
  function factory($http, logger) {
    var service = {
      getAllLandingPageFiles: getAllLandingPageFiles,
      postLandingPageFiles: postLandingPageFiles,
      deleteLandingPageFiles: deleteLandingPageFiles,
      getOneLandingPageFile: getOneLandingPageFile
    };
    return service;

    ////////////////

    function getComplete(response) {
      return response.data;
    }

    function getFailed(error) {
      if (error.status === 401) {
        logger.error('Sorry, your session has timed out. Please log in again to continue.');
      } else {
        logger.error('File Failed.', error);
      }
    }

    function getAllLandingPageFiles() {
      return $http.get('/api/landingpage_upload')
        .then(getComplete)
        .catch(getFailed);
    }

    function getOneLandingPageFile(filename) {
      return $http.get('/api/landingpage_upload/?filename=' + filename)
      .then(getComplete)
      .catch(getFailed);
    }

    function postLandingPageFiles() {
      return $http.get('/api/landingpage_upload')
        .then(getComplete)
        .catch(getFailed);
    }

    function deleteLandingPageFiles(id) {
      return $http.delete('/api/landingpage_upload/' + id)
        .then(getComplete)
        .catch(getFailed);
    }


  }
})();

(function () {
    'use strict';

    angular
        .module('acstoparent')
        .controller('PopupController', PopupController);

    PopupController.$inject = ['$uibModalInstance'];

    /* @ngInject */
    function PopupController($uibModalInstance) {
        var vm = this;

        vm.ok = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }

})();

(function() {
  'use strict';

  angular
    .module('acstoparent')
    .run(appRun);

  /* @ngInject */
  function appRun(routerHelper) {
    routerHelper.configureStates(getStates());
  }

  function getStates() {
    return [{
        state: 'login',
        config: {
          url: '/auth/login?msg&err',
          views: {
            'login': {
              templateUrl: 'app/login/login.html',
              controller: 'AuthController',
              controllerAs: 'auth',
              params: {
                email: '',
                msg: '',
                err: ''
              }
            }
          }
        }
      },
      // {
      //   state: 'register',
      //   config: {
      //     url: '/auth/register',
      //     controller: function($window) {
      //       $window.location.href = $window.location.protocol + '//' + $window.location.host + '/auth/register';
      //     }
      //   }
      // },
      // {
      //   state: 'passwordreset',
      //   config: {
      //     url: '/password/email',
      //     controller: function($window) {
      //       $window.location.href = $window.location.protocol + '//' + $window.location.host + '/password/email';
      //     }
      //   }
      // },
      {
        state: 'facebook',
        config: {
          url: '/auth/facebook',
          controller: function($window) {
            $window.location.href = $window.location.protocol + '//' + $window.location.host + '/auth/facebook';
          }
        }
      }, {
        state: 'google',
        config: {
          url: '/auth/google',
          controller: function($window) {
            $window.location.href = $window.location.protocol + '//' + $window.location.host + '/auth/google';
          }
        }
      }
      // , {
      //   state: 'students',
      //   config: {
      //     url: '/students',
      //     templateUrl: 'app/students/student.html',
      //     controller: 'ChildrenCtrl as children'
      //   }
      // }, {
      //   state: 'logoff',
      //   config: {
      //     url: '/auth/logout',
      //     controller: function($window, $$window) {
      //       $location.path('/auth/logout');
      //       $$window.location.href = '/auth/logout';
      //     }
      //   }
      // }
    ];
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('AuthController', AuthController);

  AuthController.$inject = ['$scope', '$uibModal', '$stateParams', '$auth', '$state', '$http', '$sce', '$rootScope', '$interval', '$log', 'locker', 'toastr', '$window', '$timeout'];


  /* @ngInject */
  function AuthController($scope, $uibModal, $stateParams, $auth, $state, $http, $sce, $rootScope, $interval, $log, locker, toastr, $window, $timeout) {
    var vm = this;
    var $elem = angular.element('body');

    $elem.css('height', '0');

    vm.errorMsg = false;
    vm.loginValidate = false;

    var msgList = [
      //0
      'Thank you for registering. A verification link has been sent to your e-mail.<br><mark><strong>You must verify before logging in.</strong></mark><br>Please add <strong>donotreply@acsto.org</strong> to your safe-sender\'s list, but if you still don\'t get your email, call us at 480.820.0403.',
      // 1
      '<i class="fa fa-check"></i>Your account has been successfully activated. Please sign in.',
      'Your activation has expired. Please request for another activation key <a href="/#/resend-confirmation">here</a>.',
      'We\'ve sent you another confirmation email.<br>Please add <strong>donotreply@acsto.org</strong> to your safe-sender\'s list or check your <mark>spam folder</mark>, but if you still don\'t get your email, call us at 480.820.0403.',
      'Token is required to reset your password.',
      'Your account has already been activated. Please sign in.',
      // 6
      'There was an issue activating your account.',
      'Your account or key does not exist.',
      // 8
      'An error has occured. Please check your entries and try again.',
      // 9
      'Account not active!<br>Please activate your account through the email confirmation we sent you. If you <a href="#/register" title="registration" target="_self"><strong>REGISTER</strong></a>, but didn\'t get the email, please check your <mark>spam folder</mark> or <a href="#/resend-confirmation" target="_self">click here to resend your confirmation</a>.',
      // user's email has not been confirmed, throw an error
      // 10
      'Sorry, the Email and/or password you chose are invalid. Let\'s see why: <ol><li>If you <a href="#/register" target="_self" title="registration"><strong>REGISTERED</strong></a>, but didn\'t get the email, please check your spam folder or <a href="#/resend-confirmation" target="_self">click here to resend your confirmation</a>.</li><li>If you forgot your password, click on <a href="#/send-password" target="_self" >Forgot Password</a> below</li><li>If you still have issues, we\'d love to help at 480.820.0403</li></ol>',
      'Your password has been reset please login with your new password.',
      'There was an issue activating your account. Please try again. Call at 480.820.0403 if problem persists.',
      'We\'ve sent you an email to reset your password. Please add donotreply@acsto.org to your safe-sender\'s list, but if you still don\'t get your email, call us at 480.820.0403.',
      ''
    ];

    // load email after registration
    if ($stateParams.email) {
      vm.email = $stateParams.email;
    }

    // show msg
    if ($stateParams.msg) {

      vm.msg = $stateParams.msg;

      if (angular.isNumber(parseInt($stateParams.msg, 10))) {
        vm.msg = msgList[$stateParams.msg];
      }

    }

    // show error
    if ($stateParams.err) {
      vm.errorMsg = msgList[$stateParams.err];
    }


    vm.loginError = false;
    vm.loginErrorText = '';

    // vm.loginWarning = false;
    // vm.loginWarningText = '';

    vm.loginSuccess = false;
    vm.loginSuccessText = '';

    function proccessLogin(response) {

      // clear vegas plugin
      clearLargeBackgroundSlideShow();

      // Stringify the returned data to prepare it
      // to go into local storage
      var user = angular.toJson(response.data.user);

      // Set the stringified user data into local storage
      // localStorage.setItem('user', user);
      locker.put('user', user);

      // The user's authenticated state gets flipped to
      // true so we can now show parts of the UI that rely
      // on the user being logged in
      $rootScope.authenticated = true;

      // Putting the user's data on $rootScope allows
      // us to access it anywhere across the app
      $rootScope.currentUser = response.data.user;

      // console.log($rootScope.currentUser);

      // Everything worked out so we can now redirect to
      // the users state to view the data
      $state.go('scholarship.dashboard');
    }

    vm.login = function(e) {

      e.preventDefault();

      vm.loginValidate = true;


      if ($scope.signinForm.$valid) {
        var credentials = {
          email: vm.email,
          password: vm.password
        };

        // Use Satellizer's $auth service to login
        $auth.login(credentials).then(function() {

          // Return an $http request for the now authenticated
          // user so that we can flatten the promise chain
          return $http.get('api/authenticate/user');

          // Handle errors
        }, function(response) {

          // $log.log('response', response);
          // $log.log('response.data.error', response.data.error);
          // $log.log('isnumber?', angular.isNumber(response.data.error));

          vm.loginError = true;
          vm.loginErrorText = response.data.error;

          vm.msg = '';

          if (angular.isNumber(response.data.error)) {
            vm.errorMsg = msgList[response.data.error];
          }

          // Because we returned the $http.get request in the $auth.login
          // promise, we can chain the next promise to the end here
        }).then(function(response) {

          if (response) {
            proccessLogin(response);
          }

        });

      } else {

        toastr.error('All values are required', 'Error!');

      }

    };

    vm.authenticate = function(provider) {
      $auth.authenticate(provider)
        .then(function() {

          // Return an $http request for the now authenticated
          // user so that we can flatten the promise chain
          return $http.get('api/authenticate/user');

          // Handle errors
        }, function(error) {

          vm.loginError = true;
          vm.loginErrorText = error.data.error;

          // Because we returned the $http.get request in the $auth.login
          // promise, we can chain the next promise to the end here
        }).then(function(response) {

          if (response) {
            proccessLogin(response);
          }

        });
    };

    showLargeBackgroundSlideShow();
    // showPopup();

    ////////////////

    function showPopup() {
      $uibModal.open({
        templateUrl: 'app/login/popup.html',
        controller: 'PopupController',
        controllerAs: 'vm'
      });
    }

    function isHighDensity() {
      return (($window.matchMedia && ($window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || $window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches)) || ($window.devicePixelRatio && $window.devicePixelRatio > 1.3));
    }

    function isRetina() {
      return (($window.matchMedia && ($window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || $window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches)) || ($window.devicePixelRatio && $window.devicePixelRatio > 2)) && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
    }

    function showLargeBackgroundSlideShow() {

      var retina = '.jpg';

      if (isHighDensity()) {
        retina = '@2x.jpg';
      }
      if (isRetina()) {
        retina = '@2x.jpg';
      }

      // fixed login height
      $elem.css('height', '0');

      $elem.vegas({
        delay: 10000,
        preload: false,
        preloadImage: true,
        autoplay: true,
        cover: true,
        timer: false,
        shuffle: true,
        // animation: 'kenburnsUp',
        slides: [{
          src: '/img/arizona_canyons' + retina,
          fade: 1500
        }, {
          src: '/img/arizona_dam' + retina,
          fade: 1500
        }, {
          src: '/img/arizona_flag' + retina,
          fade: 1500
        }, {
          src: '/img/arizona_mountains' + retina,
          fade: 1500
        }, {
          src: '/img/night_time_arizona' + retina,
          fade: 1500
        }, {
          src: '/img/arizona_sky' + retina,
          fade: 1500
        }, {
          src: '/img/arizona_telescope_observatory' + retina,
          fade: 1500
        }, {
          src: '/img/downtown_arizona' + retina,
          fade: 1500
        }, {
          src: '/img/water_bridge' + retina,
          fade: 1500
        }, {
          src: '/img/night_time_arizona2' + retina,
          fade: 1500
        }, {
          src: '/img/arizona_mountains2' + retina,
          fade: 1500
        }]
      });
    }

    function clearLargeBackgroundSlideShow() {
      $timeout(function() {
        if ($elem.hasClass('vegas-container')) {
          $elem.removeAttr('style');
          $elem.vegas('destroy');
        }
      }, 100);
    }

  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .run(appRun);

  /* @ngInject */
  function appRun(routerHelper) {
    routerHelper.configureStates(getStates());
  }

  function getStates() {
    return [{
      state: 'literature',
      config: {
        url: '/resources/literature',
        templateUrl: 'app/literature/literature.html',
        controller: 'LiteratureController',
        controllerAs: 'lit',
        data: {},
        resolve: { /* @ngInject */
          'stateList': ['DataFactory',
            function(DataFactory) {
              return DataFactory.getState();
            }
          ]
        }
      }
    }];
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('LiteratureController', LiteratureController);

  LiteratureController.$inject = ['$scope', '$log', 'DataFactory', '$state', 'LiteratureFactory', '$filter', 'toastr', '$sanitize', 'locker', 'stateList'];

  /* @ngInject */
  function LiteratureController($scope, $log, DataFactory, $state, LiteratureFactory, $filter, toastr, $sanitize, locker, stateList) {
    var vm = this;

    vm.states = stateList.data.states;
    vm.user = angular.fromJson(locker.get('user'));

    vm.validateLiterature = false;
    vm.first_name = vm.user.parent_first_name;
    vm.last_name = vm.user.parent_last_name;
    vm.address = vm.user.address;
    vm.city = vm.user.city;
    vm.zip = vm.user.zip;
    vm.phone = $filter('tel')(vm.user.parent_phone);
    vm.email = vm.user.email;
    vm.brochures = 0;
    vm.scholarship_apps = 0;
    vm.out_of_state_donation_brochures = 0;
    vm.comment = '';


    angular.forEach(vm.states, function(value, key) {

      if (value.value === vm.user.state) {
        vm.state = vm.states[key];
      }

    });


    vm.sendRequest = function() {
      var original = angular.copy(vm.literature);

      vm.validateLiterature = true;

      toastr.info('Please wait this may take a few moments', 'Saving data...', {
        timeOut: 5000
      });

      if ($scope.literature.$invalid) {
        toastr.clear();
        toastr.warning('All fields are required', 'Warning');
        return false;
      }

      LiteratureFactory.sendEmail({

        first_name: $sanitize(vm.first_name),
        last_name: $sanitize(vm.last_name),
        address: $sanitize(vm.address),
        city: $sanitize(vm.city),
        state: $sanitize(vm.state.value),
        zip: $sanitize(vm.zip),
        phone: $sanitize(vm.phone),
        email: $sanitize(vm.email),
        brochures: $sanitize(vm.brochures),
        scholarship_apps: $sanitize(vm.scholarship_apps),
        out_of_state_donation_brochures: $sanitize(vm.out_of_state_donation_brochures),
        comment: $sanitize(vm.comment)

      }).then(function(success) {

        toastr.clear();

        vm.literature = angular.copy(original);
        vm.brochures = 0;
        vm.scholarship_apps = 0;
        vm.out_of_state_donation_brochures = 0;
        vm.comment = '';

        $scope.literature.comment.$setPristine();
        $scope.literature.comment.$setValidity();

        // $state.go('home');


        // $log.log('success', success);

        if (success.status === 200) {

          toastr.success('Email has been sent successfully', 'Email Sent', {
            timeOut: 10000
          });

          $state.go('scholarship.dashboard');

        } else {
          toastr.error(success.msg, 'Failed', {
            timeOut: 5000
          });
        }



      }, function() {

        toastr.clear();
        toastr.error('There was an issue sending your email. Please try again later', 'Failed');

      });

    };



  }
})();

(function() {
  'use strict';

  angular
    .module('acstoparent')
    .factory('LiteratureFactory', LiteratureFactory);

  LiteratureFactory.$inject = ['$http'];

  /* @ngInject */
  function LiteratureFactory($http) {
    var service = {
      sendEmail: sendEmail
    };
    return service;

    ////////////////

    function sendEmail(payload) {
      return $http.post('/api/literature', payload);
    }

  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .run(appRun);

  /* @ngInject */
  function appRun(routerHelper) {
    routerHelper.configureStates(getStates());
  }

  function getStates() {
    return [{
      state: 'faq',
      config: {
        url: '/faq',
        templateUrl: 'app/faq/faq.html',
        controller: 'FaqController',
        controllerAs: 'vm'
      }
    }];
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('FaqController', FaqController);

  /* @ngInject */
  function FaqController($auth) {
    var vm = this;
    var ele = angular.element('body');
    vm.registrationQs = [
      {
        question: 'I registered for a Parent Portal account. Why can\'t I log in?',
        answer: 'When you first register for a Parent Portal account, you must verify your email address within 24 hours by clicking the confirmation link we emailed to you, then you can log in. If it has been more than 24 hours since you registered, <a href="#/resend-confirmation" target="_self">click here</a> to generate a new confirmation email.'
      },
      {
        question: 'I did not get a confirmation email. What should I do?',
        answer: 'The confirmation email may get caught in your spam filter, so check your spam or junk folder first. If you can\'t find the confirmation email: 1) Add <b>donotreply@acsto.org</b> to your contacts or safe sender\'s list, then 2) <a href="#/resend-confirmation" target="_self">Click here</a> to generate a new confirmation email.'
      },
      {
        question: 'I still can\'t log in. What else can I do?',
        answer: 'Confirm that you are using the email address associated with your Parent Portal account. Call us at 480.820.0403 if you need assistance.'
      },
      {
        question: 'I forgot my password. What should I do?',
        answer: 'Click “Forgot Password” on the Parent Portal log in screen to reset your password.'
      },
      {
        question: 'Are the Parent Portal and Donor Portal the same or different?',
        answer: 'They are two different portals. You need create a separate account for each portal.'
      }
    ];

    vm.scholarshipQs = [
      {
        question: 'What are the advantages of using the Parent Portal?',
        answer: '<ul><li>Submit Scholarship Applications quickly</li><li>View application status any time</li><li>View new scholarship awards immediately</li><li>View amount sent to the school for a specific school year</li><li>Create a custom Family Page and donation link to share with family and friends</li><li>Update family or financial information easily</li></ul>'
      },
      {
        question: 'How will I know if my student\'s application was submitted successfully?',
        answer: 'You will receive an email confirmation for each application submitted online. If the application is incomplete or if we have questions, we will contact you by email. You can also view the status of each application on the Scholarships & Applications Dashboard in your Parent Portal. If you do not see the application status change to “Complete” within two weeks of submitting it, please contact us.'
      },
      {
        question: 'What information is available in my student\'s ACSTO Award History?',
        answer: '<p>Parent Portal users who have a current Scholarship Application for their student will receive an email from ACSTO at the end of each award cycle asking them to log in to their portal and check the Award History for any new scholarship awards.</p><p>The ACSTO Award History shows two types of information:</p><ul><li><b>Scholarship Awards - </b> Each award the student received for the past five years is shown along with the date awarded and the Application Year (i.e., school year) it was awarded for. If you need to go back more than five years, call ACSTO for assistance.</li><li><b>Total Funds Sent to School (Net Scholarships) - </b>This is the total amount that ACSTO sent to the school for the Application Year shown.</li></ul><p>The Award History does not show unused scholarships being held by ACSTO for the student\'s future tuition (known as “multi-year scholarships”). Please call ACSTO at 480.820.0403 with multi-year scholarship questions.</p>'
      },
      {
        question: 'Can I see donor recommendations made for my student?',
        answer: '<p>Donor recommendations are not available on the Parent Portal. You may call ACSTO at 480.820.0403 and we would be happy to look up the number and type of recommendations (Original or Overflow) your student has, if any.</p><p>Per the Arizona Department of Revenue as well as federal charitable contribution laws, donor names must be kept confidential.</p><p>Arizona tax credit law prohibits STOs from awarding, designating, or reserving scholarships based solely on a donor\'s recommendation. Therefore, donation amounts for recommendations are not disclosed since there are no guarantees to scholarships that have not been awarded yet.</p>'
      },
      {
        question: 'Is the Parent Portal the only way to apply for scholarships for my student?',
        answer: 'No, if you prefer to a complete a paper copy of the Scholarship Application, <a href="https://acsto.org/parents/apply-now" target="_self">download and complete an application</a> and submit it to us by mail, fax, or email (<a href="mailto:applications@acsto.org">applications@acsto.org</a>). Be sure to include any additional documents requested.'
      },
      {
        question: 'I\'ve only applied to ACSTO by mail, email, or fax in the past. I just created a Parent Portal. Will my student\'s previous application/award history be available on my portal?',
        answer: 'Your student\'s history will appear one business day after we connect your portal account to our database.'
      }
    ];

    vm.profileQs = [
      {
        question: 'How do I change my Parent Portal email?',
        answer: '<ul><li>Log out of your current portal</li><li>At the Parent Portal log in screen, choose "Register" and create a new account with your new email</li><li>Check your email within 24 hours to confirm your new email address</li><li>Log in with your new email AND add your student(s)*</li><li>Allow 1-2 business days for ACSTO to connect your existing account to your new account</li></ul><i>*If you already submitted your student’s Scholarship Application for the current or upcoming school year, you do not need to apply again for these school years. However, you must add your student(s) to your new portal.</i>'
      },
      {
        question: 'How do I change my address, phone number, or password?',
        answer: 'Log in to your Parent Portal and select “Profile” to update your address, phone number, or reset your password.'
      }
    ]

    // clear background pix 
    if (!$auth.isAuthenticated() && ele.hasClass('vegas-container')) {
      ele.vegas('destroy');
    }

  }
})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .factory('NewsFactory', NewsFactory);

  NewsFactory.$inject = ['$http', '$q'];

  /* @ngInject */
  function NewsFactory($http, $q) {
    var service = {
      getNews: getNews
    };
    return service;

    ////////////////


    function getNews(currentPage) {
      var deferred = $q.defer();
      // cancel promise
      // deferred.resolve();

      $http.get('/api/news?page=' + currentPage)
        .then(function(response) {

          // return response.data;
          deferred.resolve(response.data);

        }, function(response) {

          // return response.data;
          deferred.reject(response.data);

        });

      return deferred.promise;
    }



  }
})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .run(appRun);

  /* @ngInject */
  function appRun(routerHelper) {
    routerHelper.configureStates(getStates());
  }

  function getStates() {
    return [{
      state: 'home',
      config: {
        url: '/home',
        templateUrl: 'app/home/home.html',
        controller: 'HomeController',
        controllerAs: 'home'
      }
    }];
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('HomeController', HomeController);


  /* @ngInject */
  function HomeController($auth, $scope, $state, NewsFactory) {
    var vm = this;

    activate();

    ////////////////

    function activate() {

      new WOW().init();

      vm.loading = true;
      vm.currentPage = 1;
      vm.pageTotal = 1;
      vm.numPerPage = 1;

      // vm.convertDate = function(getDate) {
      //   return '(posted ' + moment(getDate).fromNow() + ')';
      // }

      function loadPage() {

        NewsFactory.getNews(vm.currentPage).then(function(data) {

          vm.posts = data.data;
          vm.currentPage = data.current_page;
          vm.pageTotal = data.total;
          vm.numPerPage = data.per_page;
          vm.loading = false;

        });

      }

      loadPage();

      $scope.$watch(function() {
        return vm.currentPage;
      }, function(newVal, oldVal) {

        if (newVal !== oldVal) {
          vm.currentPage = newVal;
          vm.loading = true;
          loadPage();
        }

      });

    }
  }
})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .run(appRun);

  /* @ngInject */
  function appRun(routerHelper) {
    routerHelper.configureStates(getStates());
  }

  function getStates() {
    return [{
      state: 'financial',
      config: {
        url: '/update-financial-information',
        templateUrl: 'app/financial/financial.html',
        controller: 'FinancialController',
        controllerAs: 'vm',
        resolve: { /* @ngInject */
          'stateList': ['DataFactory',
            function(DataFactory) {
              return DataFactory.getState();
            }
          ]
        }
      }
    }];
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('FinancialController', FinancialController);

  FinancialController.$inject = ['$scope','toastr', '$uibModal', 'IncomeFactory', 'locker', '$interval'];

  /* @ngInject */
  function FinancialController($scope, toastr, $uibModal, IncomeFactory, locker, $interval) {
    var vm = this;
    vm.validateIncome = false;
    vm.household = 0;
    vm.incomeLoading = true;
    vm.fincomes = [];
    vm.lastupdated = 'none';
    vm.number_of_household = 0;
    vm.householdNumberError = false;

    vm.periods = {
      1: 'Annually',
      12: 'Monthly',
      24: '2xMonth',
      26: 'EOW',
      52: 'Weekly'
    };

    vm.income = income;
    vm.addIncome = addIncome;
    vm.editTableRow = editTableRow;
    vm.deleteTableRow = deleteTableRow;
    vm.updateAcsto = updateAcsto;
    vm.updateHousehold = updateHousehold;

    ////////////////

    // When income submited
    function income(event) {
      event.preventDefault();

      var $table = angular.element('table');

      vm.validateIncome = true;


      if (vm.household != vm.number_of_household) {
        $uibModal.open({
          templateUrl: 'app/scholarship/edit/alert.html',
          controller: 'AlertController',
          controllerAs: 'vm',
          resolve: { /* @ngInject */
            s: function() {
              return 1;
            }
          }
        });

        return false;
      }

      if ($table.find('tbody td:visible').eq(1).text() === '$ ---') {
        $uibModal.open({
          templateUrl: 'app/scholarship/edit/alert.html',
          controller: 'AlertController',
          controllerAs: 'vm',
          resolve: { /* @ngInject */
            s: function() {
              return 0;
            }
          }
        });
        return false;
      }
    }

    function loadIncome() {
      vm.incomeLoading = true;

      IncomeFactory
        .getIncomes()
        .then(function(data) {
          if (data.incomes) {
            vm.fincomes = data.incomes;
            vm.household = data.incomes.length;
            vm.number_of_household = data.incomes.length;
          }

          // hide loading
          vm.incomeLoading = false;
        }, function(error) {
          // error
        });
    }

    function addIncome() {

      var modalInstance = $uibModal.open({
        templateUrl: 'app/scholarship/income/income.add.html',
        controller: 'AddIncomeController',
        controllerAs: 'vm',
        resolve: {
          ID: function() {
            return '';
          }
        }
      });

      modalInstance.result.then(function(response) {

        vm.fincomes.push(response.income);

        vm.household = (vm.household + 1);
        updateAcsto();

      }, function() {

        // cancel
        // $target.removeClass('warning');
        // $log.log('next function after the modalinstance');

      });
    }

    function editTableRow(income, event) {

      var $target = angular.element(event.target).parent().parent();
      var editIncomeIndex = vm.fincomes.indexOf(income);

      // fix to ensure table row is selected
      if (event.target.nodeName === 'I') {
        $target = $target.parent();
      }

      $target.addClass('info');

      var modalInstance = $uibModal.open({
        templateUrl: 'app/scholarship/income/income.add.html',
        controller: 'AddIncomeController',
        controllerAs: 'vm',
        resolve: {
          ID: function() {
            return income.id;
          }
        }
      });

      modalInstance.result.then(function(response) {

        // $log.log('response.income', response.income);
        vm.fincomes[editIncomeIndex] = response.income;
        updateAcsto();

      }, function() {

        $target.removeClass('info');

      });
    }

    function deleteTableRow(income, event) {

      var $target = angular.element(event.target).parent().parent();

      // fix to ensure table row is selected
      if (event.target.nodeName === 'I') {
        $target = $target.parent();
      }

      $target.addClass('danger');

      var modalInstance = $uibModal.open({
        templateUrl: 'app/confirm.html',
        controller: 'IncomeConfirmController',
        controllerAs: 'vm',
        resolve: { /* @ngInject */
          incomename: function() {
            return income.name;
          }
        }
      });


      modalInstance.result.then(function(response) {

        if (response.status) {

          IncomeFactory.deleteIncome(income.id)
            .then(function(data) {

              if (data) {
                vm.household = (vm.household - 1);
                vm.fincomes.splice(vm.fincomes.indexOf(income), 1);
                toastr.success('Income deleted successfully', 'Success');
                updateAcsto();
              }

            }, function() {

              toastr.error('There were issues adding the Parent information', 'Failed to Update');

            });

        }

        $target.removeClass('danger');
        updateTimestamp();

      }, function() {

        // if cancelled
        $target.removeClass('danger');

      });
    }

    // Load income
    loadIncome();

    var timer;
    function updateTimer(updated_at) {
      if (timer) {
        $interval.cancel(timer);
      }

      timer = $interval(function() {
        vm.lastupdated = moment(updated_at).fromNow();
      }, 60000);
    }

    function updateTimestamp() {
      IncomeFactory
      .getFinacialTimestamp()
      .then(function(data) {
        var updated_at = '';

        if (data) {
          updated_at = data.finacial.updated_at;
        }

        vm.lastupdated = moment(updated_at).fromNow();
        updateTimer(updated_at);
      });
    }

    updateTimestamp();

    function updateAcsto() {
      IncomeFactory
      .updateAcsto()
      .then(function(data) {
        if (data) {
          toastr.clear();
          toastr.success('You have successfully notified ACSTO changes in your Income.', 'Success');
          vm.updateHousehold();
          vm.lastupdated = moment().fromNow();
          updateTimer(moment.utc());
        }
      }, function(err) {

        toastr.error('Could not notify ACSTO income update.', 'Failed to Notify ACSTO');

      });
    }

    function updateHousehold() {
      if (vm.household != vm.number_of_household || vm.household < 2 && !vm.isFosterChild) {
        vm.householdNumberError = true;
        $scope.scholarship.number_of_household.$setValidity('number_of_household', false);
      } else {
        $scope.scholarship.number_of_household.$setValidity('number_of_household', true);
        vm.householdNumberError = false;
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('acstoparent')
        .run(appRun);

    /* @ngInject */
    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [{
            state: 'customlink',
            config: {
                url: '/create-custom-donation-link',
                templateUrl: 'app/customlink/customlink.html',
                controller: 'CustomlinkController',
                controllerAs: 'vm'
            }
        }];
    }

})();

(function () {
    'use strict';

    angular
        .module('acstoparent')
        .controller('CustomlinkController', CustomlinkController);

    CustomlinkController.$inject = ['$document'];

    /* @ngInject */
    function CustomlinkController($document) {
        var vm = this;
        vm.customUrl = '';
        vm.copyStatus = 'Copy URL';

        vm.copyToClipboard = function() {
          if (vm.customUrl) {
            var copyElement = $document[0].createElement("textarea");
            copyElement.style.position = 'fixed';
            copyElement.style.opacity = '0';
            copyElement.textContent = vm.customUrl;
            var body = $document[0].getElementsByTagName('body')[0];
            body.appendChild(copyElement);
            copyElement.select();
            $document[0].execCommand('copy');
            body.removeChild(copyElement);
            vm.copyStatus = 'Copied!';
          }
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('acstoparent')
    .run(appRun);

  /* @ngInject */
  function appRun(routerHelper) {
    routerHelper.configureStates(getStates());
  }

  function getStates() {
    return [{
      state: 'contact',
      config: {
        url: '/contact',
        templateUrl: 'app/contact/contact.html',
        controller: 'ContactController',
        controllerAs: 'vm',
        data: {}
      }
    }];
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .factory('EmailFactory', EmailFactory);

  EmailFactory.$inject = ['$http'];

  /* @ngInject */
  function EmailFactory($http) {
    var service = {
      sendEmail: sendEmail
    };
    return service;

    ////////////////

    function sendEmail(payload) {
      return $http.post('/api/contact', payload);
    }

  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .controller('ContactController', ContactController);

  ContactController.$inject = ['$scope', '$state', '$uibModal', '$filter', 'toastr', 'ResourceFactory', 'EmailFactory', 'DataFactory', '$log', '$sanitize', 'locker'];

  /* @ngInject */
  function ContactController($scope, $state, $uibModal, $filter, toastr, ResourceFactory, EmailFactory, DataFactory, $log, $sanitize, locker) {
    var vm = this;
    var original = angular.copy(vm.contact);
    vm.parents = '';
    vm.validateContact = false;
    vm.contact = angular.fromJson(locker.get('user'));


    activate();

    ////////////////

    function activate() {

      if (vm.contact.parent_phone) {

        vm.contact.parent_phone = $filter('tel')(vm.contact.parent_phone);

      }


      // $log.log(vm.contact);
      // $log.log('vm.parents',vm.parents);

      vm.sendEmail = function() {

        vm.validateContact = true;

        if ($scope.contactus.$invalid) {
          toastr.clear();
          toastr.warning('All fields are required', 'Warning');
          return false;
        }

        toastr.info('Please wait this may take a few moments', 'Saving data...', {
          timeOut: 0
        });


        EmailFactory.sendEmail({

          first_name: $sanitize(vm.contact.parent_first_name),
          last_name: $sanitize(vm.contact.parent_last_name),
          email: vm.contact.email,
          phone: vm.contact.parent_phone,
          comment: vm.comment

        }).then(function(response) {

          toastr.clear();

          if (response.status === 200) {
            vm.contact = angular.copy(original);
            vm.comment = '';
            $scope.contactus.comment.$setPristine();
            $scope.contactus.comment.$setValidity();

            toastr.success('Email has been sent successfully', 'Email Sent', {
              timeOut: 10000
            });

            $state.go('scholarship.dashboard');

          }



        }, function() {

          toastr.clear();
          toastr.error('There was an issue sending your email please try again later', 'Failed');

        });


      };

    }
  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .run(runBlock);

  runBlock.$inject = ['$rootScope', '$state', '$interval', '$http', '$auth', 'locker', '$timeout', '$uibModal'];

  /** @ngInject */
  function runBlock($rootScope, $state, $interval, $http, $auth, locker, $timeout, $uibModal) {

    // $rootScope.$on("$stateChangeError", $log.log.bind(console));

    // $log.log(angular.toJson($state.get()));

    // scroll to top on every load
    $rootScope.$on('$viewContentLoaded', function() {

      var interval = setInterval(function() {
        if (document.readyState == "complete") {
          window.scrollTo(0, 0);
          clearInterval(interval);
        }
      }, 200);

      if (localStorage.getItem('language') && localStorage.getItem('language') === 'es') {
        $uibModal.open({
          templateUrl: 'app/components/spanishModal/spanishModal.html',
          controller: 'SpanishModal',
          controllerAs: 'vm',
        })
        localStorage.removeItem('language');
      }
    });


    // $rootScope.$on('$stateNotFound',
    //   function(event, unfoundState, fromState, fromParams) {
    //     $log.log(unfoundState.to); // "lazy.state"
    //     $log.log(unfoundState.toParams); // {a:1, b:2}
    //     $log.log(unfoundState.options); // {inherit:false} + default options
    //   });
    $rootScope.$on('$stateChangeStart', function(event, toState) {

      // $log.log('toState', toState);

      if (
        toState.name != 'login' &&
        toState.name != 'faq' &&
        toState.name != 'register' &&
        toState.name != 'passwordreset' &&
        toState.name !== 'sendConfirmation' &&
        toState.name !== 'sendResetPW' &&
        !$auth.isAuthenticated()
      ) {

        event.preventDefault();
        // localStorage.removeItem('user');
        locker.empty();
        $rootScope.authenticated = false;
        $rootScope.loggedin = false;
        $rootScope.currentUser = null;
        return $state.go('login');

      }

      if ($auth.isAuthenticated()) {
        // Grab the user from local storage and parse it to an object
        // var user = JSON.parse(localStorage.getItem('user'));
        // var user = locker.get('user');
        var user = angular.toJson(locker.get('user'));
        var $elem = angular.element('body');

        // If there is any user data in local storage then the user is quite
        // likely authenticated. If their token is expired, or if they are
        // otherwise not actually authenticated, they will be redirected to
        // the auth state because of the rejected request anyway
        if (user) {

          // The user's authenticated state gets flipped to
          // true so we can now show parts of the UI that rely
          // on the user being logged in
          $rootScope.authenticated = true;

          // Putting the user's data on $rootScope allows
          // us to access it anywhere across the app. Here
          // we are grabbing what is in local storage
          $rootScope.currentUser = user;

          // If the user is logged in and we hit the auth route we don't need
          // to stay there and can send the user to the main state
          if (toState.name === 'login') {

            // Preventing the default behavior allows us to use $state.go
            // to change states
            event.preventDefault();

            // go to the "main" state which in our case is users
            $state.go('scholarship.dashboard');

            // make sure vegas is destroyed
            $timeout(function() {
              if ($elem.hasClass('vegas-container')) {
                $elem.vegas('destroy');
              }
            }, 3000);

          }
        }

        // if (toState.name != 'login' && !$auth.isAuthenticated()) {
        //   event.preventDefault();
        //   return $state.go('login');
        // }
      }

    });

    var timer;

    function start() {
      stop();
      // timer = $interval(updateToken, 1740000); //29mins
      timer = $interval(updateToken, 3600000); //1200000 20mins  3600000 1hour
      // timer = $interval(updateToken, 600000); // 10 mins
      // timer = $interval(updateToken, 15000);
    }

    function stop() {
      $interval.cancel(timer);
    }

    function updateToken() {


      $http.get('api/authenticate/refresh')
        .then(function(response) {

          var currentToken = '',
            refreshToken = '';

          // $log.log('token refresh', response);

          currentToken = $auth.getToken();
          refreshToken = response.headers('Authorization');

          if (currentToken != refreshToken && refreshToken) {
            $auth.setToken(refreshToken.replace('Bearer ', ''));
          }


        }, function(response) {

          // $log.info(response.config);
          // $log.error('response', response);

          if (response.status === 401) {
            $state.go('login'); //have user log back in
          }


        });



    }

    // refresh token
    $rootScope.$watch(function() {

      return $auth.isAuthenticated();

    }, function(newValue) {

      if (newValue) {
        start();
      } else {
        stop();
      }

    });


  }

})();
/* global WOW:false, moment:false */
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .constant('WOW', WOW)
    .constant('moment', moment);

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .config(config);

  config.$inject = ['$logProvider',
    'toastrConfig',
    '$locationProvider',
    '$authProvider',
    '$stateProvider',
    '$urlRouterProvider',
    '$httpProvider',
    '$provide',
    'lockerProvider'
  ];

  /** @ngInject */
  function config($logProvider,
    toastrConfig,
    $locationProvider,
    $authProvider,
    $stateProvider,
    $urlRouterProvider,
    $httpProvider,
    $provide,
    lockerProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 4000;
    // toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.positionClass = 'toast-top-full-width';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = false;

    // states.forEach($stateProvider.state);

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {

      if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
      }
      $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
      $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
      $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';

    }

    lockerProvider.defaults({
      // driver: 'session',
      driver: 'local',
      namespace: 'acstoparent'
    });

    // Facebook
    // $authProvider.facebook({
    //   clientId: '1533268960297706',
    //   url: '/auth/facebook',
    //   authorizationEndpoint: 'https://www.facebook.com/v2.3/dialog/oauth',
    //   redirectUri: (window.location.origin || window.location.protocol + '//' + window.location.host) + '/',
    //   requiredUrlParams: ['display', 'scope'],
    //   scope: ['email'],
    //   scopeDelimiter: ',',
    //   display: 'popup',
    //   type: '2.0',
    //   popupOptions: {
    //     width: 580,
    //     height: 400
    //   }
    // });

    // Google
    // $authProvider.google({
    //   clientId: '905789819989-q7nnrttl0u0dhv2svjpo1n55er1mkdke.apps.googleusercontent.com',
    //   url: '/auth/google',
    //   authorizationEndpoint: 'https://accounts.google.com/o/oauth2/auth',
    //   redirectUri: window.location.origin || window.location.protocol + '//' + window.location.host,
    //   requiredUrlParams: ['scope'],
    //   optionalUrlParams: ['display'],
    //   scope: ['profile', 'email'],
    //   scopePrefix: 'openid',
    //   scopeDelimiter: ' ',
    //   display: 'popup',
    //   type: '2.0',
    //   popupOptions: {
    //     width: 452,
    //     height: 633
    //   }
    // });

    function getParameterByName(name, url) {
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    const languageQueryParam = getParameterByName('lang', window.location) || '';
    if (languageQueryParam === 'es') {
      localStorage.setItem('language', languageQueryParam);
    }


    function redirectWhenLoggedOut($q, $injector) {

      return {

        responseError: function(rejection) {

          // Need to use $injector.get to bring in $state or else we get
          // a circular dependency error
          var $state = $injector.get('$state');
          var locker = $injector.get('locker');
          var $rootScope = $injector.get('$rootScope');

          // Instead of checking for a status code of 400 which might be used
          // for other reasons in Laravel, we check for the specific rejection
          // reasons to tell us if we need to redirect to the login state
          var rejectionReasons = ['token_not_provided', 'token_expired', 'token_absent', 'token_invalid', 'Unauthorized'];

          // Loop through each rejection reason and redirect to the login
          // state if one is encountered
          angular.forEach(rejectionReasons, function(value) {

            // Failed to authenticate because of bad credentials or an invalid authorization header.
            if ((rejection.data.error || rejection.statusText) === value) {

              // If we get a rejection corresponding to one of the reasons
              // in our array, we know we need to authenticate the user so 
              // we can remove the current user from local storage
              // localStorage.removeItem('user');
              locker.clean();
              $rootScope.authenticated = false;
              $rootScope.loggedin = false;

              // Remove the current user info from rootscope
              $rootScope.currentUser = null;

              // Send the user to the auth state so they can login
              $state.go('login');
            }
          });

          return $q.reject(rejection);
        }
      };
    }

    // Setup for the $httpInterceptor
    $provide.factory('redirectWhenLoggedOut', redirectWhenLoggedOut);


    /*
    var interceptor = ['$rootScope', '$q', function (scope, $q) {

        function success(response) {
            return response;
        }

        function error(response) {
            var status = response.status;

            if (status == 401) {
                window.location = "./index.html";
                return;
            }
            // otherwise
            return $q.reject(response);

        }

        return function (promise) {
            return promise.then(success, error);
        }

    }];
    $httpProvider.responseInterceptors.push(interceptor);
    */

    // Push the new factory onto the $http interceptor array
    $httpProvider.interceptors.push('redirectWhenLoggedOut');

    $authProvider.loginUrl = '/api/authenticate';

    $urlRouterProvider.otherwise('/auth/login');


  }

})();
(function() {
  'use strict';

  angular
    .module('acstoparent')
    .factory('DataFactory', DataFactory);

  /** @ngInject */
  function DataFactory($http) {
    var service = {
      getState: getState,
      setState: setState,
      getSchool: getSchool,
      setSchool: setSchool,
      getStos: getStos,
      getChildren: getChildren,
      setChildren: setChildren
    };

    var data = {
      user: {},
      state: {},
      school: {},
      children: {}
    };
    return service;

    ////////////////

    // getter

    function getState() {

      return $http.get('api/states');

    }

    function getSchool() {

      return $http.get('api/schools');

    }

    function getStos() {

      return $http.get('api/stos');

    }

    function getChildren() {
      return data.children;
    }


    // set


    function setState() {
      data.state = $http.get('api/states');
    }

    function setSchool() {
      data.school = $http.get('api/schools');
    }


    function setChildren(profile) {
      data.children = profile;
    }
  }
})();

angular.module("acstoparent").run(["$templateCache", function($templateCache) {$templateCache.put("app/confirm.html","<div class=\"modal-header\"><h3 class=\"modal-title\">{{ vm.title }}</h3></div><div class=\"modal-body\" ng-class=\"vm.popClass\" ng-bind-html=\"vm.msg\"></div><div class=\"modal-footer\"><button class=\"btn btn-link\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button> <button class=\"btn btn-danger\" type=\"button\" ng-click=\"vm.ok()\">OK</button></div>");
$templateCache.put("app/faq/faq.html","<div class=\"row\"><div class=\"col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3\"><div class=\"panel panel-default\"><div class=\"panel-heading text-center\"><a ng-hide=\"authenticated\" href=\"https://acsto.org\"><img src=\"/img/acsto2.png\"></a><h1 class=\"wow fadeIn\" data-wow-duration=\"1.5s\">FAQ - Parent Portal</h1></div><div class=\"panel-body\"><div ng-hide=\"authenticated\"><a ui-sref=\"login\" class=\"btn btn-primgary\">Return to Login</a></div><div id=\"faq\"><h3>Registration/Log In Questions</h3><hr><dl class=\"fade in\" ng-repeat=\"question in vm.registrationQs\"><dt ng-bind-html=\"question.question\"><i class=\"fa fa-question-circle text-danger\"></i> {{ question.question }}</dt><dd ng-bind-html=\"question.answer\"><i class=\"fa fa-check-circle text-success\"></i> {{ question.answer }}</dd></dl><h3>Application & Scholarship Questions</h3><hr><dl class=\"fade in\" ng-repeat=\"question in vm.scholarshipQs\"><dt ng-bind-html=\"question.question\"><i class=\"fa fa-question-circle text-danger\"></i> {{ question.question }}</dt><dd ng-bind-html=\"question.answer\"><i class=\"fa fa-check-circle text-success\"></i> {{ question.answer }}</dd></dl><h3>Profile Questions</h3><hr><dl class=\"fade in\" ng-repeat=\"question in vm.profileQs\"><dt ng-bind-html=\"question.question\"><i class=\"fa fa-question-circle text-danger\"></i> {{ question.question }}</dt><dd ng-bind-html=\"question.answer\"><i class=\"fa fa-check-circle text-success\"></i> {{ question.answer }}</dd></dl></div><div ng-show=\"results.length == 0\" class=\"alert alert-warning\" role=\"alert\"><h3><i class=\"fa fa-exclamation-circle\"></i> No results found...</h3><h4>Please contact us for more information</h4><ul class=\"list-unstyled\"><li><i class=\"fa fa-phone\"></i> 480.820.0403</li><li><i class=\"fa fa-fax\"></i> 480.820.2027</li><li><i class=\"fa fa-envelope\"></i> <a href=\"mailto:social@acsto.org\" title=\"email us\">social@acsto.org</a></li></ul></div></div><div class=\"panel-footer\" ng-hide=\"authenticated\"><a ui-sref=\"login\" class=\"btn btn-primgary\">Return to Login</a></div></div></div></div>");
$templateCache.put("app/contact/contact.html","<div class=\"row\"><div class=\"col-sm-offset-2 col-sm-8\"><div class=\"page-header\"><h1><i class=\"fa fa-comment-o\"></i>Contact Us</h1></div><div class=\"row\"><div class=\"col-sm-6\"><address><h2>ACSTO, Inc.</h2>PO Box 6580<br>Chandler, AZ 85246<br><a href=\"https://acsto.org\" title=\"Arizona Christian School Tuition Organization\" target=\"_blank\"><i class=\"fa fa-share\"></i>Back to ACSTO.org</a><br><abbr title=\"Phone\"><i class=\"fa fa-phone\"></i></abbr>480.820.0403<br><abbr title=\"Fax\"><i class=\"fa fa-fax\"></i></abbr>480.820.2027</address></div><div class=\"col-sm-6\"><address><h2>Hours:</h2>M-F 9:00 am - 12:00 pm<br>M-F 1:00 pm - 4:00 pm</address></div></div><form name=\"contactus\" role=\"form\" method=\"POST\" class=\"last-element\" novalidate=\"\"><div class=\"form-group row\" ng-class=\"{ \'has-error\' : contactus.first_name.$error.required && contactus.first_name.$dirty || contactus.first_name.$invalid && vm.validateContact }\"><label class=\"col-md-4 control-label\" for=\"first_name\"><span class=\"text-danger\">*</span>First Name(s)</label><div class=\"col-md-8\"><input ng-model=\"vm.contact.parent_first_name\" class=\"form-control input-md\" placeholder=\"First name(s)\" name=\"first_name\" type=\"text\" value=\"\" required=\"\"> <span class=\"help-block\" ng-show=\"( contactus.first_name.$error.required && contactus.first_name.$dirty || contactus.first_name.$invalid && vm.validateContact )\"><p class=\"text-danger\">This field is required.</p></span></div></div><div class=\"form-group row\" ng-class=\"{ \'has-error\' : contactus.last_name.$error.required && contactus.last_name.$dirty || contactus.last_name.$invalid && vm.validateContact }\"><label class=\"col-md-4 control-label\" for=\"last_name\"><span class=\"text-danger\">*</span>Last Name</label><div class=\"col-md-8\"><input ng-model=\"vm.contact.parent_last_name\" class=\"form-control input-md\" placeholder=\"Last name\" name=\"last_name\" type=\"text\" value=\"\" required=\"\"> <span class=\"help-block\" ng-show=\"( contactus.last_name.$error.required && contactus.last_name.$dirty || contactus.last_name.$invalid && vm.validateContact )\"><p class=\"text-danger\">This field is required.</p></span></div></div><div class=\"form-group row\" ng-class=\"{ \'has-error\' : contactus.email.$error.required && contactus.email.$dirty || contactus.email.$invalid && vm.validateContact }\"><label class=\"col-md-4 control-label\" for=\"email\"><span class=\"text-danger\">*</span>Email</label><div class=\"col-md-8\"><input ng-model=\"vm.contact.email\" class=\"form-control input-md\" placeholder=\"Email\" name=\"email\" type=\"email\" value=\"\" required=\"\"> <span class=\"help-block\" ng-show=\"( contactus.email.$error.required && contactus.email.$dirty || contactus.email.$invalid && vm.validateContact )\"><p class=\"text-danger\">This field is required.</p></span></div></div><div class=\"form-group row\" ng-class=\"{ \'has-error\' : contactus.phone.$error.required && contactus.phone.$dirty || contactus.phone.$invalid && vm.validateContact }\"><label class=\"col-md-4 control-label\" for=\"phone\">Phone</label><div class=\"col-md-8\"><input ng-model=\"vm.contact.parent_phone\" ng-blur=\"vm.contact.parent_phone\" class=\"form-control input-md phone\" id=\"parent_phone\" placeholder=\"Phone\" maxlength=\"20\" name=\"phone\" type=\"text\" value=\"\" format-phone=\"\" required=\"\"> <span class=\"help-block\" ng-show=\"( contactus.phone.$error.required && contactus.phone.$dirty || contactus.phone.$invalid && vm.validateContact )\"><p class=\"text-danger\">This field is required.</p></span></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : contactus.comment.$error.required && contactus.comment.$dirty || contactus.comment.$invalid && vm.validateContact }\"><label for=\"comment\" class=\"sr-only\"><span class=\"text-danger\">*</span>Comment/Question</label> <textarea ng-model=\"vm.comment\" class=\"form-control input-md\" placeholder=\"Send us your comment or question.\" name=\"comment\" cols=\"50\" rows=\"10\" required=\"\">\n		</textarea> <span class=\"help-block\" ng-show=\"( contactus.comment.$error.required && contactus.comment.$dirty || contactus.comment.$invalid && vm.validateContact )\"><p class=\"text-danger\">This field is required.</p></span></div><button ng-click=\"vm.sendEmail($event)\" type=\"button\" class=\"btn btn-primary\"><i class=\"fa fa-envelope-o\"></i>Send email</button></form></div></div>");
$templateCache.put("app/customlink/customlink.html","<article class=\"container\"><div class=\"row\"><div class=\"page-header\"><h1>Create Custom Donation Link</h1></div><div class=\"col-md-2\"><div ng-include=\"\'app/components/navbar/scholarship.navbar.html\'\"></div></div><div class=\"col-md-10\"><h4>Make Donating Even Easier!</h4><p>A Custom Donation Link works like the donation button on your ACSTO Family Page but can be sent to family and friends who prefer to go directly to the ACSTO Donor Portal to donate and recommend your student(s) for scholarships.</p><p>You may enter multiple student names in the <strong>Student Recommendation</strong> fields below, however, you may only identify one school. If your students attend different Christian Schools, please select one school from the list. ACSTO will ensure that donor recommendations are split between your students, regardless of which school is identified.</p><p>After completing the form, click “Copy URL” to share your donation link with family and friends.</p><div custom-link-inputs=\"\" show-reset-form-btn=\"true\" generated-url=\"vm.customUrl\"></div><br><div class=\"form-group\"><label for=\"url\">Custom URL</label><div class=\"row\"><div class=\"col-md-9 col-sm\"><textarea name=\"url\" type=\"text\" class=\"form-control\" id=\"url\" placeholder=\"Your custom URL will be generated here once the required fields are filled in.\" readonly=\"\" ng-model=\"vm.customUrl\" ng-click=\"vm.copyToClipboard()\">\n                </textarea></div><div class=\"col-md-3 col-sm\"><button type=\"button\" id=\"create-custom-link\" ng-click=\"vm.copyToClipboard()\" class=\"btn btn-info inline-button\">{{ vm.copyStatus }}</button></div></div></div></div></div></article>");
$templateCache.put("app/home/home.html","<div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"page-header\"><h1>Home</h1></div></div></div><div class=\"row\"><div class=\"col-md-7\"><h2>ACSTO Calendar</h2><div class=\"embed-responsive embed-responsive-16by9\"><iframe class=\"embed-responsive-item\" src=\"//www.google.com/calendar/embed?src=acstoconnect%40gmail.com&amp;showTitle=0&amp;height=600&amp;wkst=1&amp;bgcolor=%23FFFFFF&amp;ctz=America%2FPhoenix&amp;mode=AGENDA\"></iframe></div></div><div class=\"col-md-5\"><h2>Latest News</h2><div ng-show=\"home.loading\" class=\"text-center\"><i class=\"fa fa-refresh fa-spin fa-4x\"></i></div><section ng-repeat=\"post in home.posts\" class=\"panel panel-default wow fadeIn\"><div class=\"panel-heading\"><h4>{{ post.headline }} <small>(posted {{ post.date | fromNow }})</small></h4></div><div class=\"panel-body\"><p>{{ post.caption }}</p><p ng-bind-html=\"post.content\"></p></div></section><footer><div class=\"text-center last-element\"><uib-pagination ng-model=\"home.currentPage\" total-items=\"home.pageTotal\" max-size=\"8\" items-per-page=\"home.numPerPage\" ng-hide=\"home.pageTotal == home.numPerPage\" boundary-links=\"true\" class=\"uib-pagination-sm\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" rotate=\"false\"></uib-pagination></div></footer></div></div></div>");
$templateCache.put("app/financial/financial.html","<article class=\"container\"><div class=\"row\"><div class=\"page-header\"><h1>Update Financial Information</h1></div><div class=\"col-md-2\"><div ng-include=\"\'app/components/navbar/scholarship.navbar.html\'\"></div></div><div class=\"col-md-10\"><form name=\"scholarship\" class=\"form-horizontal scholarship\" role=\"form\" method=\"POST\" novalidate=\"\"><div class=\"panel panel-primary\"><div class=\"panel-body\"><div class=\"alert alert-acsto-secondary\"><strong>IMPORTANT!</strong> If you have already submitted a <strong>current application</strong> for your student(s) and need to <strong>update</strong> the Financial Information you provided, please use the form below. If you do not have a current application on file yet, DO NOT use the following form. Instead, select \"Apply\" in the left column to begin the application process. A new application is required per student each school year.</div><div class=\"alert alert-info\" role=\"alert\"><h3>INSTRUCTIONS:</h3><p><strong>Income information is a required part of the application process. If you do not report income, we cannot consider your child(ren) for any scholarships.</strong></p><p><em>We determine financial circumstances based on the USDA\'s definition of household income.&nbsp;<u>A <strong>household</strong> is a group of related or unrelated individuals who share housing, income, and expenses.</u>&nbsp;You do not have to list those who are economically independent from you or their dependents, even if you share housing.</em></p><p><em>Include <strong>all</strong> household members below, <strong>including children, students away at college, and individuals without income</strong>. Processing delays can occur for applications containing incomplete Financial Info Forms.</em></p><p ng-if=\"vm.displayIncomeYearlyUpdate\"><small>As of February 2017, ACSTO processes all financial income on an annual basis. If you’re reapplying for the \'17-\'18 school year, as a courtesy to you, we\'ve converted your financial data from last year to reflect this change. Please confirm that your information is correct.</small></p></div><button ng-hide=\"vm.isFosterChild\" ng-click=\"vm.addIncome($event)\" class=\"btn btn-info\">Add Household Member</button><div class=\"form-group\" ng-class=\"{ \'has-error\': vm.householdNumberError || scholarship.number_of_household.$touched && scholarship.number_of_household.$invalid || scholarship.number_of_household.$invalid }\"><br><label for=\"number_of_household\" class=\"control-label\">Number of People Living in Household:</label> <input ng-model=\"vm.number_of_household\" ng-readonly=\"vm.isFosterChild\" min=\"vm.isFosterChild ? 1 : 2\" ng-change=\"vm.updateHousehold()\" name=\"number_of_household\" type=\"number\" class=\"form-control\" placeholder=\"Total # of household\" required=\"\"><div class=\"help-block text-error\" ng-messages=\"scholarship.number_of_household.$error\" ng-if=\"scholarship.number_of_household.$touched || scholarship.number_of_household.$invalid || vm.householdNumberError\"><p ng-message=\"required\">Number of people living in household is required.</p><p ng-message=\"min\">The minimum number of people living in household is {{ vm.isFosterChild ? 1 : 2 }}.</p></div><div class=\"help-block text-error\" ng-if=\"vm.householdNumberError && vm.number_of_household && vm.number_of_household !== 0\">Entries do not match the total number in household. Please include everyone in your household, including children and those away at college, even if they do not have income.</div></div><p class=\"visible-xs-block alert alert-info\"><i class=\"fa fa-info-circle\"></i>Swipe left or right to see additional details.</p><div class=\"table-responsive\"><table ng-hide=\"vm.isFosterChild\" id=\"income\" class=\"table table-condensed\"><thead><tr><th><a href=\"#\" uib-tooltip=\"Family Name(s)\">Name</a></th><th><a href=\"#\" uib-tooltip=\"Earnings from Work\">Work</a></th><th><a href=\"#\" uib-tooltip=\"Welfare; Child Support; Spousal Maintenance\">Support</a></th><th><a href=\"#\" uib-tooltip=\"Pension; Retirement; Social Security\">Retirement</a></th><th><a href=\"#\" uib-tooltip=\"Other Income\">Other</a></th><th><a href=\"#\" uib-tooltip=\"Edit or Delete Income\">Edit/Delete</a></th></tr></thead><tbody><tr><div ng-show=\"incomeLoading\" class=\"text-center ng-scope ng-hide\" aria-hidden=\"true\"><i class=\"fa fa-refresh fa-spin fa-3x\"></i></div></tr><tr ng-repeat=\"income in vm.fincomes | orderBy:\'fname\'\"><td>{{ income.name }}</td><td>{{ income.work * income.work_frequency | currency:\"$\":0 }} Annually</td><td>{{ income.support * income.support_frequency | currency:\"$\":0 }} Annually</td><td>{{ income.retirement * income.retirement_frequency | currency:\"$\":0 }} Annually</td><td>{{ income.other * income.other_frequency | currency:\"$\":0 }} Annually</td><td><button type=\"button\" ng-click=\"vm.editTableRow(income, $event)\" popover-trigger=\"mouseenter\" class=\"btn btn-info btn-circle btn-xs\" popover-placement=\"top\" uib-popover=\"Edit Income\"><i class=\"fa fa-pencil\"></i></button> <button type=\"button\" ng-click=\"vm.deleteTableRow(income, $event)\" popover-trigger=\"mouseenter\" class=\"btn btn-danger btn-circle btn-xs\" popover-placement=\"top\" uib-popover=\"Delete Income\"><i class=\"fa fa-user-times\"></i></button></td></tr></tbody></table><div class=\"alert alert-success\" role=\"alert\"><p>Update Financial Information<br>Updated {{ vm.lastupdated }}</p></div></div><div class=\"panel-footer clearfix\"><h3>FAQ:</h3><dl><dt>What counts as income?</dt><dd>Income information is a required part of the application process. If you do not report income, we cannot consider your child(ren) for any scholarships.</dd><dt>Names:</dt><dd>List the first and last name of <strong>every</strong> person living in your household. <strong>Include adults and children.</strong></dd><dt>Gross Income and Frequency:</dt><dd>List gross income from work (wages, salaries, tips, commissions). This is not the same as take-home pay. It is the amount earned before taxes and deductions. It should be listed on your pay stub. If self-employed, you may report income after expenses (your own business, freelance work, farm, or rental property).</dd><dt>Welfare, Child Support, Spousal Maintenance:</dt><dd>Include TANF, General Assistance, General Relief, etc. NOTE: <em>Food stamps and FDPIR benefits are not included as income.</em></dd><dt>Pensions, Retirement, Social Security:</dt><dd>Include Supplemental Security Income (SSI), Veteran\'s (VA) benefits, and disability benefits.</dd><dt>All Other Income:</dt><dd>Include workers\' compensation, unemployment, strike benefits, net rental income, annuities, net royalties, interest, dividend income, cash withdrawn from savings, income from estates, trust and/or investments, regular contributions from people who do not live in your household, and <strong>any other income</strong>. If you are in the military, you do <em>not</em> have to include combat pay as income.</dd></dl></div></div></div></form></div></div></article>");
$templateCache.put("app/literature/literature.html","<div class=\"row\"><div class=\"col-sm-offset-2 col-sm-8\"><div class=\"page-header\"><h1>Brochures</h1></div><form name=\"literature\" role=\"form\" method=\"POST\" class=\"last-element\" novalidate=\"\"><p>The following ACSTO brochures are available to print or download from the <a href=\"https://acsto.org/parents/resources\">Parents/Resources</a> page of our website:</p><ul><li>Donation Brochures</li><li>Charitable Giving/Out of State Donation Brochures</li></ul><p>If you prefer to have brochures mailed to you, please submit the form below.</p><br><hr><h4>Shipping Address</h4><br><div class=\"form-group row\" ng-class=\"{ \'has-error\' : literature.first_name.$error.required && literature.first_name.$dirty || literature.first_name.$invalid && validateLiterature }\"><label class=\"col-md-4 control-label\" for=\"first_name\"><span class=\"text-danger\">*</span>First Name(s)</label><div class=\"col-md-8\"><input ng-model=\"lit.first_name\" class=\"form-control input-md\" placeholder=\"First name(s)\" name=\"first_name\" type=\"text\" value=\"\" required=\"\"> <span class=\"help-block\" ng-show=\"( literature.first_name.$error.required && literature.first_name.$dirty || literature.first_name.$invalid && validateLiterature )\"><p class=\"text-danger\">This field is required.</p></span></div></div><div class=\"form-group row\" ng-class=\"{ \'has-error\' : literature.last_name.$error.required && literature.last_name.$dirty || literature.last_name.$invalid && validateLiterature }\"><label class=\"col-md-4 control-label\" for=\"last_name\"><span class=\"text-danger\">*</span>Last Name</label><div class=\"col-md-8\"><input ng-model=\"lit.last_name\" class=\"form-control input-md\" placeholder=\"Last name\" name=\"last_name\" type=\"text\" value=\"\" required=\"\"> <span class=\"help-block\" ng-show=\"( literature.last_name.$error.required && literature.last_name.$dirty || literature.last_name.$invalid && validateLiterature )\"><p class=\"text-danger\">This field is required.</p></span></div></div><div class=\"form-group row\" ng-class=\"{ \'has-error\' : literature.address.$error.required && literature.address.$dirty || literature.address.$invalid && validateLiterature }\"><label class=\"col-md-4 control-label\" for=\"address\"><span class=\"text-danger\">*</span>Address</label><div class=\"col-md-8\"><input ng-model=\"lit.address\" class=\"form-control input-md\" placeholder=\"Address\" name=\"address\" type=\"text\" value=\"\" required=\"\"> <span class=\"help-block\" ng-show=\"( literature.address.$error.required && literature.address.$dirty || literature.address.$invalid && validateLiterature )\"><p class=\"text-danger\">This field is required.</p></span></div></div><div class=\"form-group row\" ng-class=\"{ \'has-error\' : literature.city.$error.required && literature.city.$dirty || literature.city.$invalid && validateLiterature }\"><label class=\"col-md-4 control-label\" for=\"city\"><span class=\"text-danger\">*</span>City</label><div class=\"col-md-8\"><input ng-model=\"lit.city\" class=\"form-control input-md\" placeholder=\"City\" name=\"city\" type=\"text\" value=\"\" required=\"\"> <span class=\"help-block\" ng-show=\"( literature.city.$error.required && literature.city.$dirty || literature.city.$invalid && validateLiterature )\"><p class=\"text-danger\">This field is required.</p></span></div></div><div class=\"form-group row\" ng-class=\"{ \'has-error\' : literature.state.$error.required && literature.state.$dirty || literature.state.$invalid && validateLiterature }\"><label class=\"col-md-4 control-label\" for=\"state\"><span class=\"text-danger\">*</span>State</label><div class=\"col-md-8\"><select ng-model=\"lit.state\" ng-options=\"state.value for state in lit.states track by state.value\" class=\"form-control input-md\" name=\"state\" required=\"\"></select><span class=\"help-block\" ng-show=\"( literature.state.$error.required && literature.state.$dirty || literature.state.$invalid && validateLiterature )\"><p class=\"text-danger\">This field is required.</p></span></div></div><div class=\"form-group row\" ng-class=\"{ \'has-error\' : literature.zip.$error.required && literature.zip.$dirty || literature.zip.$invalid && validateLiterature }\"><label class=\"col-md-4 control-label\" for=\"zip\"><span class=\"text-danger\">*</span>ZIP</label><div class=\"col-md-8\"><input ng-model=\"lit.zip\" class=\"form-control input-md\" placeholder=\"ZIP\" name=\"zip\" type=\"text\" value=\"\" maxlength=\"5\" pattern=\"\\d*\" required=\"\"> <span class=\"help-block\" ng-show=\"( literature.zip.$error.required && literature.zip.$dirty || literature.zip.$invalid && validateLiterature )\"><p class=\"text-danger\">This field is required.</p></span></div></div><div class=\"form-group row\" ng-class=\"{ \'has-error\' : literature.phone.$error.$invalid && literature.phone.$dirty || literature.phone.$invalid && validateContact }\"><label class=\"col-md-4 control-label\" for=\"phone\"><span class=\"text-danger\">*</span>Phone</label><div class=\"col-md-8\"><input ng-model=\"lit.phone\" ng-minlength=\"10\" class=\"form-control input-md phone\" placeholder=\"Phone\" maxlength=\"15\" name=\"phone\" type=\"text\" format-phone=\"\" required=\"\"> <span class=\"help-block\" ng-show=\"( literature.phone.$invalid && literature.phone.$dirty || literature.phone.$invalid && validateLiterature )\"><p class=\"text-danger\">Please enter your 10 digits number starting with the area code.</p></span></div></div><div class=\"form-group row\" ng-class=\"{ \'has-error\' : literature.email.$error.$invalid && literature.email.$dirty || literature.email.$invalid && validateLiterature }\"><label class=\"col-md-4 control-label\" for=\"email\">Email</label><div class=\"col-md-8\"><input ng-model=\"lit.email\" class=\"form-control input-md\" placeholder=\"Email\" name=\"email\" type=\"email\"> <span class=\"help-block\" ng-show=\"(literature.email.$error.email && literature.email.$dirty || literature.email.$invalid && validateLiterature)\"><p class=\"text-danger\">Please enter a valid email.</p></span></div></div><h4>Brochure Request</h4><br><div class=\"form-group row\"><label class=\"col-md-4 control-label\" for=\"brochures\"><span class=\"text-danger\">*</span># of Donation Brochures</label><div class=\"col-md-8\"><input ng-model=\"lit.brochures\" class=\"form-control input-md\" name=\"brochures\" type=\"test\" pattern=\"\\d*\"></div></div><div class=\"form-group row\"><label class=\"col-md-4 control-label\" for=\"scholarship_apps\"><span class=\"text-danger\">*</span># of Charitable Giving/Out of State Donation Brochures</label><div class=\"col-md-8\"><input ng-model=\"lit.scholarship_apps\" class=\"form-control input-md\" name=\"scholarship_apps\" type=\"test\" pattern=\"\\d*\"></div></div><div class=\"form-group\"><label for=\"comment\" class=\"sr-only\">Comment/Question</label> <textarea ng-model=\"lit.comment\" class=\"form-control input-md\" placeholder=\"Send us your comment or question.\" name=\"comment\" cols=\"50\" rows=\"10\">\n				</textarea></div><a ui-sref=\"home\" class=\"btn btn-link\">Cancel</a> <button ng-click=\"lit.sendRequest($event)\" type=\"button\" class=\"btn btn-primary\"><i class=\"fa fa-envelope-o\"></i> Send Request</button></form></div></div>");
$templateCache.put("app/login/login.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-6 col-sm-offset-3 col-lg-4 col-lg-offset-4\"><div class=\"panel panel-default\" id=\"login\"><div class=\"panel-heading text-center\"><a href=\"https://acsto.org\"><img src=\"/img/acsto2.png\" class=\"img-responsive\"></a><h2 class=\"wow fadeIn\" data-wow-duration=\"1.5s\">Parent Portal</h2></div><div class=\"panel-body\"><div ng-show=\"auth.msg\" class=\"alert alert-success\" role=\"alert\"><p ng-bind-html=\"auth.msg\"></p></div><div class=\"alert alert-danger\" ng-if=\"auth.errorMsg\" role=\"alert\"><p ng-bind-html=\"auth.errorMsg\"></p></div><form role=\"form\" name=\"signinForm\" ng-submit=\"auth.login($event)\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{ \'has-error\': signinForm.email.$touched && signinForm.email.$invalid || signinForm.email.$invalid && user.loginValidate }\"><label>Email Address</label> <input ng-model=\"auth.email\" type=\"email\" class=\"form-control input-lg\" name=\"email\" placeholder=\"Email\" required=\"\"><div class=\"help-block\" ng-messages=\"signinForm.email.$error\" ng-if=\"signinForm.email.$touched || signinForm.email.$invalid && user.loginValidate\"><p ng-message=\"required\">Your email is required.</p></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': signinForm.password.$touched && signinForm.password.$invalid || signinForm.password.$invalid && user.loginValidate }\"><label>Password <i class=\"fa fa-question-circle text-info\" popover-placement=\"right\" popover-trigger=\"mouseenter\" uib-popover=\"Passwords are case sensitive.\"></i></label> <input ng-model=\"auth.password\" type=\"password\" class=\"form-control input-lg\" name=\"password\" placeholder=\"Password\" required=\"\"><div class=\"help-block\" ng-messages=\"signinForm.password.$error\" ng-if=\"signinForm.password.$touched || signinForm.password.$invalid && user.loginValidate\"><p ng-message=\"required\">Your password is required.</p></div></div><div class=\"form-group\"><button ng-click=\"auth.login($event)\" type=\"submit\" class=\"btn btn-primary btn-block\">Sign In</button> <a ui-sref=\"register\" class=\"btn btn-warning btn-block\">Register</a></div><div class=\"form-group text-center\"><a ui-sref=\"sendResetPW\" class=\"btn btn-link\">Forgot Your Password?</a> | <a ui-sref=\"faq\" class=\"btn btn-link\">FAQ</a></div></form></div></div></div></div></div>");
$templateCache.put("app/login/popup.html","<div class=\"modal-header\"><h3 class=\"modal-title text-info\">IMPORTANT TAX CREDIT INFORMATION</h3></div><div class=\"modal-body alert-info\" style=\"font-size: 21px;\"><p><i class=\"fa fa-bullhorn fa-3x\" aria-hidden=\"true\"></i>The deadline for <strong>tax credit donations REMAINS April 15, 2020</strong> even though the 2019 tax filing deadline has been extended to July 15, 2020.</p><p>All tax credit donations must be made <strong>by the time you file your taxes, but no later than April 15, 2020, whichever comes first</strong>, if you want to claim it on your 2019 state taxes.</p></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.ok()\">CLOSE</button></div>");
$templateCache.put("app/profile/profile.html","<article class=\"container\"><form class=\"form-horizontal\" name=\"parentInfo\" role=\"form\" method=\"POST\" novalidate=\"\"><div class=\"row\"><div class=\"page-header\"><h1>Profile</h1></div><div class=\"col-md-10 col-md-offset-1\"><section class=\"scholarship family\"><div class=\"panel panel-primary\"><div class=\"panel-heading\"><h3>Parent Information</h3></div><div class=\"panel-body\"><span ng-show=\"parentInfo.$invalid && parentInfo.$dirty || validateParent && parentInfo.$invalid\"><div class=\"alert alert-danger\" role=\"alert\"><i class=\"fa fa-exclamation-triangle\"></i> fields marked with an asterisk (<span class=\"text-danger\">*</span>) are required</div></span><div class=\"form-group\" ng-class=\"{ \'has-error\' : parentInfo.parent_first_name.$error.required && parentInfo.parent_last_name.$error.required && parentInfo.parent_first_name.$dirty || validateParent && (parentInfo.parent_first_name.$invalid || parentInfo.parent_last_name.$invalid)}\"><label class=\"col-sm-3 control-label\"><span class=\"text-danger\">*</span> Parent Name(s)</label><div class=\"col-sm-7\"><div class=\"row\"><div class=\"col-md-5\"><label for=\"parent_first_name\" class=\"sr-only\">First Name</label> <input ng-model=\"vm.parents.parent_first_name\" class=\"form-control\" placeholder=\"First name(s)\" maxlength=\"50\" name=\"parent_first_name\" type=\"text\" required=\"\"> <span class=\"help-block\" ng-show=\"(parentInfo.parent_first_name.$error.required && parentInfo.parent_first_name.$dirty) || parentInfo.parent_first_name.$invalid && validateParent\"><p class=\"text-danger\">This field is required.</p></span></div><div class=\"col-md-2\"><label for=\"parent_middle_initial\" class=\"sr-only\">Middle Initial</label> <input ng-model=\"vm.parents.parent_middle_initial\" class=\"form-control\" placeholder=\"M.I.\" maxlength=\"30\" name=\"parent_middle_initial\" type=\"text\"></div><div class=\"col-md-5\"><label for=\"parent_last_name\" class=\"sr-only\">Last Name</label> <input ng-model=\"vm.parents.parent_last_name\" class=\"form-control\" placeholder=\"Last name\" maxlength=\"30\" name=\"parent_last_name\" type=\"text\" required=\"\"> <span class=\"help-block\" ng-show=\"(parentInfo.parent_last_name.$error.required && parentInfo.parent_last_name.$dirty) || parentInfo.parent_last_name.$invalid && validateParent\"><p class=\"text-danger\">This field is required.</p></span></div></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : parentInfo.parent_phone.$error.required && parentInfo.parent_phone.$dirty || parentInfo.parent_phone.$invalid && validateParent }\"><label for=\"parent_phone\" class=\"col-sm-3 control-label\"><span class=\"text-danger\">*</span> Phone</label><div class=\"col-sm-7\"><input ng-model=\"vm.parents.parent_phone\" ng-minlength=\"10\" class=\"form-control\" placeholder=\"Phone\" maxlength=\"15\" name=\"parent_phone\" type=\"text\" format-phone=\"\" required=\"\"> <span class=\"help-block\" ng-show=\"parentInfo.parent_phone.$error.required && parentInfo.parent_phone.$dirty || parentInfo.parent_phone.$invalid && validateParent\"><p class=\"text-danger\">This field is required.</p></span></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : parentInfo.address.$error.required && parentInfo.address.$dirty || parentInfo.address.$invalid && validateParent }\"><label class=\"col-sm-3 control-label\"><span class=\"text-danger\">*</span> Address</label><div class=\"col-sm-7\"><input ng-model=\"vm.parents.address\" type=\"text\" class=\"form-control\" placeholder=\"Address\" name=\"address\" required=\"\"> <span class=\"help-block\" ng-show=\"(parentInfo.address.$error.required && parentInfo.address.$dirty) || parentInfo.address.$invalid && validateParent\"><p class=\"text-danger\">This field is required.</p></span></div></div><div class=\"form-group\"><div class=\"col-sm-7 col-sm-offset-3\"><input ng-model=\"vm.parents.address2\" type=\"text\" class=\"form-control\" placeholder=\"Apt / Suite / Other\" name=\"address2\" value=\"\"></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : parentInfo.zip.$error.required && parentInfo.zip.$dirty || parentInfo.city.$invalid && validateParent }\"><label class=\"col-sm-3 control-label\"><span class=\"text-danger\">*</span> City/<span class=\"text-danger\">*</span> State/<span class=\"text-danger\">*</span> ZIP</label><div class=\"col-sm-7\"><div class=\"row\"><div class=\"col-md-5\"><label for=\"city\" class=\"sr-only\">City</label> <input ng-model=\"vm.parents.city\" class=\"form-control\" maxlength=\"30\" name=\"city\" type=\"text\" required=\"\"> <span class=\"help-block\" ng-show=\"parentInfo.city.$error.required && parentInfo.city.$dirty || parentInfo.city.$invalid && validateParent\"><p class=\"text-danger\">This field is required.</p></span></div><div class=\"col-md-4\"><label for=\"state\" class=\"sr-only\">State</label><select ng-model=\"vm.parents.state\" ng-options=\"state.value for state in vm.states track by state.value\" class=\"form-control\" name=\"state\" required=\"\"></select></div><div class=\"col-md-3\"><label for=\"zip\" class=\"sr-only\">ZIP</label> <input ng-model=\"vm.parents.zip\" pattern=\"\\d*\" class=\"form-control\" id=\"zip\" maxlength=\"5\" name=\"zip\" type=\"text\" required=\"\"> <span class=\"help-block\" ng-show=\"parentInfo.zip.$error.required && parentInfo.zip.$dirty || parentInfo.zip.$invalid && validateParent\"><p class=\"text-danger\">This field is required.</p></span></div></div></div></div><div class=\"col-sm-offset-3 col-sm-6\"><button ng-click=\"vm.saveParentInfo($event)\" ng-disabled=\"vm.updateBtn === \'Updating...\'\" ng-bind-html=\"vm.updateBtn\" type=\"submit\" class=\"btn btn-primary\"></button></div></div></div></section><section class=\"scholarship family\"><div class=\"panel panel-primary\"><div class=\"panel-heading\"><h3>Change Email</h3></div><div class=\"panel-body\"><p>To change your Parent Portal email:</p><ul><li>Log out of your current portal</li><li>At the Parent Portal log in screen, choose \"Register\" and create a new account with your new email</li><li>Check your email <strong>within 24 hours</strong> to confirm your new email address</li><li>Log in with your new email <strong>AND</strong> add your student(s)*</li><li>Allow 1-2 business days for ACSTO to connect your existing account to your new account</li></ul><p><em>*If you already submitted your student’s Scholarship Application for the current or upcoming school year, you do not need to apply again for these school years. However, you must add your student(s) to your new portal.</em></p></div></div></section><section class=\"scholarship family\"><div class=\"panel panel-primary\"><div class=\"panel-heading\"><h3>Reset Password</h3></div><div class=\"panel-body\"><div class=\"form-group\"><label>Current Password</label><div class=\"row\"><div class=\"col-md-4\"><input ng-model=\"vm.old_password\" type=\"password\" class=\"form-control\" name=\"old_password\" placeholder=\"Current password\"></div></div></div><div class=\"form-group\"><label>New Password</label><div class=\"row\"><div class=\"col-md-4\"><input ng-model=\"vm.new_password\" type=\"password\" class=\"form-control\" name=\"password\" placeholder=\"New Password\"></div></div></div><div class=\"form-group\"><label>Confirm Password</label><div class=\"row\"><div class=\"col-md-4\"><input ng-model=\"vm.confirm_new_password\" password-match=\"vm.new_password\" type=\"password\" class=\"form-control\" name=\"password_confirmation\" placeholder=\"Confirm new password\"></div><div class=\"help-block\" ng-messages=\"parentInfo.password_confirmation.$error\" ng-if=\"parentInfo.password_confirmation.$dirty || parentInfo.password_confirmation.$invalid && vm.validatePw\"><div ng-message=\"compareTo\">Password must match.</div><div ng-message=\"required\">Confirm password is required.</div></div></div></div><button type=\"submit\" ng-click=\"vm.updatePassword($event)\" class=\"btn btn-primary\"><i class=\"fa fa-floppy-o\"></i>Update</button></div></div></section></div></div></form></article><br><br><br>");
$templateCache.put("app/manageLandingPage/manageLandingPage.html","<article class=\"container\"><div class=\"row\"><div class=\"page-header\"><h1>Create/Manage ACSTO Family Page</h1></div><div class=\"col-md-2\"><div ng-include=\"\'app/components/navbar/scholarship.navbar.html\'\"></div></div><div class=\"col-md-10\"><div class=\"form-group\" ng-if=\"vm.landingPageStatus\"><label for=\"status\">Page Status</label><br>{{ vm.landingPageStatus }}</div><div class=\"form-group landing-page-link alert alert-success\" ng-if=\"vm.landingPageLink\"><label for=\"link\">ACSTO Family Page Link</label><div class=\"row\"><div class=\"col-md-10 col-sm\">{{ vm.landingPageLink }}</div><div class=\"col-md-2 col-sm\"><button type=\"button\" id=\"copy-url\" class=\"btn btn-info\" ng-click=\"vm.copyToClipboard()\">{{ vm.copyStatus }}</button></div></div></div><div class=\"alert alert-info\" style=\"display: flex; justify-content: center; align-items: center; flex-direction: column;\"><p>Your ACSTO Family Page is a custom page designed to help you share with your family and friends how they can give to ACSTO, receive a dollar-for-dollar tax credit, and recommend your student(s) to be considered for a scholarship!</p><br><p>Please allow 1-2 business days for us to process or update your page. You will receive an email notifying you when your page or update is ready.</p><br><button type=\"button\" class=\"btn btn-info\"><a href=\"https://pages.acsto.org/sample/\" style=\"color: white;\" target=\"_blank\">Sample ACSTO Family Page</a></button></div><div class=\"alert alert-info\"><h3 style=\"margin-top: 0;\">Narrative</h3><p>Tell us about your children! Here are some suggestions to get you started:</p><br><ul><li>Why is sending your children to a Christian School important to you?</li><li>What activities are your children involved in?</li><li>What do your students love about their school?</li><li>What do you love about Christian Education?</li></ul><br><p><strong><em>Please&nbsp;<u>do not</u>&nbsp;explain the tax credit program.</em></strong> ACSTO will take care of those details for you (see “Sample ACSTO Family Page”).</p></div><form name=\"landingPage\" role=\"form\" method=\"POST\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : landingPage.appeal.$dirty && landingPage.appeal.$invalid || landingPage.appeal.$invalid && vm.validateAppeal }\"><textarea ng-bind-html=\"vm.appeal\" ng-model=\"vm.appeal\" rows=\"10\" min-word=\"30\" maxlength=\"8000\" required=\"\" name=\"appeal\" type=\"text\" class=\"form-control\" id=\"appeal\" placeholder=\"We recommend you type and save your Narrative in a separate document first. Then paste it here.\">\n                  </textarea> <em>Note: 8,000 character limit</em><div class=\"help-block\" ng-messages=\"landingPage.appeal.$error\" ng-if=\"landingPage.appeal.$dirty || landingPage.appeal.$invalid && vm.validateAppeal\"><div ng-message=\"required\">This field is required.</div><div ng-message=\"minWord\">A narrative is required. Please provide 1-2 paragraphs.</div><div ng-message=\"maxlength\">The appeal must be less than 8,000 characters.</div></div></div><div class=\"alert alert-info\"><h3 style=\"margin-top: 0;\">Custom Donation Link</h3><p>Friends and family will have the option to donate through your ACSTO Family Page. By completing the sections below, your student\'s name and school will automatically appear in the Student Recommendation section during the donation process.</p><br><p><b>Important!</b></p><br><ul><li>Type your student\'s first and last names exactly as they appear on your Parent Portal. Do not abbreviate. For example: Joshua Cornell.</li><li>If you have more than one child, type each child\'s name. For example: Joshua, Andrew, and Sara Cornell. <strong><em><u>Do not</u></em></strong> type “The Cornell Family/Kids.”</li><li>If your student does not qualify for Overflow Tax Credit Scholarships, leave the two Overflow Tax Credit boxes blank. <strong><em><u>Do not</u>&nbsp;enter a student\'s name who is not in your family</em></strong>. If you do not know if your student qualifies, call ACSTO at 480.820.0403.</li><li>If your students attend different Christian Schools, please select one school and ACSTO will ensure donations are split between your students, regardless of which school is identified.</li></ul></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : landingPage.student.$error.required && (landingPage.student.$dirty || landingPage.student.$touched) }\"><label for=\"student\">Original Tax Credit: Student Full Name (Required)</label> <input name=\"student\" type=\"text\" class=\"form-control\" id=\"student\" required=\"\" ng-model=\"vm.customLinkStudent\" placeholder=\"Student Full Name\"> <span class=\"help-block\" ng-show=\"landingPage.student.$error.required && (landingPage.student.$dirty || landingPage.student.$touched)\"><p class=\"text-danger\">You must enter a student for your custom link.</p></span></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : landingPage.school.$error.required && (landingPage.school.$dirty || landingPage.school.$touched) }\"><label for=\"school\">Original Tax Credit: School (Required)</label><select name=\"school\" class=\"form-control\" id=\"school\" required=\"\" ng-model=\"vm.customLinkSchool\" ng-options=\"school.school_name for school in vm.schoolList track by school.alt_id\"><option value=\"\" disabled=\"\" selected=\"\">--- Select School ---</option></select><span class=\"help-block\" ng-show=\"landingPage.school.$error.required && (landingPage.school.$dirty || landingPage.school.$touched)\"><p class=\"text-danger\">You must enter a school to for your custom link.</p></span></div><div class=\"form-group\"><label for=\"overflowStudent\">Overflow Tax Credit: Student Full Name</label> <input name=\"overflowStudent\" type=\"text\" class=\"form-control\" id=\"overflowStudent\" placeholder=\"Student Full Name\" ng-model=\"vm.customLinkOverflowStudent\"></div><div class=\"form-group\"><label for=\"overflowSchool\">Overflow Tax Credit: School</label><select name=\"overflowSchool\" class=\"form-control\" id=\"overflowSchool\" ng-model=\"vm.customLinkOverflowSchool\" ng-options=\"school.school_name for school in vm.schoolList track by school.alt_id\"><option value=\"\" disabled=\"\" selected=\"\">--- Select School ---</option></select></div><div class=\"form-group\"><div class=\"alert alert-info\"><h3 style=\"margin-top: 0;\">Uploaded Images</h3><ul><li>Complete any cropping or rotating of image before uploading.</li><li>To update an existing upload, first delete your image (select the red X next to the image), then upload the new image.</li><li>You may upload a total of 3 images.</li><li>We only accept .png, .jpeg, .gif, or .bmp. <strong><em>We do not accept .bin files.</em></strong></li><li>Images <em><strong>must be less than 8MB.</strong></em></li></ul><br><p ng-if=\"vm.shownListOfUploadedFiles.length === 0\" class=\"no-files\">[No files uploaded]</p><ul><li ng-repeat=\"f in vm.shownListOfUploadedFiles\" style=\"font:smaller\">{{ f.original_filename }} <button ng-click=\"vm.deleteFile($event, f)\" class=\"btn btn-link btn-xs\"><span class=\"fa fa-times text-danger\"></span></button></li></ul></div></div><br><div style=\"position: relative\"><div style=\"position: absolute; top: 70px; z-index:100; left: 15%; text-align:center\">If you are having difficulty uploading an image, please contact us at <a href=\"mailto:social@acsto.org\" style=\"z-index: 100\">social@acsto.org</a> or 480.820.0403.</div><div type=\"file\" ngf-drop=\"\" ngf-select=\"\" ng-model=\"vm.files\" class=\"drop-box\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/jpeg,image/jpg,image/png,image/gif,image/bmp\" ngf-pattern=\"\'image/jpeg,image/jpg,image/png,image/gif,image/bmp\'\"><i class=\"fa fa-cloud-upload\"></i>Click or Drag &amp; Drop Images Here to Upload.<br><br><br><br><button class=\"btn btn-default drop-btn\">Select Files to Import</button></div><div class=\"alert alert-danger\" role=\"alert\" ngf-no-file-drop=\"\"><i class=\"fa fa-exclamation-triangle\"></i>File Drag/Drop is not supported for this browser. Please mail or email your file(s).</div><br><p>Image upload progress</p><div class=\"progress file-progress\"><uib-progressbar class=\"progress-striped active\" ng-class=\"{ \'active\': vm.dynamic < 100 }\" value=\"vm.dynamic\" type=\"{{vm.type}}\"><strong>{{vm.dynamic}}% <i ng-show=\"vm.showComplete\">Complete!</i></strong></uib-progressbar></div></div><br><div class=\"form-group\"><button type=\"submit\" id=\"submit\" class=\"btn btn-primary\" ng-click=\"vm.submitLandingPageInfo($event)\" ng-disabled=\"vm.submitting\"><div ng-if=\"!vm.submitting\">Submit</div><div ng-if=\"vm.submitting\">Submitting...</div></button></div></form></div></div></article>");
$templateCache.put("app/resetPassword/pw.html","<div class=\"col-md-8 col-md-offset-2\" id=\"password\"><div class=\"well teal-bg\"><a href=\"https://parent.acsto.org\"><img src=\"/img/acsto.png\" class=\"img-responsive\" alt=\"ACSTO Logo\"></a><h3>Reset Password</h3><form name=\"resetPWEmailForm\" ng-submit=\"pw.send($event)\" novalidate=\"\"><div ng-show=\"pw.errorMsg\" class=\"alert alert-danger\" role=\"alert\"><i class=\"fa fa-exclamation-circle\"></i>Error<ul ng-repeat=\"error in pw.errorMsg\"><li>{{ error }}</li></ul></div><div class=\"form-group\" ng-class=\"{ \'has-error\': resetPWEmailForm.email.$touched && resetPWEmailForm.email.$invalid }\"><label class=\"sr-only\" for=\"email\">Email <i class=\"text-danger\">*</i></label> <input ng-model=\"pw.email\" ng-maxlength=\"100\" maxlength=\"100\" type=\"email\" name=\"email\" class=\"form-control\" placeholder=\"Email\" required=\"\"><div class=\"help-block\" ng-messages=\"resetPWEmailForm.email.$error\" ng-if=\"resetPWEmailForm.email.$touched\"><p ng-message=\"maxlength\">Your email is too long.</p><p ng-message=\"required\">Your email is required.</p></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': resetPWEmailForm.password.$touched && resetPWEmailForm.password.$invalid }\"><label class=\"sr-only\" for=\"password\">Password <i class=\"text-danger\">*</i></label> <input ng-model=\"pw.password\" type=\"password\" name=\"password\" class=\"form-control\" placeholder=\"Password\" required=\"\"><div class=\"help-block\" ng-messages=\"resetPWEmailForm.password.$error\" ng-if=\"resetPWEmailForm.password.$touched\"><p ng-message=\"maxlength\">Your password is too long.</p><p ng-message=\"required\">Your password is required.</p></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': resetPWEmailForm.confirm_password.$touched && resetPWEmailForm.confirm_password.$invalid }\"><label class=\"sr-only\" for=\"confirm_password\">Confirm Password <i class=\"text-danger\">*</i></label> <input ng-model=\"pw.confirm_password\" type=\"password\" name=\"confirm_password\" class=\"form-control\" placeholder=\"Confirm Password\" required=\"\"><div class=\"help-block\" ng-messages=\"resetPWEmailForm.confirm_password.$error\" ng-if=\"resetPWEmailForm.confirm_password.$touched\"><p ng-message=\"required\">Your confirm password is required.</p></div></div><button class=\"btn btn-primary\" type=\"submit\" ng-click=\"pw.send($event)\">Submit</button></form><br><a ui-sref=\"login\">Sign In</a></div></div>");
$templateCache.put("app/register/register.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-10 col-md-offset-1\"><div class=\"panel panel-default\"><div class=\"panel-heading text-center\"><a href=\"https://parent.acsto.org\"><img src=\"/img/acsto.png\" class=\"img-responsive\" alt=\"ACSTO Logo\"></a><h2 class=\"wow fadeIn\" data-wow-duration=\"1.5s\">Parent Portal - Register</h2></div><div class=\"panel-body\"><form name=\"registerForm\" class=\"form-horizontal\" novalidate=\"\"><div ng-show=\"user.registerError\" class=\"alert alert-danger\" role=\"alert\"><i class=\"fa fa-exclamation-circle\"></i>Registration Failed<ul ng-repeat=\"error in user.registerErrorText\"><li>{{ error[0] }}</li></ul></div><div class=\"form-group\" ng-class=\"{ \'has-error\': registerForm.email.$dirty && registerForm.email.$invalid || registerForm.email.$invalid && user.registerValidate }\"><label class=\"col-md-4 control-label\">Email Address<i class=\"text-danger\">*</i></label><div class=\"col-md-6\"><input ng-model=\"user.email\" ng-maxlength=\"100\" maxlength=\"100\" type=\"email\" name=\"email\" class=\"form-control\" placeholder=\"Email\" required=\"\"><div class=\"help-block\" ng-messages=\"registerForm.email.$error\" ng-if=\"registerForm.email.$dirty || registerForm.email.$invalid && user.registerValidate\"><p ng-message=\"maxlength\">Your email is too long.</p><p ng-message=\"required\">Your email is required.</p></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': registerForm.parent_first_name.$dirty && registerForm.parent_last_name.$invalid || registerForm.parent_first_name.$invalid && user.registerValidate || registerForm.parent_last_name.$invalid && user.registerValidate }\"><label for=\"parent_first_name\" class=\"col-md-4 control-label\">Parent Name(s)<i class=\"text-danger\">*</i></label><div class=\"col-md-6\"><div class=\"form-group row\"><div class=\"col-md-5\"><label for=\"parent_first_name\" class=\"sr-only\">First Name</label> <input ng-model=\"user.parent_first_name\" ng-maxlength=\"50\" type=\"text\" name=\"parent_first_name\" maxlength=\"50\" class=\"form-control\" placeholder=\"First name(s)\" required=\"\"><div class=\"help-block\" ng-messages=\"registerForm.parent_first_name.$error\" ng-if=\"registerForm.parent_first_name.$dirty || registerForm.parent_first_name.$invalid && user.registerValidate\"><p ng-message=\"maxlength\">Your first name is too long.</p><p ng-message=\"required\">Your first name is required.</p></div></div><div class=\"col-md-3\"><label for=\"parent_middle_initial\" class=\"sr-only\">Middle Initial</label> <input ng-model=\"user.middle\" ng-maxlength=\"30\" class=\"form-control\" placeholder=\"M.I.\" maxlength=\"30\" name=\"parent_middle_initial\" type=\"text\"><div class=\"help-block\" ng-messages=\"registerForm.parent_middle_initial.$error\" ng-if=\"registerForm.parent_middle_initial.$dirty\"><p ng-message=\"maxlength\">Your middle name is too long.</p></div></div><div class=\"col-md-4\"><label for=\"parent_last_name\" class=\"sr-only\">Last Name</label> <input ng-model=\"user.parent_last_name\" ng-maxlength=\"30\" maxlength=\"30\" type=\"text\" name=\"parent_last_name\" class=\"form-control\" placeholder=\"Last name\" required=\"\"><div class=\"help-block\" ng-messages=\"registerForm.parent_last_name.$error\" ng-if=\"registerForm.parent_last_name.$dirty || registerForm.parent_last_name.$invalid && user.registerValidate\"><p ng-message=\"maxlength\">Your last name is too long.</p><p ng-message=\"required\">Your last name is required.</p></div></div></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': registerForm.phone.$dirty && registerForm.phone.$invalid || registerForm.phone.$invalid && user.registerValidate }\"><label class=\"col-md-4 control-label\">Phone<i class=\"text-danger\">*</i></label><div class=\"col-md-6\"><input ng-model=\"user.phone\" ng-maxlength=\"10\" pattern=\"\\d*\" maxlength=\"10\" type=\"text\" name=\"phone\" format-phone=\"\" class=\"form-control\" placeholder=\"Phone\" required=\"\"><div class=\"help-block\" ng-messages=\"registerForm.phone.$error\" ng-if=\"registerForm.phone.$dirty || registerForm.phone.$invalid && user.registerValidate\"><p ng-message=\"format-phone\">(xxx) xxx-xxxx format.</p><p ng-message=\"pattern\">Enter numeric value only.</p><p ng-message=\"maxlength\">Your phone is too long.</p><p ng-message=\"required\">Your phone is required.</p></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': registerForm.address.$dirty && registerForm.address.$invalid || registerForm.address.$invalid && user.registerValidate }\"><label class=\"col-md-4 control-label\">Address<i class=\"text-danger\">*</i></label><div class=\"col-md-6\"><input ng-model=\"user.address\" ng-maxlength=\"30\" ng-minlength=\"10\" maxlength=\"30\" type=\"text\" name=\"address\" class=\"form-control\" placeholder=\"Address\" required=\"\"><div class=\"help-block\" ng-messages=\"registerForm.address.$error\" ng-if=\"registerForm.address.$dirty || registerForm.address.$invalid && user.registerValidate\"><p ng-message=\"maxlength\">Your address is too long.</p><p ng-message=\"required\">Your address is required.</p></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': registerForm.city.$dirty && registerForm.city.$invalid || registerForm.zip.$dirty && registerForm.zip.$invalid || registerForm.city.$invalid && user.registerValidate || registerForm.zip.$invalid && user.registerValidate }\"><label for=\"city\" class=\"col-md-4 control-label\">City/State/ZIP<i class=\"text-danger\">*</i></label><div class=\"col-md-6\"><div class=\"form-group row\"><div class=\"col-md-5\"><label for=\"city\" class=\"sr-only\">City</label> <input ng-model=\"user.city\" ng-maxlength=\"30\" maxlength=\"30\" type=\"text\" name=\"city\" class=\"form-control\" placeholder=\"City\" required=\"\"><div class=\"help-block\" ng-messages=\"registerForm.city.$error\" ng-if=\"registerForm.city.$dirty || registerForm.city.$invalid && user.registerValidate\"><p ng-message=\"maxlength\">Your city is too long.</p><p ng-message=\"required\">Your city is required.</p></div></div><div class=\"col-md-3\"><label for=\"parent_middle_initial\" class=\"sr-only\">State</label><select ng-model=\"user.state\" ng-init=\"user.state = user.stateList[3]\" ng-options=\"states.state for states in user.stateList track by states.value\" class=\"form-control\" name=\"state\" required=\"\"></select></div><div class=\"col-md-4\"><label for=\"zip\" class=\"sr-only\">ZIP</label> <input ng-model=\"user.zip\" ng-minlength=\"5\" maxlength=\"5\" pattern=\"\\d*\" type=\"text\" name=\"zip\" class=\"form-control\" placeholder=\"ZIP\" required=\"\"><div class=\"help-block\" ng-messages=\"registerForm.zip.$error\" ng-if=\"registerForm.zip.$dirty || registerForm.zip.$invalid && user.registerValidate\"><p ng-message=\"minlength\">Enter your 5 digit ZIP.</p><p ng-message=\"required\">Enter your 5 digit ZIP.</p></div></div></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': registerForm.password.$dirty && registerForm.password.$invalid || registerForm.password.$invalid && user.registerValidate }\"><label class=\"col-md-4 control-label\">Password<i class=\"text-danger\">*</i> <i class=\"fa fa-question-circle text-info\" popover-placement=\"right\" popover-trigger=\"mouseenter\" uib-popover=\"Passwords are case sensitive. Alpha, numeric, and symbol characters are allowed. Password must have at least 6 characters.\"></i></label><div class=\"col-md-6\"><input ng-model=\"user.password\" type=\"password\" name=\"password\" class=\"form-control\" placeholder=\"Password\" password-strength=\"\" required=\"\"><div class=\"help-block\" ng-messages=\"registerForm.password.$error\" ng-if=\"registerForm.password.$dirty || registerForm.password.$invalid && user.registerValidate\"><p ng-message=\"maxlength\">Your password is too long.</p><p ng-message=\"required\">Your password is required.</p></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': registerForm.confirm_password.$dirty && registerForm.confirm_password.$invalid || registerForm.confirm_password.$invalid && user.registerValidate }\"><label class=\"col-md-4 control-label\">Confirm Password<i class=\"text-danger\">*</i></label><div class=\"col-md-6\"><input ng-model=\"user.confirm_password\" password-match=\"user.password\" type=\"password\" name=\"confirm_password\" class=\"form-control\" placeholder=\"Confirm Password\" required=\"\"><div class=\"help-block\" ng-messages=\"registerForm.confirm_password.$error\" ng-if=\"registerForm.confirm_password.$dirty || registerForm.confirm_password.$invalid && user.registerValidate\"><div ng-message=\"compareTo\">Password must match.</div><div ng-message=\"required\">Confirm password is required.</div></div></div></div><div class=\"form-group\"><div class=\"col-md-6 col-md-offset-4\"><button ng-click=\"user.register($event)\" type=\"submit\" class=\"btn btn-primary\">Register</button> <a href=\"/\" class=\"btn btn-link\">Cancel</a></div></div></form></div></div></div></div></div>");
$templateCache.put("app/resendEmail/sendEmail.html","<div class=\"col-md-6 col-md-offset-3\"><div class=\"well teal-bg\"><a href=\"https://parent.acsto.org\"><img src=\"/img/acsto.png\" class=\"img-responsive\" alt=\"ACSTO Logo\"></a><h3>Send Email Confirmation</h3><form name=\"resendEmailForm\" ng-submit=\"resend.send($event)\" novalidate=\"\"><div ng-show=\"resend.errorMsg\" class=\"alert alert-danger\" role=\"alert\"><i class=\"fa fa-exclamation-circle\"></i><span ng-bind-html=\"resend.errorMsg\"></span></div><div class=\"form-group\" ng-class=\"{ \'has-error\': resendEmailForm.email.$touched && resendEmailForm.email.$invalid }\"><label class=\"sr-only\" for=\"email\">Email <i class=\"text-danger\">*</i></label> <input ng-model=\"resend.email\" ng-maxlength=\"100\" maxlength=\"100\" type=\"email\" name=\"email\" class=\"form-control\" placeholder=\"Email\" required=\"\"><div class=\"help-block\" ng-messages=\"resendEmailForm.email.$error\" ng-if=\"resendEmailForm.email.$touched\"><p ng-message=\"maxlength\">Your email is too long.</p><p ng-message=\"required\">Your email is required.</p></div></div><button class=\"btn btn-primary\" type=\"submit\" ng-click=\"resend.send($event)\">Submit</button></form><br><a ui-sref=\"login\">Sign In</a></div></div>");
$templateCache.put("app/sendPasswordToken/pwToken.html","<div class=\"col-md-6 col-md-offset-3\" id=\"token\"><div class=\"well teal-bg\"><img src=\"/img/acsto.png\" class=\"img-responsive\" alt=\"CEA Logo\"><h3>Reset Password</h3><div ng-show=\"pwemail.errorMsg\" class=\"alert alert-danger\" role=\"alert\"><i class=\"fa fa-exclamation-circle\"></i><span ng-bind-html=\"pwemail.errorMsg.email\"></span></div><div class=\"form-group\" ng-class=\"{ \'has-error\': resendEmailForm.email.$touched && resendEmailForm.email.$invalid }\"><label class=\"sr-only\" for=\"email\">Email</label> <input ng-model=\"pwemail.email\" ng-maxlength=\"100\" maxlength=\"100\" type=\"email\" name=\"email\" class=\"form-control\" placeholder=\"Email\" required=\"\"><div class=\"help-block\" ng-messages=\"resendEmailForm.email.$error\" ng-if=\"resendEmailForm.email.$touched\"><p ng-message=\"maxlength\">Your email is too long.</p><p ng-message=\"required\">Your email is required.</p></div></div><button class=\"btn btn-primary\" type=\"submit\" ng-click=\"pwemail.send($event)\">Submit</button><br><a ui-sref=\"login\">Sign In</a></div></div>");
$templateCache.put("app/scholarship/dashboard.html","<article class=\"container\" ng-controller=\"ScholarshipController\"><div class=\"page-header\"><h1>Scholarships <small>&amp; Applications Dashboard</small></h1></div><div class=\"row\"><div class=\"col-md-2\"><div ng-include=\"\'app/components/navbar/scholarship.navbar.html\'\"></div></div><div class=\"col-md-10\"><uib-tabset><uib-tab class=\"hidden-print\" select=\"vm.appStatus($event)\"><uib-tab-heading><i class=\"fa fa-trophy\"></i> Applications Status</uib-tab-heading><br><div class=\"alert alert-info lead hidden-print\" role=\"alert\"><p><i class=\"fa fa-info-circle\"></i>Please note: Students must have a complete application AND be enrolled at an ACSTO Partner School to be considered for any scholarship awards. Only one application is required per student, per school year (not per award cycle). Applications expire on May 31 of the school year shown on the application, regardless of when they are received. A complete ACSTO application does not guarantee a scholarship.</p></div><div ng-hide=\"vm.students.length > 0\" class=\"alert alert-warning lead hidden-print\" role=\"alert\"><p><i class=\"fa fa-exclamation-triangle\"></i>You currently have no applications on file.</p><p>If you recently submitted an application, it could take up to 15 minutes to show here. If you started, but didn\'t complete an application, it will be under the \'Saved Applications\' tab.</p><p><a ui-sref=\"scholarship.apply\" class=\"btn btn-warning\"><i class=\"fa fa-plus\"></i>Apply now</a></p></div><p class=\"visible-xs-block alert alert-info\"><i class=\"fa fa-info-circle\"></i>Swipe left or right to see additional details.</p><div ng-show=\"vm.loading\" class=\"text-center\"><i class=\"fa fa-refresh fa-spin fa-5x\"></i></div><div ng-hide=\"vm.loading\" ng-repeat=\"student in vm.students\"><div class=\"panel panel-info\"><div class=\"panel-heading clearfix\"><h3 class=\"pull-left\">{{ student.student_name | paseQuotes }}</h3><button ng-click=\"vm.contact($event, student)\" class=\"btn btn-info pull-right\">Changes</button></div><div class=\"table-responsive\" style=\"overflow:visible\"><table class=\"table\"><thead><tr><th style=\"width:10%\">School Year</th><th style=\"width:7%\">Grade</th><th style=\"width:7%\">ESA</th><th style=\"width:20%\">School</th><th style=\"width:10%\">DOB</th><th style=\"width:16%\">App Status</th><th style=\"width:20%\">Per School is Attending?</th><th style=\"width:10%\">Expire</th></tr></thead><tbody ng-repeat=\"details in student.detail\"><tr ng-if=\"details.status !== \'OTHER\'\"><td>{{ details.application_year }}</td><td>{{ details.grade }}</td><td ng-if=\"details.using_esa\">Y</td><td ng-if=\"!details.using_esa\">N</td><td>{{ details.school_name }}</td><td>{{ details.dob }}</td><td><button uib-popover-html=\"vm.getStatusLookup(details.status)\" popover-trigger=\"focus\" class=\"btn btn-default\">{{ details.status }}</button></td><td ng-if=\"details.per_school_is_attending\" style=\"display:flex;justify-content:center;\">Y</td><td ng-if=\"!details.per_school_is_attending\" style=\"display:flex;justify-content:center;\">N</td><td>{{ details.expiration_date }}</td></tr></tbody></table></div></div></div></uib-tab><uib-tab class=\"hidden-print\" select=\"vm.getUnfinishedScholarship()\"><uib-tab-heading><i class=\"fa fa-file-o\"></i> Saved Applications (in progress)</uib-tab-heading><br><div class=\"alert alert-info lead hidden-print\" role=\"alert\"><p><i class=\"fa fa-info-circle\"></i>Note: Family Information already entered on a saved application cannot be changed. Updates can be made in your <a ui-sref=\"profile\" class=\"btn btn-warning btn-sm\"><i class=\"fa fa-user\" style=\"margin-right:.15em;\"></i>Profile</a>.</p></div><div ng-hide=\"vm.scholarshipList.length\" class=\"alert alert-warning lead hidden-print\" role=\"alert\"><p><i class=\"fa fa-exclamation-triangle\"></i>You currently have no saved applications waiting to be completed.</p></div><p class=\"visible-xs-block alert alert-info\"><i class=\"fa fa-info-circle\"></i>Swipe left or right to see additional details.</p><div ng-show=\"vm.loading\" class=\"text-center\"><i class=\"fa fa-refresh fa-spin fa-5x\"></i></div><div ng-hide=\"vm.loading\" ng-show=\"vm.scholarshipList.length\" class=\"table-responsive\"><table class=\"table table-condensed\"><thead><tr><th>Name</th><th>School</th><th>App Year</th><th>Grade</th><th></th></tr></thead><tbody ng-repeat=\"scholarship in vm.scholarshipList\"><tr><td>{{ scholarship.student_name | paseQuotes }}</td><td>{{ scholarship.school_name }}</td><td>{{ scholarship.app_year }} <span ng-if=\"scholarship.expired\" class=\"label label-danger\">Expired</span></td><td>{{ scholarship.grade }}</td><td><a ui-sref=\"scholarship.edit({ scholarshipId: scholarship.id })\" class=\"btn btn-xs\" ng-disabled=\"scholarship.expired\" ng-class=\"scholarship.expired ? \'btn-default\' : \'btn-info\'\">Edit</a> <button ng-click=\"vm.deleteScholarship($event, scholarship)\" class=\"btn btn-danger btn-xs\">Delete</button></td></tr></tbody></table></div></uib-tab><uib-tab class=\"hidden-print\" select=\"vm.getHistory()\"><uib-tab-heading><i class=\"fa fa-file\"></i> Award History</uib-tab-heading><br><div ng-hide=\"vm.awards.length > 0\" class=\"alert alert-warning lead hidden-print\" role=\"alert\"><p><i class=\"fa fa-exclamation-triangle\"></i>There is currently no award history to display. If you just registered, it could take up to 1-2 business days for your Award History to show.</p></div><p class=\"visible-xs-block alert alert-info\"><i class=\"fa fa-info-circle\"></i>Swipe left or right to see additional details.</p><div ng-show=\"vm.loading\" class=\"text-center\"><i class=\"fa fa-refresh fa-spin fa-5x\"></i></div><div ng-hide=\"vm.loading\" ng-repeat=\"award in vm.awards | orderBy:\'student_name\'\"><div class=\"panel panel-info\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"col-md-12 clear-fix\"><h3 ng-if=\"award.student_name\" class=\"pull-left\">{{ award.student_name | paseQuotes }}</h3><a href=\"#\" target=\"_blank\" ng-if=\"award.student_web_id\" ng-click=\"vm.downloadChildHistory($event, award.student_web_id)\" class=\"btn btn-default pull-right hidden-print\"><i class=\"fa fa-file-pdf-o\"></i> Award History</a> <a href=\"#\" target=\"_blank\" ng-if=\"award.student_web_id\" ng-click=\"vm.downloadConfirmation($event, award.student_web_id)\" class=\"btn btn-default pull-right hidden-print\"><i class=\"fa fa-file-pdf-o\"></i> Award Confirmation</a></div><div class=\"col-md-12 clear-fix\" ng-if=\"award.custom3\"><div class=\"alert alert-danger\" role=\"alert\">{{ award.custom3 | paseQuotes }}</div></div></div></div><div class=\"table-responsive\"><table class=\"table table-condensed\"><thead><tr><th><i class=\"fa fa-university\"></i>School</th><th><i class=\"fa fa-bullhorn\"></i>App Year</th><th><i class=\"fa fa-calendar\"></i>Date</th><th><i class=\"fa fa-tag\"></i>Type</th><th><i class=\"fa fa-usd\"></i>Amount</th></tr></thead><tbody ng-repeat=\"app in award.detail\"><tr><td>{{ app.school_name }}</td><td>{{ app.application_year }}</td><td><span ng-if=\"app.award_type !== \'Total funds sent to school (Net Scholarships)\'\">{{ app.award_date }}</span></td><td>{{ app.award_type }}</td><td class=\"text-right\">{{ app.amount | currency }}</td></tr></tbody></table></div></div></div></uib-tab></uib-tabset><br><br><br><br></div></div></article>");
$templateCache.put("app/scholarship/modal.html","<div class=\"modal-header\"><h3 class=\"modal-title\">{{ vm.title }}</h3></div><div class=\"modal-body\"><div class=\"alert alert-info\"><p class=\"lead\">The Arizona Department of Revenue requires a child to be at least 5 years old by January 1st of their Kindergarten year in order to be considered for tax credit scholarships. Please verify the date of birth for your child by going to Students and using the <i class=\"fa fa-pencil\" style=\"margin-right:0;\"></i> Edit button. If your student is a preschooler with disabilities, you will need to provide an MET or IEP from an Arizona public school for us to consider the application complete.</p></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.ok()\">Ok</button></div>");
$templateCache.put("app/scholarship/scholarship.contact.html","<div class=\"modal-header\"><h3 class=\"modal-title\">{{ vm.title }}</h3></div><div class=\"modal-body\"><div class=\"alert alert-info\"><p>Use this form to update an application you\'ve previously submitted. A submitted application cannot be updated online. Please submit your edits here and a member of our staff will make the necessary corrections to this child\'s application within 1-2 business days.</p><p><strong>If you wish to submit a new application, please <a ui-sref=\"scholarship.apply\" ng-click=\"vm.cancel()\" title=\"apply scholarship\">click here</a> to apply. Remember, we only need one application per school year.</strong></p></div><form name=\"scholarshipContact\" role=\"form\" method=\"POST\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{ \'has-error\': scholarshipContact.msg.$dirty && scholarshipContact.msg.$invalid || scholarshipContact.msg.$invalid && vm.validateContact }\"><label for=\"msg\"><span class=\"text-danger\">*</span> Email Us:</label> <textarea ng-model=\"vm.msg\" class=\"form-control\" rows=\"8\" name=\"msg\" placeholder=\"Please describe the changes you need here.\" required=\"\"></textarea><div class=\"help-block\" ng-messages=\"scholarshipContact.msg.$error\" ng-if=\"scholarshipContact.msg.$dirty || scholarshipContact.msg.$invalid && vm.validateContact\"><div ng-message=\"required\">Please enter a message.</div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-link\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.ok()\"><i class=\"fa fa-paper-plane-o\"></i>Send</button></div>");
$templateCache.put("app/students/student.add.html","<form name=\"childform\" class=\"form-horizontal\" role=\"form\" method=\"POST\" novalidate=\"\"><div class=\"modal-header\"><h3 class=\"modal-title\">Add Student</h3></div><div class=\"modal-body\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : childform.child_first_name.$error.required && childform.child_last_name.$error.required && childform.child_first_name.$dirty || validateChild && (childform.child_first_name.$invalid || childform.child_last_name.$invalid)}\"><label for=\"children_name\" class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span> Student Full Name</label><div class=\"col-sm-10\"><div class=\"row\"><div class=\"col-md-4\" ng-class=\"{ \'has-error\' : childform.child_first_name.$touched && childform.child_first_name.$invalid || childform.child_first_name.$invalid && validateChild }\"><label for=\"child_first_name\" class=\"sr-only\">First Name</label> <input ng-model=\"vm.child_first_name\" class=\"form-control\" placeholder=\"First name\" maxlength=\"30\" name=\"child_first_name\" type=\"text\" required=\"\"><div class=\"help-block\" ng-messages=\"childform.child_first_name.$error\" ng-if=\"childform.child_first_name.$touched || childform.child_first_name.$invalid && validateChild\"><div ng-message=\"required\">This field is required.</div><div ng-message=\"maxlength\">First name is too long.</div></div></div><div class=\"col-md-4\"><label for=\"child_middle_initial\" class=\"sr-only\">Middle Name</label> <input ng-model=\"vm.child_middle_initial\" class=\"form-control\" placeholder=\"Middle name\" maxlength=\"30\" name=\"child_middle_initial\" type=\"text\"></div><div class=\"col-md-4\" ng-class=\"{ \'has-error\' : childform.child_last_name.$touched && childform.child_last_name.$invalid || childform.child_last_name.$invalid && validateChild }\"><label for=\"child_last_name\" class=\"sr-only\">Last Name</label> <input ng-model=\"vm.child_last_name\" class=\"form-control\" placeholder=\"Last name\" maxlength=\"30\" name=\"child_last_name\" type=\"text\" required=\"\"><div class=\"help-block\" ng-messages=\"childform.child_last_name.$error\" ng-if=\"childform.child_last_name.$touched || childform.child_last_name.$invalid && validateChild\"><div ng-message=\"required\">This field is required.</div><div ng-message=\"maxlength\">Last name is too long.</div></div></div></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : childform.child_dob.$touched && childform.child_dob.$invalid || childform.child_dob.$invalid && validateChild }\"><label for=\"children_dob\" class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span> Student DOB</label><div class=\"col-sm-10\"><input ng-model=\"vm.child_dob\" name=\"child_dob\" ng-pattern=\"/^((((0[13578])|([13578])|(1[02]))[\\/](([1-9])|([0-2][0-9])|(3[01])))|(((0[469])|([469])|(11))[\\/](([1-9])|([0-2][0-9])|(30)))|((2|02)[\\/](([1-9])|([0-2][0-9]))))[\\/]\\d{4}$|^\\d{4}$/\" type=\"text\" class=\"form-control\" placeholder=\"mm/dd/yyyy\" required=\"\"><div class=\"help-block\" ng-messages=\"childform.child_dob.$error\" ng-if=\"childform.child_dob.$touched || childform.child_dob.$invalid && validateChild\"><div ng-message=\"required\">This field is required.</div><div ng-message=\"pattern\">Please enter MM/DD/YYYY format.</div></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : childform.schools.$touched && childform.schools.$invalid || childform.schools.$invalid && validateChild }\"><label for=\"schools\" class=\"col-sm-2 control-label\"><span class=\"text-danger\">*</span> School</label><div class=\"col-sm-10\"><select ng-model=\"vm.children_school\" ng-options=\"school.school_name for school in vm.schoolList track by school.alt_id\" class=\"form-control\" name=\"schools\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">--- Select School ---</option></select><div class=\"help-block\" ng-messages=\"childform.schools.$error\" ng-if=\"childform.schools.$touched || childform.schools.$invalid && validateChild\"><div ng-message=\"required\">Please select a school.</div></div></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-6\"><div class=\"checkbox foster-checkbox\"><label><input ng-model=\"vm.foster_child\" value=\"1\" name=\"foster_child\" type=\"checkbox\"> Foster Child (If this child is the legal responsibility of an Arizona welfare agency or court, and is currently living in your household, please check the box.)</label></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-default\" ng-click=\"vm.cancel()\">Cancel</button> <button ng-click=\"vm.saveChildInfo($event)\" ng-disabled=\"vm.addStudentBtn === \'Saving...\'\" ng-bind-html=\"vm.addStudentBtn\" type=\"button\" class=\"btn btn-primary\"><i class=\"fa fa-user-plus\"></i>Add Student</button></div></form>");
$templateCache.put("app/students/student.confirm.html","<div class=\"modal-header\"><h3 class=\"modal-title\">{{ vm.title }}</h3></div><div class=\"modal-body\" ng-class=\"vm.popClass\"><p class=\"lead\">If you accidentally added a duplicate student, we will automatically merge it with your existing student record within 1-2 business days. If you need to remove your application, please <a ui-sref=\"contact\" href=\"/contact\" ng-click=\"vm.cancel()\" title=\"contact us\"><i class=\"fa fa-envelope\"></i>Contact Us</a>.</p></div><div class=\"modal-footer\"><button class=\"btn btn-link\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.ok()\">OK</button></div>");
$templateCache.put("app/students/student.html","<article class=\"container\"><div class=\"row\"><div class=\"page-header\"><h1>Scholarship <small>Students</small></h1></div></div><div class=\"row\"><div class=\"col-md-2\"><div ng-include=\"\'app/components/navbar/scholarship.navbar.html\'\"></div></div><section class=\"col-md-10 scholarship family last-element\"><div class=\"panel panel-info\"><div class=\"panel-heading\"><h3>Student(s) Information</h3></div><div class=\"panel-body\"><div ng-show=\"vm.childloading\" class=\"text-center\"><h1><i class=\"fa fa-refresh fa-spin\"></i></h1></div><p class=\"visible-xs-block alert alert-info\"><i class=\"fa fa-info-circle\"></i>Swipe left or right to see additional details.</p><div class=\"table-responsive\" ng-hide=\"vm.childloading\"><table class=\"table table-striped table-hover table-responsive wow fadein\"><thead><tr><th><i class=\"fa fa-user\"></i>Name</th><th><i class=\"fa fa-calendar\"></i>DOB</th><th><i class=\"fa fa-university\"></i>School</th><th><i class=\"fa fa-child\"></i>Foster</th><th><i class=\"fa fa-cog\"></i>Manage</th></tr></thead><tbody><tr ng-repeat=\"student in vm.children | orderBy:\'fname\'\"><td>{{ student.fname | paseQuotes }} {{ student.mname }} {{ student.lname }}</td><td>{{ student.dob_month }}/{{ student.dob_day }}/{{ student.dob_year }}</td><td>{{ student.school_name }}</td><td>{{ (student.is_foster_child)?\'Y\':\'N\' }}</td><td><button type=\"button\" ng-click=\"vm.childEdit(student, $event)\" class=\"btn btn-default btn-circle btn-xs\"><i class=\"fa fa-pencil\"></i></button> <button type=\"button\" ng-click=\"vm.childDelete(student, $event)\" class=\"btn btn-default btn-circle btn-xs\"><i class=\"fa fa-user-times\"></i></button></td></tr></tbody></table></div></div></div><button ng-click=\"vm.childAdd()\" type=\"button\" class=\"btn btn-primary\"><i class=\"fa fa-user-plus\"></i>Add Student</button></section></div></article>");
$templateCache.put("app/students/student.update.html","<form name=\"childform\" class=\"form-horizontal\" role=\"form\" method=\"POST\" novalidate=\"\"><div class=\"modal-header\"><h3 class=\"modal-title\">Update Student</h3></div><div class=\"modal-body\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : childform.child_first_name.$error.required && childform.child_last_name.$error.required && childform.child_first_name.$dirty || validateChild && (childform.child_first_name.$invalid || childform.child_last_name.$invalid)}\"><label for=\"children_name\" class=\"col-sm-3 control-label\"><span class=\"text-danger\">*</span> Student Full Name</label><div class=\"col-sm-9\"><div class=\"row\"><div class=\"col-md-5\"><input ng-model=\"vm.children.fname\" class=\"form-control\" placeholder=\"First name\" maxlength=\"30\" name=\"child_first_name\" type=\"text\" required=\"\"><div class=\"help-block\" ng-messages=\"childform.child_first_name.$error\" ng-if=\"childform.child_first_name.$touched || childform.child_first_name.$invalid && validateChild\"><div ng-message=\"required\">This field is required.</div><div ng-message=\"maxlength\">First name is too long.</div></div></div><div class=\"col-md-2\"><input ng-model=\"vm.children.mname\" class=\"form-control\" placeholder=\"M\" maxlength=\"30\" name=\"child_middle_initial\" type=\"text\"></div><div class=\"col-md-5\" ng-class=\"{ \'has-error\' : childform.child_last_name.$touched && childform.child_last_name.$invalid || childform.child_last_name.$invalid && validateChild }\"><label for=\"child_last_name\" class=\"sr-only\">Last Name</label> <input ng-model=\"vm.children.lname\" class=\"form-control\" placeholder=\"Last name\" maxlength=\"30\" name=\"child_last_name\" type=\"text\" required=\"\"><div class=\"help-block\" ng-messages=\"childform.child_last_name.$error\" ng-if=\"childform.child_last_name.$touched || childform.child_last_name.$invalid && validateChild\"><div ng-message=\"required\">This field is required.</div><div ng-message=\"maxlength\">Last name is too long.</div></div></div></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : childform.dob.$error && childform.dob.$dirty || childform.dob.$invalid && validateChild }\"><label for=\"children_dob\" class=\"col-sm-3 control-label\"><span class=\"text-danger\">*</span> DOB</label><div class=\"col-sm-9\"><input ng-model=\"vm.dob\" name=\"dob\" ng-pattern=\"/^((((0[13578])|([13578])|(1[02]))[\\/](([1-9])|([0-2][0-9])|(3[01])))|(((0[469])|([469])|(11))[\\/](([1-9])|([0-2][0-9])|(30)))|((2|02)[\\/](([1-9])|([0-2][0-9]))))[\\/]\\d{4}$|^\\d{4}$/\" type=\"text\" class=\"form-control\" placeholder=\"mm/dd/yyyy\" required=\"\"><div class=\"help-block\" ng-messages=\"childform.dob.$error\" ng-if=\"childform.dob.$touched || childform.dob.$invalid && validateChild\"><div ng-message=\"required\">This field is required.</div><div ng-message=\"pattern\">Please enter MM/DD/YYYY format.</div></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : childform.schools.$touched && childform.schools.$invalid || childform.schools.$invalid && validateChild }\"><label for=\"children_school\" class=\"col-sm-3 control-label\"><span class=\"text-danger\">*</span> School</label><div class=\"col-sm-9\"><select ng-model=\"vm.school\" ng-options=\"school.school_name for school in vm.schoolList track by school.alt_id\" class=\"form-control\" name=\"schools\" required=\"\"></select><div class=\"help-block\" ng-messages=\"childform.schools.$error\" ng-if=\"childform.schools.$touched || childform.schools.$invalid && validateChild\"><div ng-message=\"required\">Please select a school.</div></div></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-6\"><div class=\"checkbox foster-checkbox\"><label><input ng-model=\"vm.foster_child\" ng-checked=\"vm.fosterCheck\" value=\"1\" name=\"foster_child\" type=\"checkbox\"> Foster Child (If this child is the legal responsibility of an Arizona welfare agency or court, and is currently living in your household, please check the box.)</label></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-default\" ng-click=\"vm.cancel()\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"vm.update()\">Update</button></div></form>");
$templateCache.put("app/components/customlinkInputs/customlinkInputs.html","<form name=\"customlinkForm\" role=\"form\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : customlinkForm.student.$error.required && (customlinkForm.student.$dirty || customlinkForm.student.$touched) }\"><label for=\"student\">Original Tax Credit - Student Recommendation (Required)</label> <input name=\"student\" type=\"text\" class=\"form-control\" id=\"student\" required=\"\" ng-model=\"vm.student\" ng-change=\"vm.updateUrl()\" placeholder=\"Student Recommendation\"> <span class=\"help-block\" ng-show=\"customlinkForm.student.$error.required && (customlinkForm.student.$dirty || customlinkForm.student.$touched)\"><p class=\"text-danger\">You must enter a student to create a custom link.</p></span></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : customlinkForm.school.$error.required && (customlinkForm.school.$dirty || customlinkForm.school.$touched) }\"><label for=\"school\">Original Tax Credit - School (Required)</label><select name=\"school\" class=\"form-control\" id=\"school\" required=\"\" ng-model=\"vm.school\" ng-change=\"vm.updateUrl()\" ng-options=\"school.school_name for school in vm.schoolList track by school.alt_id\"><option value=\"\" disabled=\"\" selected=\"\">--- Select School ---</option></select><span class=\"help-block\" ng-show=\"customlinkForm.school.$error.required && (customlinkForm.school.$dirty || customlinkForm.school.$touched)\"><p class=\"text-danger\">You must enter a school to create a custom link.</p></span></div><div class=\"form-group\"><label for=\"overflowStudent\">Overflow Tax Credit - Student Recommendation</label> <input name=\"overflowStudent\" type=\"text\" class=\"form-control\" id=\"overflowStudent\" required=\"\" placeholder=\"Student Recommendation\" ng-model=\"vm.overflowStudent\" ng-change=\"vm.updateUrl()\"></div><div class=\"form-group\"><label for=\"overflowSchool\">Overflow Tax Credit - School</label><select name=\"overflowSchool\" class=\"form-control\" id=\"overflowSchool\" ng-change=\"vm.updateUrl()\" ng-model=\"vm.overflowSchool\" ng-options=\"school.school_name for school in vm.schoolList track by school.alt_id\"><option value=\"\" disabled=\"\" selected=\"\">--- Select School ---</option></select></div><div class=\"form-group\" ng-if=\"vm.showResetFormBtn\"><button type=\"reset\" id=\"reset\" class=\"btn btn-default\" ng-click=\"vm.resetForm()\">Reset Form</button></div></form>");
$templateCache.put("app/components/footer/footer.html","<footer class=\"footer\"><div class=\"container notice\"><div class=\"row text-center\"><div class=\"col-md-12\"><ul class=\"list-inline\"><li><i class=\"fa fa-copyright\"></i>2014-<span id=\"year\"></span> Arizona Christian School Tuition Organization</li><li><a href=\"https://acsto.org/privacy-policy\" target=\"_blank\">Privacy Policy</a></li><li><a href=\"https://acsto.org/azdor-certification\" target=\"_blank\">ADOR Certification</a></li></ul><ul class=\"list-inline socialmedia\"><li><a href=\"//facebook.com/acstoconnect\" target=\"_blank\" title=\"acstoconnect facebook\"><i class=\"fa fa-facebook-official fa-1half\"></i></a></li><li><a href=\"//instagram.com/acstoconnect\" target=\"_blank\" title=\"acstoconnect instagram\"><i class=\"fa fa-instagram\"></i></a></li></ul><p><small>Notice: A school tuition organization cannot award, restrict, or reserve scholarships solely on the basis of a donor\'s recommendation. A taxpayer may not claim a tax credit if the taxpayer agrees to swap donations with another taxpayer to benefit either taxpayer’s own dependent. A.R.S. 43-1603 (C). Any designation of your own dependent as a potential recipient is prohibited.</small></p><div id=\"DigiCertClickID_-6G8CrSS\" data-language=\"en_US\"><br><a href=\"https://www.digicert.com/wildcard-ssl-certificates.htm\">ACSTO Certified SSL</a></div><script type=\"text/javascript\">\n        var __dcid = __dcid || [];__dcid.push([\"DigiCertClickID_-6G8CrSS\", \"7\", \"s\", \"white\", \"-6G8CrSS\"]);(function(){var cid=document.createElement(\"script\");cid.async=true;cid.src=\"//seal.digicert.com/seals/cascade/seal.min.js\";var s = document.getElementsByTagName(\"script\");var ls = s[(s.length - 1)];ls.parentNode.insertBefore(cid, ls.nextSibling);}());\n        </script></div></div></div></footer><script>\n  document.getElementById(\'year\').innerHTML = new Date().getFullYear();\n</script>");
$templateCache.put("app/components/navbar/navbar.html","<nav ng-show=\"authenticated\" class=\"navbar navbar-default nav-main\" role=\"navigation\"><div class=\"container\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle\" ng-init=\"isCollapsed = true\" ng-click=\"isCollapsed = !isCollapsed\"><span class=\"sr-only\">Toggle Navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand\" ui-sref=\"scholarship.dashboard\"><img src=\"/img/acsto.small.png\" class=\"img-responsive\" alt=\"\"></a></div><div class=\"collapse navbar-collapse\" uib-collapse=\"isCollapsed\"><ul class=\"nav navbar-nav\"><li class=\"dropdown\" ui-sref-active=\"active\" uib-dropdown=\"\"><a href=\"#\" uib-dropdown-toggle=\"\" class=\"dropdown-toggle\" data-toggle=\"dropdown\"><i class=\"fa fa-graduation-cap\"></i> Scholarships &amp; Applications <span class=\"caret\"></span></a><ul class=\"dropdown-menu\" role=\"menu\"><li><a ui-sref=\"scholarship.dashboard\"><i class=\"fa fa-tachometer\"></i> Scholarships &amp; Applications Dashboard</a></li><li><a ui-sref=\"students\"><i class=\"fa fa-users\"></i> Students</a></li><li><a ui-sref=\"scholarship.apply\"><i class=\"fa fa-plus\"></i> Apply</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"profile\"><i class=\"fa fa-user\"></i> Profile</a></li><li class=\"dropdown\" ui-sref-active=\"active\" uib-dropdown=\"\"><a href=\"#\" uib-dropdown-toggle=\"\" class=\"dropdown-toggle\" data-toggle=\"dropdown\"><i class=\"fa fa-certificate\"></i> Resources <span class=\"caret\"></span></a><ul class=\"dropdown-menu\" role=\"menu\"><li><a ui-sref=\"literature\"><i class=\"fa fa-file-text-o\"></i> Brochures</a></li><li><a ng-href=\"https://acsto.org/donors/claim-your-credit\" target=\"_blank\"><i class=\"fa fa-file-pdf-o\"></i> Tax Credit Forms</a></li><li><a ng-href=\"https://acsto.org/about/school-choice-resources\" target=\"_blank\"><i class=\"fa fa-file\"></i> School Choice Resources</a></li><li><a ng-href=\"https://acsto.org\" title=\"Arizona Christian School Tuition Organization\" target=\"_blank\"><i class=\"fa fa-reply\"></i> Back to ACSTO.org</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"contact\"><i class=\"fa fa-envelope\"></i> Contact Us</a></li><li ui-sref-active=\"active\"><a ui-sref=\"faq\"><i class=\"fa fa-question-circle\"></i> FAQs</a></li></ul><ul class=\"nav navbar-nav navbar-right\"><li><a ng-click=\"vm.logout()\"><i class=\"fa fa-sign-out\"></i> Logout</a></li></ul></div></div></nav>");
$templateCache.put("app/components/navbar/scholarship.navbar.html","<ul class=\"nav nav-pills nav-stacked\"><li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"scholarship.dashboard\"><i class=\"fa fa-tachometer\"></i> Scholarships &amp; Applications Dashboard</a></li><li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"students\"><i class=\"fa fa-users\"></i> Students</a></li><li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"scholarship.apply\"><i class=\"fa fa-plus\"></i> Apply</a></li><li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"financial\"><i class=\"fa fa-usd\"></i> Update Financial Information</a></li><li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"customlink\"><i class=\"fa fa-link\"></i> Create Custom Donation Link</a></li><li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"manageLandingPage\"><i class=\"fa fa-newspaper-o\"></i> Create/Manage ACSTO Family Page</a></li></ul>");
$templateCache.put("app/components/spanishModal/spanishModal.html","<form name=\"childform\" class=\"form-horizontal\" role=\"form\" method=\"POST\" novalidate=\"\"><div class=\"modal-header\"><h3 class=\"modal-title\">NOTA</h3></div><div class=\"modal-body\">Nuestro portal para padres está disponible solo en inglés en este momento. Puede continuar en el portal o si prefiere aplicar con nuestra aplicación en español, haga clic <a href=\"https://es.acsto.org/padres/aplique-ahora\" target=\"_blank\">aquí</a>.</div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.ok()\">Continuar</button></div></form>");
$templateCache.put("app/scholarship/add/addScholarship.html","<article class=\"container\"><div class=\"row\"><div class=\"page-header\"><h1>Scholarship <small>Apply</small></h1></div><div class=\"col-md-2\"><div ng-include=\"\'app/components/navbar/scholarship.navbar.html\'\"></div></div><div class=\"col-md-10\"><form name=\"scholarship\" class=\"form-horizontal scholarship\" role=\"form\" method=\"POST\" novalidate=\"\"><ol class=\"breadcrumb\"><li class=\"active\">Family Information</li><li>Narrative</li><li>Financial Information</li><li>Overflow Tax Credit</li><li>Review</li></ol><div class=\"alert alert-info\" role=\"alert\"><p>When you begin a scholarship application, a copy will be saved automatically for you. You can return to the application from <a ui-sref=\"scholarship.dashboard\"><i class=\"fa fa-tachometer\"></i>Scholarships &amp; Applications Dashboard</a> in the \"Saved Applications (in progress)\" tab.</p><p>Once the application has begun, you can save the application at any time by clicking on the \"Save Now &amp; Finish Later\" button.</p></div><div class=\"panel panel-primary\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Parent Information</h3></div><div class=\"panel-body\"><div class=\"alert alert-info\" role=\"alert\" style=\"margin:0 -15px 15px;\"><h5><i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>&nbsp;Please confirm the information is correct. Updates can be made in your <a ui-sref=\"profile\" class=\"btn btn-link\" style=\"padding:0;\"><i class=\"fa fa-user\"></i>Profile</a>.</h5></div><div class=\"form-group\" ng-class=\"{ \'has-error\': scholarship.parent_first_name.$touched && scholarship.parent_first_name.$invalid || scholarship.parent_last_name.$touched && scholarship.parent_last_name.$invalid || scholarship.parent_last_name.$invalid && scholarship.parent_first_name.$invalid && vm.validateParent}\"><label class=\"control-label\"><span class=\"text-danger\">*</span> Parent Name(s)</label><div class=\"row\"><div class=\"col-md-5\"><label for=\"parent_first_name\" class=\"sr-only\">First Name</label> <input ng-model=\"vm.user.parent_first_name\" class=\"form-control\" placeholder=\"First name\" maxlength=\"50\" name=\"parent_first_name\" type=\"text\" readonly=\"\" required=\"\"><div class=\"help-block\" ng-messages=\"scholarship.parent_first_name.$error\" ng-if=\"scholarship.parent_first_name.$touched || scholarship.parent_first_name.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div><div class=\"col-md-2\"><label for=\"parent_middle_initial\" class=\"sr-only\">Middle Initial</label> <input ng-model=\"vm.user.parent_middle_initial\" class=\"form-control\" placeholder=\"M.I.\" maxlength=\"30\" name=\"parent_middle_initial\" type=\"text\" readonly=\"\"></div><div class=\"col-md-5\"><label for=\"parent_last_name\" class=\"sr-only\">Last Name</label> <input ng-model=\"vm.user.parent_last_name\" class=\"form-control\" placeholder=\"Last name\" maxlength=\"30\" name=\"parent_last_name\" type=\"text\" readonly=\"\" required=\"\"><div class=\"help-block\" ng-messages=\"scholarship.parent_last_name.$error\" ng-if=\"scholarship.parent_last_name.$touched || scholarship.parent_last_name.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : scholarship.parent_phone.$touched && scholarship.parent_phone.$invalid || scholarship.parent_phone.$invalid && vm.validateParent }\"><label for=\"parent_phone\" class=\"control-label\"><span class=\"text-danger\">*</span> Phone</label> <input ng-model=\"vm.user.parent_phone\" ng-minlength=\"10\" class=\"form-control\" placeholder=\"Phone\" maxlength=\"15\" name=\"parent_phone\" type=\"text\" format-phone=\"\" readonly=\"\" required=\"\"><div class=\"help-block\" ng-messages=\"scholarship.parent_phone.$error\" ng-if=\"scholarship.parent_phone.$touched || scholarship.parent_phone.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : scholarship.city.$error.required && scholarship.zip.$error.required && scholarship.city.$dirty || vm.validateParent && (scholarship.city.$invalid || scholarship.zip.$invalid)}\"><label class=\"control-label\"><span class=\"text-danger\">*</span> Address</label> <input ng-model=\"vm.user.address\" type=\"text\" class=\"form-control\" placeholder=\"Address\" name=\"address\" readonly=\"\" required=\"\"><div class=\"help-block\" ng-messages=\"scholarship.address.$error\" ng-if=\"scholarship.address.$touched || scholarship.address.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div><div class=\"form-group\"><label class=\"control-label\">Address 2</label> <input ng-model=\"vm.user.address2\" type=\"text\" class=\"form-control\" placeholder=\"Apt / Suite / Other\" name=\"address2\" value=\"\" readonly=\"\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : scholarship.zip.$error.required && scholarship.zip.$dirty || scholarship.city.$invalid && vm.validateParent }\"><label class=\"control-label\"><span class=\"text-danger\">*</span> City/<span class=\"text-danger\">*</span> State/<span class=\"text-danger\">*</span> ZIP</label><div class=\"row\"><div class=\"col-md-5\"><label for=\"city\" class=\"sr-only\">City</label> <input ng-model=\"vm.user.city\" class=\"form-control\" maxlength=\"30\" name=\"city\" type=\"text\" readonly=\"\" required=\"\"><div class=\"help-block\" ng-messages=\"scholarship.city.$error\" ng-if=\"scholarship.city.$touched || scholarship.city.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div><div class=\"col-md-4\"><label for=\"state\" class=\"sr-only\">State</label><select ng-model=\"vm.user.state\" ng-options=\"state.value for state in vm.states track by state.value\" name=\"state\" class=\"form-control\" readonly=\"\" disabled=\"\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">--- Select State ---</option></select><div class=\"help-block\" ng-messages=\"scholarship.state.$error\" ng-if=\"scholarship.state.$touched || scholarship.state.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div><div class=\"col-md-3\"><label for=\"zip\" class=\"sr-only\">ZIP</label> <input ng-model=\"vm.user.zip\" pattern=\"\\d*\" class=\"form-control\" id=\"zip\" maxlength=\"5\" name=\"zip\" type=\"text\" readonly=\"\" required=\"\"><div class=\"help-block\" ng-messages=\"scholarship.zip.$error\" ng-if=\"scholarship.zip.$touched || scholarship.zip.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div></div></div></div></div><div class=\"panel panel-primary\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Student Information</h3></div><div class=\"panel-body\"><div ng-if=\"vm.appAlert\" class=\"alert alert-info\" role=\"alert\" style=\"margin:0 -15px 15px;\"><h5 class=\"lead\"><i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>&nbsp;NOTE: Applications for the {{ vm.appAlert }} school year will <strong>NOT</strong> be available until February 3, {{vm.appAlertYear}}.</h5></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : scholarship.student.$touched && scholarship.student.$invalid || scholarship.student.$invalid && vm.validateParent }\"><label for=\"student\">Student</label><select ng-model=\"vm.students\" ng-options=\"child.fname for child in vm.studentList track by child.web_id\" ng-change=\"vm.loadChildSchool(vm.students)\" class=\"form-control\" name=\"student\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">--- Select Student ---</option></select><div class=\"help-block\" ng-messages=\"scholarship.student.$error\" ng-if=\"scholarship.student.$touched || scholarship.student.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div><div class=\"form-group\"><label>Is your child not listed?</label> <button ng-click=\"vm.addStudent()\" type=\"button\" class=\"btn btn-warning hidden-xs\">Add a Student</button> <button ng-click=\"vm.addStudent()\" type=\"button\" class=\"btn btn-warning visible-xs-block btn-block\">Add a Student</button></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : scholarship.schoolYearDrop.$touched && scholarship.schoolYearDrop.$invalid || scholarship.schoolYearDrop.$invalid && vm.validateParent }\"><label for=\"schoolYearDrop\" ng-bind-html=\"vm.schoolYearLabel\"></label><select ng-model=\"vm.schoolYearDrop\" ng-options=\"year.value for year in vm.schoolYearList track by year.value\" ng-change=\"vm.updateSchoolYear()\" class=\"form-control\" name=\"schoolYearDrop\" required=\"\"><option value=\"\">--- Select Application Year ---</option></select><div class=\"help-block\" ng-messages=\"scholarship.schoolYearDrop.$error\" ng-if=\"scholarship.schoolYearDrop.$touched || scholarship.schoolYearDrop.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : scholarship.school.$touched && scholarship.school.$invalid || scholarship.school.$invalid && vm.validateParent }\"><label for=\"schools\">School</label><select ng-model=\"vm.school\" ng-options=\"school.school_name for school in vm.schoolList track by school.alt_id\" class=\"form-control\" name=\"school\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">--- Select School ---</option></select><div class=\"help-block\" ng-messages=\"scholarship.school.$error\" ng-if=\"scholarship.school.$touched || scholarship.school.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : scholarship.grade.$touched && scholarship.grade.$invalid || scholarship.grade.$invalid && vm.validateParent }\"><label for=\"grade\" ng-show=\"!vm.schoolYear\">Grade</label> <label for=\"grade\" ng-show=\"vm.schoolYear\">Grade for {{ vm.schoolYear }}</label><select ng-model=\"vm.grade\" ng-options=\"grade.value for grade in vm.gradeList track by grade.label\" ng-change=\"vm.handleGradeChange()\" class=\"form-control\" name=\"grade\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">--- Select Grade ---</option></select><div class=\"help-block\" ng-messages=\"scholarship.grade.$error\" ng-if=\"scholarship.grade.$touched || scholarship.grade.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : scholarship.tuition_amt.$touched && scholarship.tuition_amt.$invalid || scholarship.tuition_amt.$invalid && vm.validateParent }\"><label for=\"tuition_amt\" ng-show=\"vm.students.fname && vm.schoolYear\">Total tuition after all discounts are applied for {{ vm.students.fname | paseQuotes }} for {{ vm.schoolYear }} <i class=\"fa fa-question-circle text-info\" popover-placement=\"top\" popover-trigger=\"mouseenter\" uib-popover=\"Please round to the nearest whole dollar, with no punctuation.\"></i>:</label> <label for=\"tuition_amt\" ng-show=\"!vm.students.fname || !vm.schoolYear\">Total tuition after all discounts are applied</label> <input ng-model=\"vm.tuition_amt\" class=\"form-control\" name=\"tuition_amt\" min=\"1000\" type=\"number\" placeholder=\"Example: 6500\" required=\"\"><div class=\"help-block\" ng-messages=\"scholarship.tuition_amt.$error\" ng-if=\"scholarship.tuition_amt.$touched || scholarship.tuition_amt.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div><div ng-message=\"min\">A minimum of $1000 is required for Total tuition.</div></div></div></div></div><div class=\"clearfix\"><div class=\"pull-left\"><a ui-sref=\"scholarship.dashboard\" class=\"btn btn-link\">Cancel</a> <button ng-click=\"vm.saveScholarship($event)\" ng-disabled=\"vm.save === \'Saving scholarship application...\'\" ng-bind-html=\"vm.save\" type=\"button\" class=\"btn btn-info\"></button></div><div class=\"pull-right\"><button ng-click=\"vm.startScholarship($event)\" ng-disabled=\"vm.begin === \'Creating scholarship application...\'\" ng-bind-html=\"vm.begin\" type=\"button\" class=\"btn btn-primary\"></button></div></div><br><br></form></div></div></article>");
$templateCache.put("app/scholarship/edit/alert.html","<div class=\"modal-header\"><h3 class=\"modal-title\">{{ vm.title }}</h3></div><div class=\"modal-body\" ng-class=\"vm.popClass\" ng-bind-html=\"vm.msg\"></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.ok()\">OK</button></div>");
$templateCache.put("app/scholarship/edit/editScholarship.html","<article class=\"container\"><div class=\"row\"><div class=\"page-header\"><h1>Scholarship <small>Apply</small></h1></div><div class=\"col-md-2\"><div ng-include=\"\'app/components/navbar/scholarship.navbar.html\'\"></div></div><div class=\"col-md-10\"><form name=\"scholarship\" class=\"form-horizontal scholarship\" role=\"form\" method=\"POST\" novalidate=\"\"><ol class=\"breadcrumb\"><li class=\"active\">Family Information</li><li>Narrative</li><li>Financial Information</li><li>Overflow Tax Credit</li><li>Review</li></ol><div class=\"alert alert-info\" role=\"alert\"><p>When you begin a scholarship application, a copy will be saved automatically for you. You can return to the application from <a ui-sref=\"scholarship.dashboard\"><i class=\"fa fa-tachometer\"></i>Scholarships &amp; Applications Dashboard</a> in the \"Saved Applications (in progress)\" tab.</p><p>Once the application has begun, you can save the application at any time by clicking on the \"Save Now &amp; Finish Later\" button.</p></div><div class=\"panel panel-primary\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Parent Information</h3></div><div class=\"panel-body\"><div class=\"form-group\" ng-class=\"{ \'has-error\': scholarship.parent_first_name.$touched && scholarship.parent_first_name.$invalid || scholarship.parent_last_name.$touched && scholarship.parent_last_name.$invalid || scholarship.parent_last_name.$invalid && scholarship.parent_first_name.$invalid && vm.validateParent}\"><label class=\"control-label\"><span class=\"text-danger\">*</span> Parent Name(s)</label><div class=\"row\"><div class=\"col-md-5\"><label for=\"parent_first_name\" class=\"sr-only\">First Name</label> <input ng-model=\"vm.user.parent_first_name\" class=\"form-control\" placeholder=\"First name\" maxlength=\"50\" name=\"parent_first_name\" type=\"text\" readonly=\"\" required=\"\"><div class=\"help-block\" ng-messages=\"scholarship.parent_first_name.$error\" ng-if=\"scholarship.parent_first_name.$touched || scholarship.parent_first_name.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div><div class=\"col-md-2\"><label for=\"parent_middle_initial\" class=\"sr-only\">Middle Initial</label> <input ng-model=\"vm.user.parent_middle_initial\" class=\"form-control\" placeholder=\"M.I.\" maxlength=\"30\" name=\"parent_middle_initial\" type=\"text\" readonly=\"\"></div><div class=\"col-md-5\"><label for=\"parent_last_name\" class=\"sr-only\">Last Name</label> <input ng-model=\"vm.user.parent_last_name\" class=\"form-control\" placeholder=\"Last name\" maxlength=\"30\" name=\"parent_last_name\" type=\"text\" readonly=\"\" required=\"\"><div class=\"help-block\" ng-messages=\"scholarship.parent_last_name.$error\" ng-if=\"scholarship.parent_last_name.$touched || scholarship.parent_last_name.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : scholarship.parent_phone.$touched && scholarship.parent_phone.$invalid || scholarship.parent_phone.$invalid && vm.validateParent }\"><label for=\"parent_phone\" class=\"control-label\"><span class=\"text-danger\">*</span> Phone</label> <input ng-model=\"vm.user.parent_phone\" ng-minlength=\"10\" class=\"form-control\" placeholder=\"Phone\" maxlength=\"15\" name=\"parent_phone\" type=\"text\" format-phone=\"\" readonly=\"\" required=\"\"><div class=\"help-block\" ng-messages=\"scholarship.parent_phone.$error\" ng-if=\"scholarship.parent_phone.$touched || scholarship.parent_phone.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : scholarship.city.$error.required && scholarship.zip.$error.required && scholarship.city.$dirty || vm.validateParent && (scholarship.city.$invalid || scholarship.zip.$invalid)}\"><label class=\"control-label\"><span class=\"text-danger\">*</span> Address</label> <input ng-model=\"vm.user.address\" type=\"text\" class=\"form-control\" placeholder=\"Address\" name=\"address\" readonly=\"\" required=\"\"><div class=\"help-block\" ng-messages=\"scholarship.address.$error\" ng-if=\"scholarship.address.$touched || scholarship.address.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div><div class=\"form-group\"><label class=\"control-label\">Address 2</label> <input ng-model=\"vm.user.address2\" type=\"text\" class=\"form-control\" placeholder=\"Apt / Suite / Other\" name=\"address2\" readonly=\"\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : scholarship.zip.$error.required && scholarship.zip.$dirty || scholarship.city.$invalid && vm.validateParent }\"><label class=\"control-label\"><span class=\"text-danger\">*</span> City/<span class=\"text-danger\">*</span> State/<span class=\"text-danger\">*</span> ZIP</label><div class=\"row\"><div class=\"col-md-5\"><label for=\"city\" class=\"sr-only\">City</label> <input ng-model=\"vm.user.city\" class=\"form-control\" maxlength=\"30\" name=\"city\" type=\"text\" readonly=\"\" required=\"\"><div class=\"help-block\" ng-messages=\"scholarship.city.$error\" ng-if=\"scholarship.city.$touched || scholarship.city.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div><div class=\"col-md-4\"><label for=\"state\" class=\"sr-only\">State</label><select ng-model=\"vm.user.state\" ng-options=\"state.value for state in vm.states track by state.value\" name=\"state\" class=\"form-control\" readonly=\"\" disabled=\"\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">--- Select State ---</option></select><div class=\"help-block\" ng-messages=\"scholarship.state.$error\" ng-if=\"scholarship.state.$touched || scholarship.state.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div><div class=\"col-md-3\"><label for=\"zip\" class=\"sr-only\">ZIP</label> <input ng-model=\"vm.user.zip\" pattern=\"\\d*\" class=\"form-control\" id=\"zip\" maxlength=\"5\" name=\"zip\" type=\"text\" readonly=\"\" required=\"\"><div class=\"help-block\" ng-messages=\"scholarship.zip.$error\" ng-if=\"scholarship.zip.$touched || scholarship.zip.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div></div></div></div></div><div class=\"panel panel-primary\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Student Information</h3></div><div class=\"panel-body\"><div ng-if=\"vm.appAlert\" class=\"alert alert-info\" role=\"alert\" style=\"margin:0 -15px 15px;\"><h5 class=\"lead\"><i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>NOTE: Applications for the {{ vm.appAlert }} school year will <strong>NOT</strong> be available until February 3, {{vm.appAlertYear}}.</h5></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : scholarship.student.$touched && scholarship.student.$invalid || scholarship.student.$invalid && vm.validateParent }\"><label for=\"student\">Student</label><select ng-model=\"vm.students\" ng-options=\"child.fname for child in vm.studentList track by child.web_id\" class=\"form-control\" name=\"student\" readonly=\"\" disabled=\"\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">--- Select Student ---</option></select><div class=\"help-block\" ng-messages=\"scholarship.student.$error\" ng-if=\"scholarship.student.$touched || scholarship.student.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : scholarship.schoolYearDrop.$touched && scholarship.schoolYearDrop.$invalid || scholarship.schoolYearDrop.$invalid && vm.validateParent }\"><label for=\"schoolYearDrop\" ng-bind-html=\"vm.schoolYearLabel\"></label><select ng-model=\"vm.schoolYearDrop\" ng-options=\"year.value for year in vm.schoolYearList track by year.value\" ng-change=\"vm.updateSchoolYear()\" class=\"form-control\" name=\"schoolYearDrop\" required=\"\"><option value=\"\">--- Select Application Year ---</option></select><div class=\"help-block\" ng-messages=\"scholarship.schoolYearDrop.$error\" ng-if=\"scholarship.schoolYearDrop.$touched || scholarship.schoolYearDrop.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : scholarship.school.$touched && scholarship.school.$invalid || scholarship.school.$invalid && vm.validateParent }\"><label for=\"schools\">School</label><select ng-model=\"vm.school\" ng-options=\"school.school_name for school in vm.schoolList track by school.alt_id\" class=\"form-control\" name=\"school\" readonly=\"\" disabled=\"\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">--- Select School ---</option></select><div class=\"help-block\" ng-messages=\"scholarship.school.$error\" ng-if=\"scholarship.school.$touched || scholarship.school.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : scholarship.grade.$touched && scholarship.grade.$invalid || scholarship.grade.$invalid && vm.validateParent }\"><label for=\"grade\" ng-show=\"!vm.schoolYear\">Grade</label> <label for=\"grade\" ng-show=\"vm.schoolYear\">Grade for {{ vm.schoolYear }}</label><select ng-model=\"vm.grade\" ng-options=\"grade.value for grade in vm.gradeList track by grade.label\" class=\"form-control\" name=\"grade\" readonly=\"\" disabled=\"\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">--- Select Grade ---</option></select><div class=\"help-block\" ng-messages=\"scholarship.grade.$error\" ng-if=\"scholarship.grade.$touched || scholarship.grade.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : scholarship.tuition_amt.$touched && scholarship.tuition_amt.$invalid || scholarship.tuition_amt.$invalid && vm.validateParent }\"><label for=\"tuition_amt\">Total tuition after all discounts are applied for {{ vm.students.fname | paseQuotes }} for {{ vm.schoolYear }} <i class=\"fa fa-question-circle text-info\" popover-placement=\"top\" popover-trigger=\"mouseenter\" uib-popover=\"Please round to the nearest whole dollar, with no punctuation.\"></i>:</label> <input ng-model=\"vm.tuition_amt\" class=\"form-control\" name=\"tuition_amt\" pattern=\"\\d*\" type=\"number\" placeholder=\"Example: 6500\" readonly=\"\" disabled=\"\" required=\"\"><div class=\"help-block\" ng-messages=\"scholarship.tuition_amt.$error\" ng-if=\"scholarship.tuition_amt.$touched || scholarship.tuition_amt.$invalid && vm.validateParent\"><div ng-message=\"required\">This field is required.</div><div ng-message=\"pattern\">Enter amount in whole dollars.</div></div></div></div></div><div class=\"clearfix\"><div class=\"pull-left\"><a ui-sref=\"scholarship.dashboard\" class=\"btn btn-link\">Cancel</a> <button ng-click=\"vm.saveScholarship($event)\" ng-disabled=\"vm.save === \'Saving scholarship application...\'\" ng-bind-html=\"vm.save\" type=\"button\" class=\"btn btn-info\"></button></div><div class=\"pull-right\"><a ng-click=\"vm.studentInfo($event)\" class=\"btn btn-primary\">Next: Narrative <i class=\"fa fa-chevron-right\"></i></a></div></div><br><br><br><br></form></div></div></article>");
$templateCache.put("app/scholarship/edit/narrative.html","<article class=\"container\"><div class=\"row\"><div class=\"page-header\"><h1>Scholarship <small>Apply</small></h1></div><div class=\"col-md-2\"><div ng-include=\"\'app/components/navbar/scholarship.navbar.html\'\"></div></div><div class=\"col-md-10\"><form name=\"scholarship\" class=\"form-horizontal scholarship\" role=\"form\" method=\"POST\" novalidate=\"\"><ol class=\"breadcrumb\"><li><a ui-sref=\"scholarship.edit({ scholarshipId: vm.id })\">Family Information</a></li><li class=\"active\">Narrative</li><li>Financial Information</li><li>Overflow Tax Credit</li><li>Review</li></ol><div class=\"alert alert-info\" role=\"alert\"><p>When you begin a scholarship application, a copy will be saved automatically for you. You can return to the application from <a ui-sref=\"scholarship.dashboard\"><i class=\"fa fa-tachometer\"></i>Scholarships &amp; Applications Dashboard</a> in the \"Saved Applications (in progress)\" tab.</p><p>Once the application has begun, you can save the application at any time by clicking on the \"Save Now &amp; Finish Later\" button.</p></div><div class=\"panel panel-primary\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Student Narrative</h3></div><div class=\"panel-body\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : scholarship.narrative.$dirty && scholarship.narrative.$invalid || scholarship.narrative.$invalid && vm.validateNarrative }\"><label for=\"text\">Narrative</label><p class=\"help-block\">Please provide a 2-3 paragraph narrative about your student in the space below. You may discuss the following as they apply to the student and his/her age: student’s character, leadership, community involvement, perseverance, school achievement, personal accomplishments, spiritual life, and/or extracurricular interests. Financial information should be included in the <strong>Financial Information</strong> section of this application, not in the Student Narrative.</p><textarea ng-bind-html=\"vm.narrative\" ng-model=\"vm.narrative\" min-word=\"30\" name=\"narrative\" class=\"form-control\" placeholder=\"We recommend you type and save your narrative in a separate document first. Then paste it here.\" rows=\"10\" required=\"\">\n							</textarea><div class=\"help-block\" ng-messages=\"scholarship.narrative.$error\" ng-if=\"scholarship.narrative.$dirty || scholarship.narrative.$invalid && vm.validateNarrative\"><div ng-message=\"required\">This field is required.</div><div ng-message=\"minWord\">A narrative is required. Please provide 2-3 paragraphs.</div></div></div></div></div><div class=\"clearfix\"><div class=\"pull-left\"><a ui-sref=\"scholarship.edit({ scholarshipId: vm.id })\" class=\"btn btn-link\"><i class=\"fa fa-chevron-left\"></i>Back</a> <button ng-click=\"vm.saveScholarship($event)\" ng-disabled=\"vm.save === \'Saving scholarship application...\'\" ng-bind-html=\"vm.save\" type=\"button\" class=\"btn btn-info\"></button></div><div class=\"pull-right\"><a ng-click=\"vm.saveNarrative($event)\" class=\"btn btn-primary\">Next: Financial Info &nbsp;&nbsp;<i class=\"fa fa-chevron-right\"></i></a></div></div><br><br></form></div></div></article>");
$templateCache.put("app/scholarship/edit/overflow-tax-credit.html","<article class=\"container\"><div class=\"row\"><div class=\"page-header\"><h1>Scholarship <small>Apply</small></h1></div><div class=\"col-md-2\"><div ng-include=\"\'app/components/navbar/scholarship.navbar.html\'\"></div></div><div class=\"col-md-10\"><form name=\"scholarship\" class=\"form-horizontal scholarship\" role=\"form\" method=\"POST\" novalidate=\"\"><ol class=\"breadcrumb\"><li><a ui-sref=\"scholarship.edit({ scholarshipId: vm.id })\">Family Information</a></li><li><a ui-sref=\"scholarship.narrative({ scholarshipId: vm.id })\">Narrative</a></li><li><a ui-sref=\"scholarship.income({ scholarshipId: vm.id })\">Financial Information</a></li><li class=\"active\">Overflow Tax Credit</li><li>Review</li></ol><div class=\"alert alert-info\" role=\"alert\"><p>When you begin a scholarship application, a copy will be saved automatically for you. You can return to the application from <a ui-sref=\"scholarship.dashboard\"><i class=\"fa fa-tachometer\"></i>Scholarships &amp; Applications Dashboard</a> in the \"Saved Applications (in progress)\" tab.</p><p>Once the application has begun, you can save the application at any time by clicking on the \"Save Now &amp; Finish Later\" button.</p></div><div class=\"panel panel-primary\"><div class=\"panel-heading\"><h3 class=\"panel-title\">ESA Status</h3></div><div class=\"panel-body\"><p>Empowerment Scholarship Accounts (ESAs) are a separate tuition funding source from tax credit scholarships (i.e., ACSTO scholarships). ESAs are administered by the <a href=\"https://www.azed.gov/\" target=\"_blank\">Arizona Department of Education</a>,&nbsp;<u>NOT</u>&nbsp;by ACSTO.</p><p>Per the ESA law, tax credit scholarships cannot be sent to the student\'s school while a parent has a signed ESA contract for the student. ACSTO <b>can hold</b> scholarship awards for future use after the student\'s ESA has been discontinued as long as: 1) the parent submits an ACSTO application each year and 2) the student remains enrolled at a Partner School.</p><br><div class=\"alert alert-acsto-secondary\" role=\"alert\"><p><b>AN ANSWER TO THE FOLLOWING QUESTION IS&nbsp;<u>REQUIRED</u>.</b></p><br><p>Do you intend to sign or have you signed an ESA contract with the Arizona Department of Education for this student during the school year that you are applying for?</p><br><div class=\"form-group\" ng-class=\"{ \'has-error\' : scholarship.using_esa.$invalid && scholarship.using_esa.$touched || vm.validateEsa && scholarship.using_esa.$invalid }\" style=\"margin-bottom: 0px !important\"><div class=\"col-md-4\" style=\"padding: 0\"><select ng-model=\"vm.using_esa_selection\" ng-options=\"usingEsa.label for usingEsa in vm.esaDropdown track by usingEsa.value\" class=\"form-control\" name=\"using_esa\" ng-change=\"vm.updateUsingESA()\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">-- Please select --</option></select><div class=\"help-block\" ng-messages=\"scholarship.using_esa.$error\" ng-if=\"scholarship.using_esa.$touched || scholarship.using_esa.$invalid && vm.validateEsa\"><p ng-message=\"required\">This field is required.</p></div></div></div></div></div></div><br><div class=\"panel panel-primary\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Overflow (Switcher) Tax Credit</h3></div><div class=\"panel-body\"><div class=\"alert alert-info\" role=\"alert\"><h3>INSTRUCTIONS:</h3><p>Please check if your child qualifies for a second opportunity called the Overflow scholarship. If your child does not qualify, skip this section by clicking Next on the bottom of this page.</p></div><p class=\"help-block\">The Overflow tax credit is another AZ tax credit available to those who qualify. If one of the following options applies to your child, check the appropriate box and upload the requested documentation (if any) to be considered for an additional scholarship under this law. Documents may be uploaded at the bottom of this page or submitted separately by email, fax, or mail.</p><div class=\"alert alert-info\"><p class=\"text-info\">You can email the required documentation to <a href=\"mailto:applications@acsto.org\"><i class=\"fa fa-envelope\"></i>applications@acsto.org</a>.</p></div><div class=\"checkbox\"><label><input ng-model=\"vm.public_school_transfer\" ng-click=\"vm.pst()\" ng-true-value=\"1\" name=\"public_school_transfer\" value=\"1\" type=\"checkbox\"> <strong>Transferring from an Arizona Public School (District or Charter)</strong></label><p class=\"help-block\">If your student is transferring to a private school after being enrolled full-time in an Arizona public school (district or charter school) for at least 90 days of the <strong><u>prior</u></strong> school year, please print the following form, have the public school complete it, then return it to ACSTO. It must show the number of days the student was enrolled in the Arizona public school during the school year <strong><u>prior</u></strong> to transferring to a private school. In lieu of the form, a printout from the public school’s student enrollment database providing the required data (e.g., a report card) will be accepted, as long as the information is issued by the public school office. <a href=\"/public-school-verification-form.pdf\" target=\"_blank\"><i class=\"fa fa-file-pdf-o\"></i>Public School Enrollment Verification Form</a></p></div><div class=\"checkbox\"><label><input ng-model=\"vm.kindergarten_disabled\" ng-click=\"vm.kd()\" ng-true-value=\"16\" name=\"kindergarten_disabled\" value=\"16\" type=\"checkbox\"> <strong>Preschool Students with Disabilities</strong></label><p class=\"help-block\">Your child qualifies if in preschool and has a disability and an IEP or MET Plan from an Arizona public school. There is a place to attach the IEP/MET documentation below. Tax credit scholarships can only be used at schools offering services that address the student’s identified disabilities.</p></div><div class=\"checkbox\"><label><input ng-model=\"vm.kindergarten_student\" ng-click=\"vm.ks()\" ng-true-value=\"2\" name=\"kindergarten_student\" value=\"2\" type=\"checkbox\"> <strong>Kindergarten Student</strong></label><p class=\"help-block\">Your child qualifies if entering kindergarten at a private school. In addition, they must be five years old on or before December 31 of their kindergarten year to be considered for tax credit scholarships. No additional documentation is required.</p></div><div class=\"checkbox\"><label><input ng-model=\"vm.us_armed_forces_dependent\" ng-click=\"vm.uafd()\" ng-true-value=\"4\" name=\"us_armed_forces_dependent\" value=\"4\" type=\"checkbox\"> <strong>U.S. Armed Forces Dependent</strong></label><p class=\"help-block\">If your child is a dependent of a member of the United States Armed Forces stationed in Arizona pursuant to military orders, attach a copy of those orders showing the location of the Arizona station. There is a place to attach documents below.</p></div><div class=\"checkbox\"><label><input ng-model=\"vm.home_school_transfer\" ng-click=\"vm.hst()\" ng-true-value=\"4\" name=\"home_school_transfer\" value=\"4\" type=\"checkbox\"> <strong>Homeschoolers in Arizona (not using ESA)</strong></label><p class=\"help-block\">If your child was homeschooled in Arizona and did not have an ESA immediately prior to enrolling in a private school, please submit the completed <a href=\"/homeschool-verification-form.pdf\" target=\"_blank\">Homeschool Verification Form</a>, <b>AND</b> one of the following:</p><ul><li><p class=\"help-block\">Affidavit of Intent to Homeschool filed with your county school superintendent</p></li><li><p class=\"help-block\">Homeschool Withdrawal Form filed with your county school superintendent</p></li><li><p class=\"help-block\">Homeschool curriculum proof of purchase</p></li></ul></div><div class=\"checkbox\"><label><input ng-model=\"vm.out_of_state_transfer\" ng-click=\"vm.oost()\" ng-true-value=\"4\" name=\"out_of_state_transfer\" value=\"4\" type=\"checkbox\"> <strong>Out of State Students</strong></label><p class=\"help-block\">If your student moved to Arizona from out of state immediately prior to enrolling in a private school, please print the <a href=\"/out-of-state-school-verification-form.pdf\" target=\"_blank\">Out of State School Verification Form</a>, have it completed by the out of state school, and attach it with the application. If your child was homeschooled out of state, please complete Section 2 on the <a href=\"/out-of-state-school-verification-form.pdf\" target=\"_blank\">Out of State School Verification Form</a>, <strong>AND</strong> submit one of the following:</p><ul><li><p class=\"help-block\">Affidavit or other evidence of Intent to Homeschool filed with required government entity</p></li><li><p class=\"help-block\">Homeschool Withdrawal Form from required government entity</p></li><li><p class=\"help-block\">Proof of purchase of homeschool curriculum</p></li></ul></div><div class=\"checkbox\"><label><input ng-model=\"vm.esa_transfer\" ng-click=\"vm.et()\" ng-true-value=\"4\" name=\"esa_transfer\" value=\"4\" type=\"checkbox\"> <strong>Previously participated in ESA Program</strong></label><p class=\"help-block\">If your student participated in the ESA program and did not renew or accept the scholarship in order to accept STO scholarships, documentation is needed to verify the student did not renew their ESA contract or cancelled their ESA contract. This can include an email or letter from the Arizona Department of Education that either states you did not renew the contract or is a \"Confirmation of Closure.\"</p></div><div class=\"checkbox\"><label><input ng-model=\"vm.prev_scholarship_recipient\" ng-click=\"vm.psr()\" ng-true-value=\"8\" name=\"prev_scholarship_recipient\" value=\"8\" type=\"checkbox\"> <strong>Previously Received Overflow or Corporate Scholarship*</strong></label><p class=\"help-block\">If your student received an <strong>Overflow</strong> scholarship or a <strong>Corporate</strong> scholarship (i.e., Low-Income or Disabled/Displaced scholarship) in a prior year <strong>AND</strong> has remained continuously enrolled in a private school since, please do the following:</p><ol><li><p class=\"help-block\">Select the organization (STO) that made the Overflow or Corporate award:</p><div class=\"form-group\" ng-class=\"{ \'has-error\' : scholarship.organization.$invalid && scholarship.organization.$dirty || vm.validateTax && scholarship.organization.$invalid }\"><select ng-model=\"vm.organization\" ng-options=\"sto.name for sto in vm.stos track by sto.name\" name=\"organization\" class=\"form-control\" ng-required=\"vm.prev_scholarship_recipient === \'Previously Received Corporate or PLUS Scholarship\'\"><option value=\"\" disabled=\"\" selected=\"\">--- Select STO ---</option></select><div class=\"help-block\" ng-messages=\"scholarship.organization.$error\" ng-if=\"scholarship.organization.$touched || scholarship.organization.$invalid && vm.validateTax\"><p ng-message=\"required\">This field is required.</p></div></div></li><li><p class=\"help-block\"><strong>If you selected ACSTO in the box above</strong> and your student has remained continuously enrolled in a private school since receiving the Overflow award, <em>no additional documentation is required</em>.</p></li><li><p class=\"help-block\"><strong>If you selected any other STO in the box above</strong> and your student has remained continuously enrolled in a private school since receiving the Overflow or Corporate award, print the <a href=\"/previous_scholarship_award_verification.2025.pdf\" target=\"_blank\"><i class=\"fa fa-file-pdf-o\"></i>Previous Scholarship Verification</a> form, have the awarding STO fill it out, then return it to ACSTO. In lieu of the form, a copy of an award letter from the other STO will be accepted. <em>If you submitted this documentation to us in the past and the student has remained continuously enrolled in private school since receiving the award, you do not need to submit documentation again.</em></p></li></ol><div class=\"alert alert-info\" role=\"alert\"><p>* ACSTO awards two types of scholarships, Original and Overflow. <strong>ACSTO does not award Corporate scholarships.</strong> Previous Original scholarship awards may not be used as a prerequisite to qualify for Overflow scholarships. To determine if an STO has previously awarded an Overflow or Corporate scholarship, you may review your past award letters, contact your school’s financial office, or contact the awarding STO.</p></div></div><br><br><div><div class=\"form-group\"><label for=\"comment\">Comment/Notes:</label> <textarea name=\"comment\" ng-model=\"vm.comment\" ng-bind-html=\"vm.comment\" placeholder=\"Optional\" class=\"form-control\" rows=\"4\"></textarea></div></div><div style=\"position: relative\"><div style=\"position: absolute; top: 100px; z-index:100; left: 15%\">If you are having difficulty attaching a file, you may email your attachments to <a href=\"mailto:applications@acsto.org\" style=\"z-index: 100\">applications@acsto.org</a>.</div><div type=\"file\" ngf-drop=\"\" ngf-select=\"\" ng-model=\"files\" class=\"drop-box\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/jpeg,image/jpg,image/png,image/gif,image/bmp,application/pdf,application/msword\" ngf-pattern=\"\'image/jpeg,image/jpg,image/png,image/gif,image/bmp,application/pdf,application/msword\'\"><i class=\"fa fa-cloud-upload\"></i>Click or Drag &amp; Drop Files Here to Upload.<div class=\"drop-title\">We prefer PDF, image, or Word files.</div><button class=\"btn btn-default drop-btn\" style=\"margin-top:60px\">Select Files to Import</button></div><div><br><p>Files:</p><ul><li ng-repeat=\"f in vm.uploadedFiles\" style=\"font:smaller\">{{ f.original_filename }} <button ng-click=\"vm.deletFile($event, f)\" class=\"btn btn-link btn-xs\"><span class=\"fa fa-times text-danger\"></span></button></li></ul></div><div class=\"alert alert-danger\" role=\"alert\" ngf-no-file-drop=\"\"><i class=\"fa fa-exclamation-triangle\"></i>File Drag/Drop is not supported for this browser. Please mail or email your file(s).</div><div class=\"progress file-progress\"><uib-progressbar class=\"progress-striped active\" ng-class=\"{ \'active\': vm.dynamic < 100 }\" value=\"vm.dynamic\" type=\"{{vm.type}}\"><strong>{{vm.dynamic}}% <i ng-show=\"vm.showComplete\">Complete!</i></strong></uib-progressbar></div></div></div></div><div class=\"clearfix\"><div class=\"pull-left\"><a ui-sref=\"scholarship.income({ scholarshipId: vm.id })\" class=\"btn btn-link\"><i class=\"fa fa-chevron-left\"></i> Back</a> <button ng-click=\"vm.saveScholarship($event)\" ng-disabled=\"vm.save === \'Saving scholarship application...\'\" ng-bind-html=\"vm.save\" type=\"button\" class=\"btn btn-info\"></button></div><div class=\"pull-right\"><a ng-click=\"vm.taxOverFlow($event)\" class=\"btn btn-primary\">Next: Review <i class=\"fa fa-chevron-right\"></i></a></div></div><br><br></form></div></div></article>");
$templateCache.put("app/scholarship/edit/review.html","<article class=\"container\"><div class=\"row\"><div class=\"page-header\"><h1>Scholarship <small>Apply</small></h1></div><div class=\"col-md-2\"><div ng-include=\"\'app/components/navbar/scholarship.navbar.html\'\"></div></div><div class=\"col-md-10\"><form name=\"scholarship\" class=\"form-horizontal scholarship\" role=\"form\" method=\"POST\" novalidate=\"\"><ol class=\"breadcrumb\"><li><a ui-sref=\"scholarship.edit({ scholarshipId: vm.id })\">Family Information</a></li><li><a ui-sref=\"scholarship.narrative({ scholarshipId: vm.id })\">Narrative</a></li><li><a ui-sref=\"scholarship.income({ scholarshipId: vm.id })\">Financial Information</a></li><li><a ui-sref=\"scholarship.taxcredit({ scholarshipId: vm.id })\">Overflow Tax Credit</a></li><li class=\"active\">Review</li></ol><div class=\"alert alert-info\" role=\"alert\"><p>When you begin a scholarship application, a copy will be saved automatically for you. You can return to the application from <a ui-sref=\"scholarship.dashboard\"><i class=\"fa fa-tachometer\"></i>Scholarships &amp; Applications Dashboard</a> in the \"Saved Applications (in progress)\" tab.</p><p>Once the application has begun, you can save the application at any time by clicking on the \"Save Now &amp; Finish Later\" button.</p></div><div class=\"panel panel-primary\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Review and Submit Application</h3></div><div class=\"panel-body\"><dl class=\"dl-horizontal\"><dt>Parent Name(s)</dt><dd>{{ vm.user.parent_first_name }} {{ vm.user.parent_middle_initial }} {{ vm.user.parent_last_name }}</dd><dt>Phone</dt><dd>{{ vm.user.parent_phone }}</dd><dt>Address</dt><dd>{{ vm.user.address }} {{ vm.user.address2 }}<br>{{ vm.user.city }} {{ vm.user.state.value }} {{ vm.user.zip }}</dd><dt>Student</dt><dd>{{ vm.students.fname }} {{ vm.students.mname }} {{ vm.students.lname }}</dd><dt>Application Year</dt><dd>{{ vm.schoolYearValue }}</dd><dt>School</dt><dd>{{ vm.school.school_name }}</dd><dt>Tuition Amount</dt><dd>{{ vm.tuition_amt | currency:\"$\":0 }}</dd><dt>Grade</dt><dd>{{ vm.grade.value }}</dd><dt>Narrative</dt><dd ng-bind-html=\"vm.narrative\"></dd><dt>Income</dt><dd><table class=\"table table-condensed\"><tbody><tr ng-repeat=\"income in vm.fincomes | orderBy:\'fname\'\"><td>{{ income.name }}</td><td>{{ income.work | currency:\"$\":0 }} {{ vm.periods[income.work_frequency] }}</td><td>{{ income.support | currency:\"$\":0 }} {{ vm.periods[income.support_frequency] }}</td><td>{{ income.retirement | currency:\"$\":0 }} {{ vm.periods[income.retirement_frequency] }}</td><td>{{ income.other | currency:\"$\":0 }} {{ vm.periods[income.other_frequency] }}</td></tr></tbody></table></dd><dt>Using ESA</dt><dd>{{ vm.using_esa ? \'Yes\' : \'No\' }}</dd><dt ng-show=\"vm.public_school_transfer || vm.kindergarten_student || vm.kindergarten_disabled || vm.us_armed_forces_dependent || vm.prev_scholarship_recipient\">Overflow Tax Credit</dt><dd ng-show=\"vm.public_school_transfer\">Public School Transfer</dd><dd ng-show=\"vm.kindergarten_student\">Kindergarten Student</dd><dd ng-show=\"vm.kindergarten_disabled\">Pre-K Students with Disabilities</dd><dd ng-show=\"vm.us_armed_forces_dependent\">US Armed Forces Dependent</dd><dd ng-show=\"vm.prev_scholarship_recipient\">Prev Scholarship Recipient</dd><dt ng-show=\"vm.prev_scholarship_recipient\">Organization Award</dt><dd ng-show=\"vm.prev_scholarship_recipient\">{{ vm.organization }}</dd><dt>Comment/Notes:</dt><dd>{{ vm.comment }}</dd><dt ng-hide=\"vm.uploadedFiles === \'\'\">Files</dt><dd ng-repeat=\"f in vm.uploadedFiles\">{{ f.original_filename }}</dd></dl></div></div><div class=\"alert alert-danger\" role=\"alert\"><div class=\"checkbox\"><label><input ng-model=\"vm.readyForSubmit\" ng-true-value=\"1\" value=\"1\" type=\"checkbox\">By submitting this application, I certify that all the information provided in this application is correct and true to the best of my knowledge.</label></div></div><div class=\"clearfix\"><div class=\"pull-left\"><a ui-sref=\"scholarship.taxcredit({ scholarshipId: vm.id })\" class=\"btn btn-link\"><i class=\"fa fa-chevron-left\"></i>Back</a> <button ng-click=\"vm.saveScholarship($event)\" ng-disabled=\"vm.save === \'Saving scholarship application...\'\" ng-bind-html=\"vm.save\" type=\"button\" class=\"btn btn-info\"></button></div><div class=\"pull-right\"><button ng-click=\"vm.submitScholarship($event)\" ng-disabled=\"vm.submit === \'Submitting scholarship application...\' || !vm.readyForSubmit\" ng-bind-html=\"vm.submit\" type=\"button\" class=\"btn btn-primary\">Submit</button></div></div><br><br></form></div></div></article>");
$templateCache.put("app/scholarship/edit/verify-income.html","<article class=\"container\"><div class=\"row\"><div class=\"page-header\"><h1>Scholarship <small>Apply</small></h1></div><div class=\"col-md-2\"><div ng-include=\"\'app/components/navbar/scholarship.navbar.html\'\"></div></div><div class=\"col-md-10\"><form name=\"scholarship\" class=\"form-horizontal scholarship\" role=\"form\" method=\"POST\" novalidate=\"\"><ol class=\"breadcrumb\"><li><a ui-sref=\"scholarship.edit({ scholarshipId: vm.id })\">Family Information</a></li><li><a ui-sref=\"scholarship.narrative({ scholarshipId: vm.id })\">Narrative</a></li><li class=\"active\">Financial Information</li><li>Overflow Tax Credit</li><li>Review</li></ol><div class=\"alert alert-info\" role=\"alert\"><p>When you begin a scholarship application, a copy will be saved automatically for you. You can return to the application from <a ui-sref=\"scholarship.dashboard\"><i class=\"fa fa-tachometer\"></i>Scholarships &amp; Applications Dashboard</a> in the \"Saved Applications (in progress)\" tab.</p><p>Once the application has begun, you can save the application at any time by clicking on the \"Save Now &amp; Finish Later\" button.</p></div><div class=\"panel panel-primary\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Financial Information</h3></div><div class=\"panel-body\"><div class=\"alert alert-info\" role=\"alert\"><p>Income information is a required part of the application process. If you do not report income, ACSTO cannot consider your child(ren) for scholarships. Processing delays will occur for applications with incomplete income information.</p><p>We determine financial circumstances based on the USDA\'s definition of household income. A household is a group of related or unrelated individuals who share housing, income, and expenses. You do not have to list those who are economically independent from you or their dependents, even if you share housing.</p><h3>INSTRUCTIONS:</h3><ol><li><p>Enter the total number of people living in your household. Include adults, children, students away at college, and individuals without income.</p></li><li><p>Enter the first and last name of each household member and report their annual income for each of the following categories. If the person has no income, select \"No income.\"</p><p><strong>Earnings from Work</strong> - List gross income from work (wages, salaries, tips, commissions). This is not the same as take-home pay. It is the amount earned before taxes and deductions. It should be listed on your pay stub. If self-employed, you may report income after expenses (your own business, freelance work, farm, or rental property).</p><p><strong>Welfare, Child Support, Spousal Maintenance</strong> - Include TANF, General Assistance, General Relief, etc. NOTE: Food stamps and FDPIR benefits are not included as income.</p><p><strong>Pensions, Retirement, Social Security</strong> - Include Supplemental Security Income (SSI), Veteran\'s (VA) benefits, and disability benefits.</p><p><strong>All Other Income</strong> - Include workers\' compensation, unemployment, strike benefits, net rental income, annuities, net royalties, interest, dividend income, cash withdrawn from savings, income from estates, trust and/or investments, regular contributions from people who do not live in your household, and any other income. If you are in the military, you do not have to include combat pay as income.</p></li></ol><p ng-if=\"vm.displayIncomeYearlyUpdate\"><small>As of February 2017, ACSTO processes all financial income on an annual basis. If you’re reapplying for the \'17-\'18 school year, as a courtesy to you, we\'ve converted your financial data from last year to reflect this change. Please confirm that your information is correct.</small></p></div><div class=\"form-group\" ng-class=\"{ \'has-error\': scholarship.number_of_household.$touched && scholarship.number_of_household.$invalid || scholarship.number_of_household.$invalid && vm.validateIncome }\"><br><label for=\"number_of_household\" class=\"control-label\">Number of People Living in Household:</label> <input ng-model=\"vm.number_of_household\" ng-readonly=\"vm.isFosterChild\" min=\"vm.isFosterChild ? 1 : 2\" name=\"number_of_household\" type=\"number\" class=\"form-control\" placeholder=\"Total # of household\" required=\"\"><div class=\"help-block text-error\" ng-messages=\"scholarship.number_of_household.$error\" ng-if=\"scholarship.number_of_household.$touched || scholarship.number_of_household.$invalid && vm.validateIncome\"><p ng-message=\"required\">Number of people living in household is required.</p><p ng-message=\"min\">The minimum number of people living in household is {{ vm.isFosterChild ? 1 : 2 }}.</p></div></div><button ng-hide=\"vm.isFosterChild\" ng-click=\"vm.addIncome($event)\" class=\"btn btn-info\">Add Household Member</button><p class=\"visible-xs-block alert alert-info\"><i class=\"fa fa-info-circle\"></i>Swipe left or right to see additional details.</p></div><div class=\"table-responsive\"><table ng-hide=\"vm.isFosterChild\" id=\"income\" class=\"table table-condensed\"><thead><tr><th><a href=\"#\" uib-tooltip=\"Family Name(s)\">Name</a></th><th><a href=\"#\" uib-tooltip=\"Earnings from Work\">Work</a></th><th><a href=\"#\" uib-tooltip=\"Welfare; Child Support; Spousal Maintenance\">Support</a></th><th><a href=\"#\" uib-tooltip=\"Pension; Retirement; Social Security\">Retirement</a></th><th><a href=\"#\" uib-tooltip=\"Other Income\">Other</a></th><th><a href=\"#\" uib-tooltip=\"Edit or Delete Income\">Edit/Delete</a></th></tr></thead><tbody><tr><div ng-show=\"incomeLoading\" class=\"text-center ng-scope ng-hide\" aria-hidden=\"true\"><i class=\"fa fa-refresh fa-spin fa-3x\"></i></div></tr><tr ng-repeat=\"income in vm.fincomes | orderBy:\'fname\'\"><td>{{ income.name }}</td><td>{{ income.work * income.work_frequency | currency:\"$\":0 }} Annually</td><td>{{ income.support * income.support_frequency | currency:\"$\":0 }} Annually</td><td>{{ income.retirement * income.retirement_frequency | currency:\"$\":0 }} Annually</td><td>{{ income.other * income.other_frequency | currency:\"$\":0 }} Annually</td><td><button type=\"button\" ng-click=\"vm.editTableRow(income, $event)\" popover-trigger=\"mouseenter\" class=\"btn btn-info btn-circle btn-xs\" popover-placement=\"top\" uib-popover=\"Edit Income\"><i class=\"fa fa-pencil\"></i></button> <button type=\"button\" ng-click=\"vm.deleteTableRow(income, $event)\" popover-trigger=\"mouseenter\" class=\"btn btn-danger btn-circle btn-xs\" popover-placement=\"top\" uib-popover=\"Delete Income\"><i class=\"fa fa-user-times\"></i></button></td></tr><tr ng-if=\"!vm.fincomes.length\" class=\"info text-center\"><td class=\"text-info\" colspan=\"6\">Please add Household Members with the button above.</td></tr></tbody></table><table ng-show=\"vm.isFosterChild\" class=\"table table-condensed\"><thead><tr><th><a href=\"#\" uib-tooltip=\"Family Name(s)\">Name</a></th><th><a href=\"#\" uib-tooltip=\"Other Income\">Foster Care Income</a></th><th><a href=\"#\" uib-tooltip=\"Edit or Delete Income\">Edit</a></th></tr></thead><tbody><tr><div ng-show=\"incomeLoading\" class=\"text-center ng-scope ng-hide\" aria-hidden=\"true\"><i class=\"fa fa-refresh fa-spin fa-3x\"></i></div></tr><tr ng-repeat=\"income in vm.fincomes | orderBy:\'fname\'\"><td>{{ income.name }}</td><td ng-show=\"!income.other && income.other !== 0\">$ ---</td><td ng-show=\"income.other == 0\">{{ income.other | currency:\"$\":0 }} {{ vm.periods[income.other_frequency] }}</td><td ng-show=\"income.other > 0\">{{ income.other | currency:\"$\":0 }} {{ vm.periods[income.other_frequency] }}</td><td><a ng-click=\"vm.editFosterChild(income, $event)\" class=\"btn btn-info btn-circle btn-xs\" href=\"#\" uib-tooltip=\"Edit Income\"><i class=\"fa fa-pencil\"></i></a></td></tr><tr ng-if=\"!vm.fincomes.length\" class=\"info text-center\"><td class=\"text-info\" colspan=\"6\">Please add Household Members with the button above.</td></tr></tbody></table></div></div><div class=\"clearfix\"><div class=\"pull-left\"><a ui-sref=\"scholarship.narrative({ scholarshipId: vm.id })\" class=\"btn btn-link\"><i class=\"fa fa-chevron-left\"></i>Back</a> <button ng-click=\"vm.saveScholarship($event)\" ng-disabled=\"vm.save === \'Saving scholarship application...\'\" ng-bind-html=\"vm.save\" type=\"button\" class=\"btn btn-info\"></button></div><div class=\"pull-right\"><a ng-click=\"vm.income($event)\" class=\"btn btn-primary\">Next: Overflow Tax Credit <i class=\"fa fa-chevron-right\"></i></a></div></div><br><br></form></div></div></article>");
$templateCache.put("app/scholarship/income/foster.child.income.html","<form name=\"income\" class=\"form-horizontal\" role=\"form\" method=\"POST\" novalidate=\"\"><div class=\"modal-header\"><h3 class=\"modal-title\">Add Household Member</h3></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12\" ng-class=\"{ \'has-error\' : income.income_name.$error.required && income.income_name.$dirty || income.income_name.$invalid && vm.validateIncome }\"><label for=\"income_name\" class=\"control-label\"><span class=\"text-danger\">*</span> Name</label> <input ng-model=\"vm.income_name\" class=\"form-control\" placeholder=\"First name\" maxlength=\"30\" name=\"income_name\" type=\"text\" required=\"\"><div class=\"help-block\" ng-messages=\"income.income_name.$error\" ng-if=\"income.income_name.$touched || income.income_name.$invalid && vm.validateIncome\"><p ng-message=\"required\">Name is required.</p></div></div></div><div class=\"row\"><div class=\"col-md-5\"><div class=\"checkbox\"><label><input ng-model=\"vm.noIncome\" type=\"checkbox\"> No income</label></div><div class=\"help-block\"><p>Check here if there is no income.</p></div></div></div><div class=\"row form-group\" ng-class=\"{ \'has-error\': (income.other_period.$invalid || income.other.$invalid) && vm.validateIncome}\"><div class=\"col-md-8\"><label for=\"other\">Foster Care Income</label> <input ng-model=\"vm.other\" type=\"text\" name=\"other\" class=\"form-control\" placeholder=\"e.g. 100\" pattern=\"\\d*\" ng-required=\"!vm.noIncome && !vm.other || !vm.noIncome && vm.other_period\"><div class=\"help-block\" ng-messages=\"income.other.$error\" ng-if=\"income.other.$invalid && vm.validateIncome\"><p ng-message=\"pattern\">Enter numbers only.</p><p ng-message=\"required\">At least one form of income is required OR check the box for no income.</p></div></div><div class=\"col-md-4\"><label for=\"other_period\">Pay Period</label><select ng-model=\"vm.other_period\" ng-options=\"period.value for period in vm.periods track by period.value\" class=\"form-control\" name=\"other_period\" ng-required=\"vm.other\"></select><div class=\"help-block\" ng-messages=\"income.other_period.$error\" ng-if=\"income.other_period.$invalid && vm.validateIncome\"><p ng-message=\"required\">This field is required.</p></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-default\" ng-click=\"vm.cancel()\">Cancel</button> <button ng-click=\"vm.saveIncomeInfo($event)\" ng-bind-html=\"vm.incomeBtn\" type=\"button\" class=\"btn btn-primary\"></button></div></form>");
$templateCache.put("app/scholarship/income/income.add.html","<form name=\"income\" class=\"form-horizontal\" role=\"form\" method=\"POST\" novalidate=\"\"><div class=\"modal-header\"><h3 class=\"modal-title\">Add Household Member</h3></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-8\" ng-class=\"{ \'has-error\' : income.income_name.$error.required && income.income_name.$dirty || income.income_name.$invalid && vm.validateIncome }\"><label for=\"income_name\" class=\"control-label\"><span class=\"text-danger\">*</span> Name</label> <input ng-model=\"vm.income_name\" class=\"form-control\" placeholder=\"Full Name\" maxlength=\"30\" name=\"income_name\" type=\"text\" required=\"\"><div class=\"help-block\" ng-messages=\"income.income_name.$error\" ng-if=\"income.income_name.$touched || income.income_name.$invalid && vm.validateIncome\"><p ng-message=\"required\">Name is required.</p></div></div></div><div class=\"row\"><div class=\"col-md-5\"><div class=\"checkbox\"><label><input ng-model=\"vm.noIncome\" ng-change=\"vm.resetEarnings()\" type=\"checkbox\"> No income</label></div><div class=\"help-block\"><p>Check here if there is no income.</p></div></div></div><div class=\"alert alert-warning\" role=\"alert\">Please do not include dollar signs, commas, decimals, or cents.</div><div class=\"row form-group\" ng-class=\"{ \'has-error\': income.work.$dirty && income.work.$invalid || income.work.$invalid && vm.validateIncome }\"><div class=\"col-md-8\"><label for=\"work\">Annual Earnings from Work</label> <input ng-model=\"vm.work\" type=\"text\" name=\"work\" class=\"form-control\" placeholder=\"e.g. 38000\" pattern=\"\\d*\" ng-disabled=\"vm.noIncome\" ng-required=\"!vm.noIncome && !vm.work && !vm.support && !vm.retirement && !vm.other\"><div class=\"help-block\" ng-messages=\"income.work.$error\" ng-if=\"income.work.$dirty && income.work.$invalid || income.work.$invalid && vm.validateIncome\"><p ng-message=\"pattern\">Enter numbers only.</p><p ng-message=\"required\">At least one form of income is required OR check the box for no income.</p></div></div></div><div class=\"row form-group\" ng-class=\"{ \'has-error\': income.support.$dirty && income.support.$invalid || income.support.$invalid && vm.validateIncome }\"><div class=\"col-md-8\"><label for=\"support\">Annual Welfare; Child Support; Spousal Maintenance</label> <input ng-model=\"vm.support\" type=\"text\" name=\"support\" class=\"form-control\" placeholder=\"e.g. 38000\" pattern=\"\\d*\" ng-disabled=\"vm.noIncome\" ng-required=\"!vm.noIncome && !vm.work && !vm.support && !vm.retirement && !vm.other\"><div class=\"help-block\" ng-messages=\"income.support.$error\" ng-if=\"income.support.$dirty && income.support.$invalid || income.support.$invalid && vm.validateIncome\"><p ng-message=\"pattern\">Enter numbers only.</p><p ng-message=\"required\">At least one form of income is required OR check the box for no income.</p></div></div></div><div class=\"row form-group\" ng-class=\"{ \'has-error\': income.retirement.$dirty && income.retirement.$invalid || income.retirement.$invalid && vm.validateIncome }\"><div class=\"col-md-8\"><label for=\"retirement\">Annual Pension; Retirement; Social Security</label> <input ng-model=\"vm.retirement\" type=\"text\" name=\"retirement\" class=\"form-control\" placeholder=\"e.g. 38000\" pattern=\"\\d*\" ng-disabled=\"vm.noIncome\" ng-required=\"!vm.noIncome && !vm.work && !vm.support && !vm.retirement && !vm.other\"><div class=\"help-block\" ng-messages=\"income.retirement.$error\" ng-if=\"income.retirement.$dirty && income.retirement.$invalid || income.retirement.$invalid && vm.validateIncome\"><p ng-message=\"pattern\">Enter numbers only.</p><p ng-message=\"required\">At least one form of income is required OR check the box for no income</p></div></div></div><div class=\"row form-group\" ng-class=\"{ \'has-error\': income.other.$dirty && income.other.$invalid || income.other.$invalid && vm.validateIncome }\"><div class=\"col-md-8\"><label for=\"other\">Other Annual Income</label> <input ng-model=\"vm.other\" type=\"text\" name=\"other\" class=\"form-control\" placeholder=\"e.g. 38000\" pattern=\"\\d*\" ng-disabled=\"vm.noIncome\" ng-required=\"!vm.noIncome && !vm.work && !vm.support && !vm.retirement && !vm.other\"><div class=\"help-block\" ng-messages=\"income.other.$error\" ng-if=\"income.other.$dirty && income.other.$invalid || income.other.$invalid && vm.validateIncome\"><p ng-message=\"pattern\">Enter numbers only.</p><p ng-message=\"required\">At least one form of income is required OR check the box for no income.</p></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-default\" ng-click=\"vm.cancel()\">Cancel</button> <button ng-click=\"vm.saveIncomeInfo($event)\" ng-bind-html=\"vm.incomeBtn\" type=\"button\" class=\"btn btn-primary\"></button></div></form>");}]);